// 国际化配置
const translations = {
  'zh-CN': {
    'environmental_requirements': '环保要求',
    'environmental_requirements_desc': '环境友好型防治方法、农药环境影响评估等环保信息',
    'all': '全部',
    'biological_control': '生物防治',
    'physical_control': '物理防治',
    'agricultural_control': '农业防治',
    'chemical_control_optimized': '化学防治',
    'friendly_methods': '友好防治',
    'environmental_impact': '环境影响',
    'regulatory_requirements': '法规要求',
    'specific_methods': '具体方法',
    'advantages': '优势',
    'env_filter_category_all': '全部',
    'env_filter_category_biological': '生物防治',
    'env_filter_category_physical': '物理防治',
    'env_filter_category_agricultural': '农业防治',
    'env_filter_category_chemical': '化学防治优化',
    'env_method_biological_title': '生物防治',
    'env_method_biological_desc': '利用天敌、微生物等生物制剂进行病虫害防治',
    'env_method_biological_step_1': '释放天敌昆虫（如赤眼蜂、草蛉等）',
    'env_method_biological_step_2': '使用微生物农药（如苏云金杆菌、白僵菌等）',
    'env_method_biological_step_3': '应用性信息素诱捕技术',
    'env_method_biological_step_4': '利用植物源农药',
    'env_method_biological_step_5': '推广生物多样性保护',
    'env_method_biological_adv_1': '对环境友好，无残留',
    'env_method_biological_adv_2': '不产生抗药性',
    'env_method_biological_adv_3': '长期有效',
    'env_method_biological_adv_4': '生态平衡',
    'env_method_physical_title': '物理防治',
    'env_method_physical_desc': '利用物理手段进行病虫害防治',
    'env_method_physical_step_1': '使用粘虫板、诱虫灯',
    'env_method_physical_step_2': '高温处理土壤',
    'env_method_physical_step_3': '覆盖防虫网',
    'env_method_physical_step_4': '人工捕杀害虫',
    'env_method_physical_step_5': '使用声波驱虫设备',
    'env_method_physical_adv_1': '无化学污染',
    'env_method_physical_adv_2': '操作简单',
    'env_method_physical_adv_3': '成本较低',
    'env_method_physical_adv_4': '安全可靠',
    'env_method_agricultural_title': '农业防治',
    'env_method_agricultural_desc': '通过农业技术措施预防病虫害',
    'env_method_agricultural_step_1': '轮作倒茬',
    'env_method_agricultural_step_2': '选用抗病品种',
    'env_method_agricultural_step_3': '合理密植',
    'env_method_agricultural_step_4': '科学施肥',
    'env_method_agricultural_step_5': '及时清除病残体',
    'env_method_agricultural_adv_1': '预防为主',
    'env_method_agricultural_adv_2': '成本低',
    'env_method_agricultural_adv_3': '效果持久',
    'env_method_agricultural_adv_4': '生态友好',
    'env_method_chemical_title': '化学防治优化',
    'env_method_chemical_desc': '优化化学农药使用，减少环境影响',
    'env_method_chemical_step_1': '选择低毒低残留农药',
    'env_method_chemical_step_2': '精准施药技术',
    'env_method_chemical_step_3': '轮换使用不同作用机制农药',
    'env_method_chemical_step_4': '减少用药次数和剂量',
    'env_method_chemical_step_5': '使用缓释剂型',
    'env_method_chemical_adv_1': '效果快速',
    'env_method_chemical_adv_2': '成本可控',
    'env_method_chemical_adv_3': '技术成熟',
    'env_method_chemical_adv_4': '环境影响小',
    'env_assessment_soil_title': '土壤环境影响',
    'env_assessment_soil_factor_1': '农药在土壤中的降解速度',
    'env_assessment_soil_factor_2': '对土壤微生物的影响',
    'env_assessment_soil_factor_3': '土壤残留量',
    'env_assessment_soil_factor_4': '对土壤肥力的影响',
    'env_assessment_soil_recommendation_1': '选择易降解农药',
    'env_assessment_soil_recommendation_2': '避免长期使用同一种农药',
    'env_assessment_soil_recommendation_3': '定期监测土壤质量',
    'env_assessment_soil_recommendation_4': '采用生物修复技术',
    'env_assessment_water_title': '水体环境影响',
    'env_assessment_water_factor_1': '农药随雨水流失',
    'env_assessment_water_factor_2': '地下水污染风险',
    'env_assessment_water_factor_3': '对水生生物的影响',
    'env_assessment_water_factor_4': '水体富营养化',
    'env_assessment_water_recommendation_1': '避免在雨季施药',
    'env_assessment_water_recommendation_2': '设置缓冲带',
    'env_assessment_water_recommendation_3': '使用缓释剂型',
    'env_assessment_water_recommendation_4': '定期监测水质',
    'env_assessment_air_title': '大气环境影响',
    'env_assessment_air_factor_1': '农药挥发损失',
    'env_assessment_air_factor_2': '对大气质量的影响',
    'env_assessment_air_factor_3': '飘散污染',
    'env_assessment_air_factor_4': '温室气体排放',
    'env_assessment_air_recommendation_1': '选择低挥发性农药',
    'env_assessment_air_recommendation_2': '避免大风天施药',
    'env_assessment_air_recommendation_3': '使用封闭式施药设备',
    'env_assessment_air_recommendation_4': '减少施药次数',
    'env_assessment_biodiversity_title': '生物多样性影响',
    'env_assessment_biodiversity_factor_1': '对非目标生物的影响',
    'env_assessment_biodiversity_factor_2': '天敌昆虫减少',
    'env_assessment_biodiversity_factor_3': '生物链破坏',
    'env_assessment_biodiversity_factor_4': '生态系统失衡',
    'env_assessment_biodiversity_recommendation_1': '使用选择性农药',
    'env_assessment_biodiversity_recommendation_2': '保护天敌昆虫',
    'env_assessment_biodiversity_recommendation_3': '建立生态廊道',
    'env_assessment_biodiversity_recommendation_4': '推广综合防治',
    'env_regulation_usage_title': '农药使用限制',
    'env_regulation_usage_item_1': '禁止使用高毒高残留农药',
    'env_regulation_usage_item_2': '限制在敏感区域使用农药',
    'env_regulation_usage_item_3': '遵守安全间隔期规定',
    'env_regulation_usage_item_4': '建立农药使用记录',
    'env_regulation_eia_title': '环境影响评价',
    'env_regulation_eia_item_1': '大型农业项目需进行环评',
    'env_regulation_eia_item_2': '评估农药使用环境影响',
    'env_regulation_eia_item_3': '制定环境保护措施',
    'env_regulation_eia_item_4': '定期监测环境质量',
    'env_regulation_waste_title': '废弃物处理',
    'env_regulation_waste_item_1': '农药包装物回收处理',
    'env_regulation_waste_item_2': '过期农药安全处置',
    'env_regulation_waste_item_3': '清洗废水处理',
    'env_regulation_waste_item_4': '建立废弃物台账',
    'env_regulation_ecology_title': '生态保护要求',
    'env_regulation_ecology_item_1': '保护农田生态系统',
    'env_regulation_ecology_item_2': '维护生物多样性',
    'env_regulation_ecology_item_3': '减少化学农药使用',
    'env_regulation_ecology_item_4': '推广绿色防控技术',
    'high_risk': '高风险',
    'medium_risk': '中风险',
    'low_risk': '低风险',
    'impact_factors': '影响因素',
    'recommended_measures': '建议措施',
    'must_comply': '必须遵守',
    'recommended_to_comply': '建议遵守',
    // Research Progress page i18n keys (labels already exist like key_findings/applications/research_impact)
    'biotech_breakthrough_content': '中国农业科学院植物保护研究所科研团队在生物农药研发方面取得重大突破...',
    'smart_monitoring_content': '某大学计算机学院与农学院联合研发的智能植保监测系统取得重要进展...',
    'slow_release_content': '某研究所农药研发团队在缓释制剂技术方面取得重要突破...',
    'uav_precision_content': '某科技公司在植保无人机精准施药方面取得重要进展...',

    'tag_bio_pesticide': '生物农药',
    'tag_rice_blast': '稻瘟病',
    'tag_green_control': '绿色防控',
    'tag_major_breakthrough': '重大突破',
    'tag_ai_tech': 'AI技术',
    'tag_smart_monitoring': '智能监测',
    'tag_auto_identification': '自动识别',
    'tag_early_warning': '预警系统',
    'tag_slow_release': '缓释制剂',
    'tag_pesticide_tech': '农药技术',
    'tag_longer_efficacy': '药效延长',
    'tag_less_dose_more_effect': '减药增效',
    'tag_uav': '无人机',
    'tag_precision_application': '精准施药',
    'tag_intelligent_control': '智能控制',
    'tag_work_efficiency': '作业效率',

    // Research 1 details
    'rp1_kf_1': '发现新型拮抗菌株',
    'rp1_kf_2': '开发高效发酵工艺',
    'rp1_kf_3': '建立质量控制标准',
    'rp1_kf_4': '完成田间试验验证',
    'rp1_app_1': '水稻稻瘟病防治',
    'rp1_app_2': '减少化学农药使用',
    'rp1_app_3': '提高农产品安全性',
    'rp1_app_4': '保护生态环境',
    'rp1_impact': '该成果将显著推动生物农药产业发展，为绿色农业提供技术支撑',

    // Research 2 details
    'rp2_kf_1': '开发图像识别算法',
    'rp2_kf_2': '建立病虫害数据库',
    'rp2_kf_3': '实现实时监测预警',
    'rp2_kf_4': '集成多源数据融合',
    'rp2_app_1': '田间病虫害监测',
    'rp2_app_2': '智能预警系统',
    'rp2_app_3': '精准防治指导',
    'rp2_app_4': '数据统计分析',
    'rp2_impact': '将显著提升病虫害监测效率和准确性，为精准植保提供技术支撑',

    // Research 3 details
    'rp3_kf_1': '开发缓释载体材料',
    'rp3_kf_2': '优化制剂配方',
    'rp3_kf_3': '建立释放控制机制',
    'rp3_kf_4': '完成药效评价',
    'rp3_app_1': '多种作物病虫害防治',
    'rp3_app_2': '减少用药次数',
    'rp3_app_3': '提高防治效果',
    'rp3_app_4': '降低环境影响',
    'rp3_impact': '将显著提高农药利用效率，减少环境污染，推动农药产业升级',

    // Research 4 details
    'rp4_kf_1': '开发精准定位技术',
    'rp4_kf_2': '优化施药参数',
    'rp4_kf_3': '建立智能控制系统',
    'rp4_kf_4': '提高作业精度',
    'rp4_app_1': '大田作物植保',
    'rp4_app_2': '果园病虫害防治',
    'rp4_app_3': '精准施药作业',
    'rp4_app_4': '提高作业效率',
    'rp4_impact': '将显著提升植保作业效率和精度，推动植保机械化发展',
    // Calendar
    'prev_month': '上个月',
    'next_month': '下个月',
    'switch_to_light': '切换为浅色模式',
    'switch_to_dark': '切换为深色模式',
    'reminders': '提醒事项',
    'add_reminder': '添加提醒',
    'loading_reminders': '正在加载提醒...',
    'no_reminders': '暂无提醒事项',
    'add_reminder_hint': '点击"添加提醒"按钮来创建新的提醒',
    'gregorian': '公历',
    'lunar': '农历',
    'hou': '候',
    'solar_term': '节气',
    'weather': '天气',
    'farming_activities': '植保作业',
    'no_farming_activities_today': '今日无植保作业',
    'type': '类型',
    'crop': '作物',
    'importance': '重要程度',
    'enter_reminder_title': '请输入提醒标题',
    'enter_reminder_content_optional': '请输入提醒内容（可选）',
    'reminder_add_success': '提醒添加成功',
    'reminder_add_failed_retry': '添加提醒失败，请稍后重试',
    'reminder_delete_success': '提醒删除成功',
    'reminder_delete_failed_retry': '删除提醒失败，请稍后重试',
    'success': '成功',
    // Knowledge 页面新增
    'cover_preview': '封面预览',
    'or_enter_image_url': '或直接输入图片URL',
    'article_detail': '文章详情',
    'views': '浏览量',
    'post_comment': '发表评论',
    'no_comments_encourage': '暂无评论，快来发表第一条评论吧！',
    // 通用
    'nav_home': '首页',
    'nav_page': '页面{number}',
    'loading': '加载中...',
    'user': '用户',
    'logout': '退出登录',
    'profile': '个人中心',
    'accountSettings': '账户设置',
    'notifications': '通知中心',
    'darkMode': '深色模式',
    'lightMode': '浅色模式',
    'save': '保存',
    'cancel': '取消',
    'delete': '删除',
    'edit': '编辑',
    'add': '添加',
    'search': '搜索',
    'export': '导出',
    'import': '导入',
    'refresh': '刷新',
    'back': '返回',
    'next': '下一步',
    'previous': '上一步',
    'confirm': '确认',
    'close': '关闭',
    'submit': '提交',
    'reset': '重置',
    'filter': '筛选',
    'sort': '排序',
    'view': '查看',
    'download': '下载',
    'upload': '上传',
    'select_all': '全选',
    'deselect_all': '取消全选',
    'selected_count': '已选',
    'no_data': '暂无数据',
    'save_success': '保存成功',
    'delete_success': '删除成功',
    'add_success': '添加成功',
    'update_success': '更新成功',
    'operation_failed': '操作失败',
    'batch_assign_success': '批量分配成功',
    'batch_delete_success': '批量删除成功',
    'import_success': '导入成功',
    'export_success': '导出成功',

    // 系统名称
    'systemName': '曲水稻香',

    // 通知
    'systemNotification': '系统通知',
    'welcomeMessage': '欢迎使用曲水稻香',
    'diseaseWarning': '病害预警',
    'diseaseRisk': '检测到可能的病害风险',
    'taskCompleted': '任务完成',
    'fieldTaskCompleted': '植保作业任务已完成',
    'noNotifications': '暂无通知',

    // 时间
    'justNow': '刚刚',
    'minutesAgo': '分钟前',
    'hoursAgo': '小时前',
    'daysAgo': '天前',

    // 登录页面
    'login_subtitle': '植物保护管理系统',
    'login_session_expired': '登录已超时或失效，请重新登录',
    'login_password_tab': '密码登录',
    'login_sms_tab': '短信登录',
    'login_qrcode_tab': '扫码登录',
    'login_username_label': '用户名',
    'login_username_placeholder': '请输入用户名',
    'login_password_label': '密码',
    'login_password_placeholder': '请输入密码',
    'login_remember_me': '记住我',
    'login_submit': '登录系统',
    'login_submitting': '登录中...',
    'login_phone_label': '手机号',
    'login_phone_placeholder': '请输入手机号',
    'login_code_label': '验证码',
    'login_code_placeholder': '请输入验证码',
    'login_send_code': '发送验证码',
    'login_sending_code': '发送中...',
    'login_generating_qrcode': '生成二维码中...',
    'login_qrcode_expired': '二维码已过期',
    'login_regenerate': '重新生成',
    'login_qrcode_scanning': '扫码成功，正在登录...',
    'login_qrcode_success': '登录成功！',
    'login_qrcode_instruction': '请使用曲水稻香APP扫码登录',
    'login_qrcode_validity': '二维码5分钟内有效',
    'login_open_app': '打开曲水稻香APP',
    'login_open_scanner': '点击"扫一扫"功能',
    'login_scan_tip': '扫描上方二维码即可登录',
    'login_refresh_qrcode': '刷新二维码',
    'login_refreshing_qrcode': '生成中...',
    'login_wechat': '微信登录',
    'login_alipay': '支付宝登录',
    'login_register': '注册',
    'login_forgot_password': '忘记密码？',
    'login_alert_title': '提示',
    'login_switch_to_en': '切换到英文',
    'login_switch_to_zh': 'Switch to Chinese',
    'login_bind_title': '绑定账号',
    'login_bind_subtitle_wechat': '检测到您首次使用微信登录',
    'login_bind_subtitle_alipay': '检测到您首次使用支付宝登录',
    'login_bind_wechat_user': '微信用户',
    'login_bind_alipay_user': '支付宝用户',
    'login_create_and_bind': '创建新账号并绑定',
    'login_bind_existing': '绑定现有账号',
    'login_or': '或',
    'login_error_required_credentials': '用户名和密码为必填',
    'login_error_login_failed': '登录失败',
    'login_error_enter_phone': '请输入手机号',
    'login_error_wechat_failed': '微信登录失败',
    'login_error_qrcode_expired': '二维码已过期，请重新获取',
    'login_error_alipay_failed': '支付宝登录失败',
    'login_error_timeout': '登录超时，请重新扫码',
    'login_error_bind_failed': '绑定失败',
    'login_error_create_failed': '创建账号失败',
    'login_sms_send_success_title': '发送成功',
    'login_sms_send_success_message': '验证码已发送到您的手机，请注意查收',
    'login_sms_send_failed_title': '错误',
    'login_sms_send_failed_message': '发送失败',
    'login_wechat_modal_title': '微信扫码登录',
    'login_wechat_modal_generating': '正在生成二维码...',
    'login_wechat_modal_instruction': '请使用微信扫描二维码登录',
    'login_simulate_scan': '模拟扫码',
    'login_cancel': '取消',
    'login_wechat_modal_failed': '二维码生成失败',
    'login_wechat_modal_retry': '请重试',
    'login_wechat_qr_alt': '微信登录二维码',
    'login_alipay_modal_title': '支付宝扫码登录',
    'login_alipay_modal_instruction': '请使用支付宝扫描二维码登录',
    'login_alipay_qr_alt': '支付宝登录二维码',
    'login_alipay_modal_failed': '二维码生成失败',

    // 注册页面
    'register_title': '账号注册',
    'register_subtitle': '注册后进入待绑定状态，登录后可申请加入目标租户或联系管理员审批。',
    'register_submitting': '注册中...',
    'register_tenant_label': '租户',
    'register_tenant_placeholder': '请选择租户',
    'register_loading_tenants': '加载租户中...',
    'register_username_placeholder': '请输入用户名',
    'register_password_placeholder': '请输入密码',
    'register_button': '注册',
    'register_to_login': '返回登录',
    'register_error_required': '用户名和密码不能为空',
    'register_error_password_length': '密码长度不能少于6位',
    'register_error_fetch_tenants': '获取租户列表失败，请刷新页面重试',
    'register_error_failed': '注册失败',
    'register_success': '注册成功，请登录',

    // 租户选择器
    'tenant_selector_all': '全部租户',
    'tenant_selector_placeholder': '选择租户',
    'platform_view_tenant_label': '查看租户',
    'platform_view_tenant_current': '当前',
    'tenant_type_province': '省级',
    'tenant_type_city': '市级',
    'tenant_type_county': '县级',
    'tenant_type_township': '乡镇级',

    // 页面加载器
    'page_loader_loading': '页面加载中...',
    'page_loader_check_status': '检查页面状态...',
    'page_loader_refresh_detected': '检测到页面刷新，正在恢复状态...',
    'page_loader_check_permissions': '检查页面权限...',
    'page_loader_redirect_login': '重定向到登录页面...',
    'page_loader_ready': '页面准备就绪',
    'page_loader_processing': '请稍候，系统正在处理您的请求...',
    'page_loader_error_title': '页面加载失败',
    'page_loader_reload': '重新加载',
    'page_loader_back_home': '返回首页',
    'page_loader_default_error': '页面初始化失败，请稍后重试',

    // 重置密码页面
    'reset_password_title': '重置密码',
    'reset_password_step1_title': '重置密码',
    'reset_password_step2_title': '输入验证码',
    'reset_password_step_info': '当前步骤: {step}, 邮箱: {email}',
    'reset_password_email_not_provided': '未填写',
    'reset_password_email_label': '邮箱地址',
    'reset_password_email_placeholder': '请输入您的邮箱地址',
    'reset_password_send_button': '发送验证码',
    'reset_password_sending': '发送中...',
    'reset_password_back_to_login': '返回登录',
    'reset_password_error_enter_email': '请输入邮箱地址',
    'reset_password_error_invalid_email': '请输入有效的邮箱地址',
    'reset_password_code_sent': '验证码已发送到您的邮箱，请查收',
    'reset_password_error_send_failed': '发送验证码失败',
    'reset_password_error_email_unregistered': '该邮箱未注册，请先注册账号或使用已注册的邮箱',
    'reset_password_error_too_frequent': '验证码发送过于频繁，请稍后再试',
    'reset_password_error_required_fields': '请填写所有字段',
    'reset_password_error_password_length': '密码长度至少6位',
    'reset_password_error_password_mismatch': '两次输入的密码不一致',
    'reset_password_success': '密码重置成功！正在跳转到登录页面...',
    'reset_password_error_reset_failed': '密码重置失败',
    'reset_password_code_label': '验证码',
    'reset_password_code_placeholder': '请输入6位验证码',
    'reset_password_resend': '重发',
    'reset_password_resend_countdown': '{seconds}s',
    'reset_password_new_password_label': '新密码',
    'reset_password_new_password_placeholder': '请输入新密码（至少6位）',
    'reset_password_confirm_password_label': '确认密码',
    'reset_password_confirm_password_placeholder': '请再次输入新密码',
    'reset_password_reset_button': '重置密码',
    'reset_password_resetting': '重置中...',
    'reset_password_back_step': '返回上一步',

    // 病虫害预警筛选
    'ppn_filter_region_label': '地区筛选',
    'ppn_filter_crop_label': '作物筛选',
    'ppn_filter_level_label': '风险等级',
    'ppn_filter_active_summary': '当前筛选条件：',
    'ppn_filter_clear': '清除筛选',
    'ppn_no_warnings': '暂无相关预警信息',
    'ppn_card_affected_area': '影响面积',
    'ppn_card_risk_factors': '风险因素',
    'ppn_card_prevention': '防治措施',
    'ppn_admin_mode_notice': '🔓 管理员模式：您拥有所有功能的访问权限',

    // 病虫害预警信息
    'ppn_warning_rice_south_title': '稻瘟病在华南地区呈高发态势',
    'ppn_warning_rice_south_desc': '受连续阴雨天气影响，稻瘟病在华南地区呈高发态势，建议及时采取防治措施',
    'ppn_warning_rice_south_area': '约50万亩',
    'ppn_warning_rice_south_measure_1': '及时排水，降低田间湿度',
    'ppn_warning_rice_south_measure_2': '喷施三环唑等杀菌剂',
    'ppn_warning_rice_south_measure_3': '增施钾肥，提高抗病性',
    'ppn_warning_rice_south_measure_4': '及时清除病株病叶',
    'ppn_warning_rice_south_factor_1': '连续阴雨',
    'ppn_warning_rice_south_factor_2': '田间湿度大',
    'ppn_warning_rice_south_factor_3': '品种抗性差',
    'ppn_warning_wheat_north_title': '小麦条锈病在华北地区扩散',
    'ppn_warning_wheat_north_desc': '小麦条锈病在华北地区开始扩散，需要密切关注发展态势',
    'ppn_warning_wheat_north_area': '约30万亩',
    'ppn_warning_wheat_north_measure_1': '加强田间监测',
    'ppn_warning_wheat_north_measure_2': '喷施戊唑醇等杀菌剂',
    'ppn_warning_wheat_north_measure_3': '合理密植，改善通风条件',
    'ppn_warning_wheat_north_measure_4': '及时清除病残体',
    'ppn_warning_wheat_north_factor_1': '温度适宜',
    'ppn_warning_wheat_north_factor_2': '品种感病',
    'ppn_warning_wheat_north_factor_3': '田间管理不当',

    'ppn_warning_corn_northeast_title': '玉米螟在东北地区发生',
    'ppn_warning_corn_northeast_desc': '玉米螟在东北地区开始发生，需要加强监测和防治',
    'ppn_warning_corn_northeast_area': '约20万亩',
    'ppn_warning_corn_northeast_measure_1': '释放赤眼蜂进行生物防治',
    'ppn_warning_corn_northeast_measure_2': '喷施苏云金杆菌制剂',
    'ppn_warning_corn_northeast_measure_3': '及时清除玉米秸秆',
    'ppn_warning_corn_northeast_measure_4': '轮作倒茬',
    'ppn_warning_corn_northeast_factor_1': '温度回升',
    'ppn_warning_corn_northeast_factor_2': '虫源基数大',
    'ppn_warning_corn_northeast_factor_3': '防治不及时',

    // 模块名称
    'diseaseDiagnosis': '病害诊断',
    'weatherAgronomy': '农情气象',
    'myPlantProtection': '生产管理',
    'knowledge': '知识库',
    'plantProtectionMall': '农资商城',
    'networkData': '网络数据',
    'systemManagement': '系统管理',

    // 个人中心
    'my_orders': '我的订单',
    'my_interactions': '我的互动',
    'my_interactions_desc': '统一管理评论、点赞、收藏与分享记录',
    'search_interactions_placeholder': '搜索互动记录…',
    'share_channel': '分享渠道',
    'type_news': '资讯',
    'type_experience': '经验',
    'my_shares': '我的分享',
    'my_favorites': '我的收藏',
    'my_likes': '我的点赞',
    'my_comments': '我的评论',
    'my_comments_desc': '查看您已发布的评论记录，点击可跳转原文',
    'view_original': '查看原文',
    'address_management': '收货地址',
    'profile_center': '个人中心',
    'profile_subtitle': '管理您的个人信息和账户设置',
    'my_account': '我的账户',
    'basic_info': '基本信息',
    'username': '用户名',
    'real_name': '真实姓名',
    'phone': '手机号',
    'email': '邮箱',
    'register_time': '注册时间',
    'last_login': '最后登录',
    'not_member_yet': '您还不是会员',
    'upgrade_member_desc': '升级会员享受更多专属服务',
    'upgrade_now': '立即升级会员',
    'member': '会员',
    'expire_date': '到期时间',
    'current_member': '当前会员',
    'remaining_days': '剩余天数',
    'days': '天',
    'member_level': '会员等级',
    'level': '级',
    'points_balance': '积分余额',
    'points': '分',
    'renew_membership': '续费会员',
    'member_benefits': '会员权益',
    'exclusive_features': '专属功能',
    'exclusive_features_desc': 'AI诊断、数据分析等高级功能',
    'points_reward': '积分奖励',
    'points_reward_desc': '消费获得积分，可兑换商品',
    'priority_service': '优先服务',
    'priority_service_desc': '客服优先响应，技术支持',
    'exclusive_discount': '专属优惠',
    'exclusive_discount_desc': '会员专享价格和促销活动',
    'account_statistics': '账户统计',
    'login_count': '登录次数',
    'usage_days': '使用天数',
    'operation_count': '操作次数',
    'favorite_count': '收藏数量',
    'account_settings_tab': '账户设置',
    'modify_profile': '修改个人信息',
    'security_settings': '安全设置',
    'reset_password': '修改密码',
    'login_security': '登录安全',
    'purchase_membership': '购买会员',
    'select_membership_plan': '选择适合您的会员套餐，享受更多专属服务',
    'validity_period': '有效期',
    'load_user_info_failed': '加载用户信息失败',
    'select_membership_type': '请选择会员类型',
    'purchase_success': '购买成功！',
    'purchase_failed': '购买失败，请重试',
    'times': '次',

    // 订单相关
    'order_status_pending': '待付款',
    'order_status_paid': '已付款',
    'order_status_shipped': '已发货',
    'order_status_delivered': '已送达',
    'order_status_cancelled': '已取消',
    'order_status_failed': '支付失败',
    'order_status_refund_pending': '退款中',
    'order_status_refunding': '退款中',
    'order_status_refunded': '已退款',
    'order_status_refund_failed': '退款失败',
    'order_number': '订单号',
    'order_status': '订单状态',
    'order_time': '下单时间',
    'payment_time': '支付时间',
    'order_details': '订单详情',
    'order_items': '订单商品',
    'go_shopping': '去购物',
    'go_pay': '去支付',
    'cancel_order': '取消订单',
    'apply_refund': '申请退款',
    'no_orders': '暂无订单',
    'no_orders_desc': '您还没有任何订单记录',
    'search_order_placeholder': '搜索订单号或商品名称...',
    'all_status': '全部状态',
    'quantity': '数量',
    'unit_price': '单价',
    'product_total': '商品总额',
    'shipping_fee': '运费',
    'discount': '优惠',
    'actual_payment': '实付金额',
    'receiver_info': '收货信息',
    'receiver_name': '收货人',
    'receiver_phone': '联系电话',
    'receiver_address': '收货地址',
    'product_info': '商品信息',
    'amount_info': '金额信息',
    'not_paid': '未支付',
    'unknown_product': '未知商品',
    'product_image': '商品图片',
    'confirm_refund': '确定要申请退款吗？',
    'confirm_cancel_order': '确定要取消这个订单吗？取消后将无法恢复。',
    'refund_submitted': '退款申请已提交',
    'refund_failed': '退款失败，请稍后重试',
    'order_cancelled': '订单已成功取消',
    'cancel_order_failed': '取消订单失败，请稍后重试',
    'cannot_load_order_details': '无法加载订单详情',
    'user_not_logged_in': '用户未登录，无法获取订单数据',

    // 收藏相关
    'search_favorites_placeholder': '搜索收藏内容...',
    'clear_search': '清除搜索内容',
    'no_favorites': '暂无收藏',
    'no_favorites_desc': '您还没有收藏任何内容',
    'type': '类型',
    'author': '作者',
    'collect_date': '收藏时间',
    'type_article': '文章',
    'type_product': '商品',
    'type_video': '视频',
    'confirm_remove_favorite': '确定要取消收藏吗？',
    // 点赞相关
    'search_likes_placeholder': '搜索点赞内容...',
    'no_likes': '暂无点赞',
    'no_likes_desc': '您还没有点赞任何内容',
    'like_date': '点赞时间',
    'confirm_remove_like': '确定要取消点赞吗？',

    // 评论相关
    'search_comments_placeholder': '搜索评论内容...',
    'no_comments': '暂无评论',
    'no_comments_desc': '您还没有发布任何评论',
    'comment_target': '评论对象',
    'comment_date': '评论时间',
    'edit_comment': '编辑',
    'save_comment': '保存',
    'cancel_edit': '取消',
    'confirm_delete': '确认删除',
    'confirm_delete_comment': '确定要删除这条评论吗？',
    'comment_empty': '评论内容不能为空！',
    'comment_updated': '评论修改成功！',
    'comment_placeholder': '请输入评论内容...',
    'replies': '回复',

    // 分享相关
    'search_shares_placeholder': '搜索分享标题或内容...',
    'all_categories': '全部分类',
    'category_experience': '种植经验',
    'category_technology': '技术分享',
    'category_news': '行业资讯',
    'category_question': '问题求助',
    'no_shares': '暂无分享',
    'no_shares_desc': '您还没有发布任何分享内容',
    'share_title': '标题',
    'share_content': '内容',
    'share_category': '分类',
    'publish_date': '发布时间',
    'views': '浏览',
    'shares': '分享',
    'confirm_delete_share': '确定要删除这篇分享吗？',
    'share_link_copied': '分享链接已复制到剪贴板！',
    'copy_share_link': '请复制以下分享链接：',

    // 会员历史相关
    'membership_purchase_history': '会员购买记录',
    'membership_purchase_desc': '查看您的所有会员购买和续费记录',
    'total_records': '共 {count} 条记录',
    'membership_type': '会员类型',
    'purchase_time': '购买时间',
    'validity_period': '有效期',
    'amount': '金额',
    'status': '状态',
    'action': '操作',
    'view_details': '查看详情',
    'status_active': '有效',
    'status_expired': '已过期',
    'status_cancelled': '已取消',
    'no_purchase_records': '暂无购买记录',
    'no_purchase_records_desc': '您还没有购买过会员服务',
    'purchase_details': '购买详情',
    'close': '关闭',
    'start_time': '开始时间',
    'expiry_time': '到期时间',
    'payment_amount': '支付金额',
    'membership_status': '会员状态',
    'contact_phone': '联系电话',
    'remark': '备注',
    'payment_method': '支付方式',
    'unknown': '未知',
    'pagination_total': '第 {start}-{end} 条，共 {total} 条记录',

    // 用户反馈相关
    'function_feedback': '功能反馈',
    'feedback_type': '反馈类型',
    'problem_title': '问题标题',
    'problem_description': '问题描述',
    'error_details': '错误详情（可选）',
    'severity': '问题严重程度',
    'submit_feedback': '提交反馈',
    'my_feedback_history': '我的反馈历史',
    'feedback_details': '反馈详情',
    'admin_reply': '管理员回复',
    'processing_time': '处理时间',
    'select_feedback_type': '请选择反馈类型',
    'enter_problem_title': '请输入问题标题',
    'enter_problem_description': '请详细描述问题',
    'select_severity': '请选择严重程度',
    'feedback_submitted': '反馈提交成功！我们会尽快处理您的问题。',
    'feedback_submit_failed': '提交失败',
    'load_feedback_types_failed': '加载反馈类型失败',
    'load_feedback_history_failed': '加载反馈历史失败',
    'status_pending': '待处理',
    'status_in_progress': '处理中',
    'status_resolved': '已解决',
    'status_rejected': '已拒绝',
    'problem_title_placeholder': '请简要描述问题',
    'problem_description_placeholder': '请详细描述您遇到的问题，包括操作步骤、期望结果和实际结果等...',
    'error_details_placeholder': '如果有错误信息、错误代码或截图描述，请在此处提供...',
    'feedback_guide_severity': '严重程度：',
    'feedback_guide_severity_desc': '根据问题影响范围选择合适级别',
    'feedback_process_title': '反馈处理流程：',
    'feedback_process_step1': '提交反馈后，系统会自动记录并分配给相关技术人员',
    'feedback_process_step2': '技术人员会分析问题并给出解决方案',
    'feedback_process_step3': '您可以在反馈历史中查看处理进度和结果',
    'feedback_process_step4': '如有疑问，可以联系客服或技术支持',
    'none': '无',

    // 账户设置 - 会员中心相关
    'welcome_to_membership': '欢迎来到会员中心',
    'not_member_intro': '您当前是免费会员，升级会员享受更多专属服务',
    'upgrade_membership': '立即升级会员',
    'view_all_membership_types': '点击查看所有会员类型和权益',
    'membership_active': '有效',
    'membership_expired': '已过期',
    'expiry_date': '到期时间',
    'expired_date': '过期时间',
    'days_remaining': '还剩 {days} 天',
    'view_purchase_history': '查看购买记录',
    'renew': '续费',
    'per_year': '/年',
    'select_payment_method': '请选择支付方式',
    'agree_to_terms': '请先同意会员购买协议',
    'processing': '处理中...',
    'confirm_purchase': '确认购买',
    'select_this_membership': '选择此会员',
    'membership_agreement': '会员购买协议',
    'agreement_intro': '尊敬的用户，欢迎您购买我们的会员服务。在您购买会员之前，请仔细阅读以下协议：',
    'i_agree': '我已阅读并同意',
    'i_have_read': '我已阅读并同意上述会员购买协议',
    'membership_benefits_title': '会员权益：',
    'benefit_customer_service': '专属客服支持',
    'benefit_priority_guidance': '优先技术指导',
    'benefit_advanced_features': '高级功能访问',
    'benefit_exclusive_offers': '专属优惠活动',
    'benefit_expert_consultation': '一对一专家咨询',
    'benefit_custom_service': '定制化服务',
    'permanent': '永久',
    'months': '个月',
    'province_city_district': '省市区',
    'province': '省份',
    'city': '城市',
    'district': '区县',
    'location': '定位',
    'auto_get_location': '自动获取当前位置',
    'full_address': '完整地址：',
    'detail_address': '详细地址',
    'detail_address_placeholder': '请输入详细地址',
    'postal_code': '邮政编码',
    'postal_code_placeholder': '请输入邮政编码',
    'geolocation_not_supported': '您的浏览器不支持地理定位功能',
    'getting_location': '正在获取位置信息...',
    'location_success': '地址信息获取成功！',
    'location_failed': '获取地址信息失败，请手动输入',
    'location_permission_denied': '用户拒绝了地理定位请求',
    'location_unavailable': '位置信息不可用',
    'location_timeout': '获取位置信息超时',
    'location_unknown_error': '获取位置信息时发生未知错误',
    'user_info_not_exist': '用户信息不存在，无法保存',
    'save_failed': '保存失败：',
    'purchase_membership_title': '购买会员',
    'validity': '有效期',
    'description': '描述',
    'purchase_agreement_confirm': '我已阅读并同意会员购买协议',
    'select_membership_type_title': '选择会员类型',

    // 植保问询 / AI智能服务
    'plant_protection_inquiry': 'AI智能服务',
    'new_conversation': '新对话',
    'close_conversation': '关闭对话',
    'simulation_mode': '模拟模式',
    'real_api': '真实API',
    'ai_assistant': 'AI助手',
    'welcome_inquiry': '您好！我是AI智能服务助手，请描述您遇到的问题，或上传图片获取防治建议。',
    'ask_question_placeholder': '询问植保问题...',
    'welcome_service': '欢迎使用AI智能服务',
    'preparing_assistant': '描述症状或上传图片，获取防治建议',
    'thinking': '正在思考中...',
    'me': '我',
    'please_login_first': '请先登录',
    'start_conversation_failed': '启动对话失败',
    'start_conversation_retry': '启动对话失败，请稍后重试',
    'recording': '正在录音...',
    'voice_input': '语音录入',
    'clear_input': '清空输入',
    'send_message': '发送消息',
    'input_tip': '提示：按Enter发送，支持图片和附件上传，支持语音录入',
    'inquiry_record': 'AI智能服务记录',
    'inquiry_hist_panel_title': '历史记录',
    'inquiry_hist_filter_category': '分类',
    'inquiry_hist_search_placeholder': '搜索问题内容…',
    'inquiry_hist_default_category': '新问答默认分类',
    'inquiry_hist_no_match': '没有符合筛选的记录',
    'inquiry_hist_cat_uncategorized': '未分类',
    'inquiry_hist_cat_pest_disease': '病虫害',
    'inquiry_hist_cat_fertilizer': '施肥营养',
    'inquiry_hist_cat_watering': '灌溉水分',
    'inquiry_hist_cat_soil': '土壤管理',
    'inquiry_hist_cat_growth': '生长发育',
    'inquiry_hist_cat_pesticide': '农药使用',
    'inquiry_hist_cat_other': '其他',
    // 快速回复
    'quick_reply_yellow_leaves': '我的植物叶片发黄了',
    'quick_reply_pest': '有虫害问题需要处理',
    'quick_reply_slow_growth': '植物生长缓慢',
    'quick_reply_fertilizer': '需要施肥建议',
    'quick_reply_watering': '浇水频率问题',
    'quick_reply_soil': '土壤改良建议',
    'quick_reply_disease': '如何防治病害',
    'quick_reply_light': '光照不足怎么办',

    // 账户设置
    'account_settings': '账户设置',
    'basic_info': '基本信息',
    'account': '账户',
    'real_name': '真实姓名',
    'email': '邮箱',
    'phone': '手机号',
    'avatar': '头像',
    'save_basic_info': '保存基本信息',
    'saving': '保存中...',
    'basic_info_save_success': '基本信息保存成功！',
    'change_password': '修改密码',
    'current_password': '当前密码',
    'new_password': '新密码',
    'confirm_new_password': '确认新密码',
    'password_mismatch': '新密码与确认密码不匹配',
    'password_too_short': '新密码长度至少6位',
    'changing': '修改中...',
    'password_change_success': '密码修改成功！',
    'privacy_settings': '隐私设置',
    'show_email_address': '显示邮箱地址',
    'show_email_desc': '允许其他用户查看您的邮箱地址',
    'show_phone_number': '显示手机号',
    'show_phone_desc': '允许其他用户查看您的手机号',
    'receive_notifications': '接收通知',
    'receive_notifications_desc': '接收系统通知和消息提醒',
    'marketing_info': '营销信息',
    'marketing_info_desc': '接收产品推广和营销信息',
    'save_privacy_settings': '保存隐私设置',
    'privacy_settings_save_success': '隐私设置保存成功！',

    // 登录注册
    'login': '登录',
    'register': '注册',
    'username': '用户名',
    'password': '密码',
    'tenant': '租户ID',

    // 用户管理
    'user_management': '用户管理',
    'user_role_assign': '用户分配角色',
    'select_user': '选择用户',
    'or_batch_assign': '或批量分配',
    'select_roles': '选择角色',
    'batch_assign_roles': '批量分配角色',
    'batch_assign': '批量分配',

    // 角色管理
    'role_management': '角色管理',
    'role_name': '角色名称',
    'role_code': '角色代码',
    'description': '描述',
    'status': '状态',
    'select_role': '选择角色',
    'select_permissions': '选择权限',
    'batch_assign_permissions': '批量分配权限',

    // 权限管理
    'permission_management': '权限管理',
    'permission_name': '权限名称',
    'permission_code': '权限代码',

    // 组织管理
    'organization_management': '组织管理',
    'organization_name': '组织名称',
    'organization_code': '组织代码',

    // 部门管理
    'department_management': '部门管理',
    'department_management_desc': '管理部门组织树，支持新建、编辑、删除部门',
    'department_name': '部门名称',
    'department_code': '部门代码',

    // 租户管理
    'tenant_management': '租户管理',
    'tenant_name': '租户名称',
    'tenant_code': '租户代码',

    // 操作日志
    'operation_log': '操作日志',
    'operation_time': '操作时间',
    'operation_type': '操作类型',
    'operation_user': '操作用户',
    'operation_content': '操作内容',

    // 资源监控
    'resource_monitoring': '资源监控',
    'cpu_usage': 'CPU使用率',
    'memory_usage': '内存使用率',
    'disk_usage': '磁盘使用率',
    'network_usage': '网络使用率',

    // 农资管理
    'agricultural_material': '农资管理',
    'material_name': '农资名称',
    'material_type': '农资类型',
    'material_price': '农资价格',
    'material_stock': '农资库存',

    // 机械管理
    'machine_management': '机械管理',
    'machine_name': '机械名称',
    'machine_type': '机械类型',
    'machine_status': '机械状态',

    // 系统设置
    'system_settings': '系统设置',
    'login_security': '登录安全',
    'sms_settings': '短信设置',
    'alipay_login': '支付宝登录',
    'wechat_login': '微信登录',

    // 商城管理
    'mall_management': '商城管理',
    'product_management': '商品管理',
    'inventory_management': '库存管理',
    'sales_management': '销售管理',

    'order_management': '订单管理',
    'logistics_management': '物流管理',
    'payment_management': '支付管理',

    // 商品相关
    'product_name': '商品名称',
    'product_price': '商品价格',
    'product_stock': '商品库存',
    'product_category': '商品分类',

    // 订单相关
    'order_number': '订单号',
    'order_date': '订单日期',
    'order_status': '订单状态',
    'order_amount': '订单金额',

    // 客户相关
    'customer_name': '客户名称',
    'customer_phone': '客户电话',
    'customer_email': '客户邮箱',
    'register_time': '注册时间',


    'activity_name': '活动名称',
    'activity_type': '活动类型',
    'activity_status': '活动状态',



    // 库存相关
    'inventory_record': '库存记录',
    'inbound_time': '入库时间',
    'outbound_time': '出库时间',
    'stock_quantity': '库存数量',

    // 销售相关
    'sales_record': '销售记录',
    'sales_date': '销售日期',
    'sales_amount': '销售金额',
    'sales_quantity': '销售数量',

    // 物流相关
    'logistics_record': '物流记录',
    'tracking_number': '快递单号',
    'shipping_address': '收货地址',
    'delivery_status': '配送状态',

    // 字典管理
    'dict_management': '字典管理',
    'dict_type': '字典类型',
    'dict_key': '字典键',
    'dict_value': '字典值',
    'dict_remark': '字典备注',

    // 财务管理
    'finance_management': '财务管理',
    'income': '收入',
    'expense': '支出',
    'balance': '余额',

    // VIP管理
    'vip_management': 'VIP管理',
    'vip_level': 'VIP等级',
    'vip_benefits': 'VIP权益',

    // AI设置
    'ai_settings': 'AI设置',
    'ai_model': 'AI模型',
    'ai_parameters': 'AI参数',

    // 安全设置
    'security_settings': '安全设置',
    'password_policy': '密码策略',
    'login_policy': '登录策略',

    // ========== 系统管理模块 - 完整国际化配置 ==========
    
    // 系统管理主页
    'system_management_page_title': '系统管理',
    'system_management_page_subtitle': '统一管理系统配置、用户权限、组织架构等功能',
    'organization_user_management': '组织用户管理',
    'organization_user_management_desc': '统一管理组织机构、用户、角色和权限相关功能',
    'tenant_management_module': '租户管理',
    'tenant_management_desc': '多租户环境下的租户信息管理',
    'operation_log_module': '操作日志',
    'operation_log_desc': '查看系统操作日志，支持审计追踪',
    'finance_management': '财务管理',
    'finance_management_desc': '收款设置、付款设置、交易记录等',
    'security_settings_module': '安全设置',
    'security_settings_desc': '联合登录、密码强度、短信验证、缓存管理、第三方登录等',
    'ai_settings_module': 'AI设置',
    'ai_settings_desc': 'API Key、计费、Token设置、默认模型',
    'dict_management': '数据字典',
    'dict_management_desc': '管理各类数据字典项',
    'menu_membership_module': '会员管理',
    'menu_membership_module_desc': '配置哪些菜单需要会员权限，设置试用次数',
    
    // AI设置页面
    'ai_settings_title': 'AI设置',
    'configured_models': '已配置模型',
    'add_model': '添加模型',
    'provider': '提供商',
    'model_name': '模型名称',
    'api_endpoint': 'API端点',
    'api_key': 'API Key',
    'test_connection': '测试连接',
    'save_as_default': '保存并设为默认',
    'save_config': '保存配置',
    'test_success': '测试成功',
    'test_failed': '测试失败',
    'connection_testing': '正在测试连接...',
    'please_select_provider': '请先选择提供商',
    'please_enter_api_key': '请先输入API Key',
    'please_enter_model_name': '请输入模型名称',
    'please_enter_api_endpoint': '请输入API端点',
    'config_saved': '配置已保存',
    'config_saved_as_default': '配置已保存并设为默认',
    'save_failed': '保存失败',
    'ai_model_config': 'AI模型配置',
    'ai_prompt_config': 'AI提示词配置',
    // AI模型配置页面
    'ai_model_config_title': 'AI模型配置',
    'ai_model_config_subtitle': '配置AI模型参数和提供商',
    'default_model': '默认模型',
    'model_provider': '模型提供商',
    'model_endpoint': '模型端点',
    'model_key': '模型密钥',
    'model_parameters': '模型参数',
    'max_tokens': '最大令牌数',
    'temperature': '温度',
    'top_p': 'Top P',
    // AI提示词配置页面
    'ai_prompt_config_title': 'AI提示词配置',
    'ai_prompt_config_subtitle': '配置AI系统提示词和预设模板',
    'system_prompt': '系统提示词',
    'user_prompt': '用户提示词',
    'prompt_template': '提示词模板',
    'prompt_variables': '提示词变量',
    
    // 用户管理页面
    'user_management_title': '用户管理',
    'user_list': '用户列表',
    'add_user': '添加用户',
    'edit_user': '编辑用户',
    'delete_user': '删除用户',
    'username': '用户名',
    'real_name': '真实姓名',
    'phone': '手机号',
    'email': '邮箱',
    'user_status': '用户状态',
    'primary_department': '主属部门',
    'user_roles': '用户角色',
    'search_user': '搜索用户名/姓名/手机号/邮箱',
    'select_tenant': '选择租户',
    'all_tenants': '全部租户',
    'cross_tenant_search': '跨租户查询',
    'batch_operations': '批量操作',
    'batch_enable': '批量启用',
    'batch_disable': '批量禁用',
    'batch_delete': '批量删除',
    'user_enabled': '启用',
    'user_disabled': '禁用',
    'password': '密码',
    'confirm_password': '确认密码',
    'department_settings': '部门设置',
    'secondary_departments': '从属部门（可多选）',
    'role_settings': '角色设置',
    'remark': '备注',
    'permission_management_btn': '权限管理',
    'edit_user_info': '编辑用户信息',
    'delete_confirm': '确定要删除这个用户吗？此操作不可恢复！',
    'batch_delete_confirm': '确定要批量删除选中的 {count} 个用户吗？此操作不可恢复！',
    'user_created': '用户创建成功',
    'user_updated': '用户更新成功',
    'user_deleted': '用户删除成功',
    'user_enabled_success': '用户启用成功',
    'user_disabled_success': '用户禁用成功',
    'password_leave_empty': '留空则不修改',
    'import_users': '导入用户',
    'export_users': '导出用户',
    'user_statistics': '用户统计',
    'print_users': '打印用户',
    
    // 角色管理页面
    'role_management_title': '角色管理',
    'role_list': '角色列表',
    'add_role': '添加角色',
    'edit_role': '编辑角色',
    'delete_role': '删除角色',
    'role_name': '角色名称',
    'role_code': '角色代码',
    'role_description': '角色描述',
    'role_permissions': '角色权限',
    'assign_permissions': '分配权限',
    'permission_list': '权限列表',
    'select_permissions': '选择权限',
    'permission_module': '权限模块',
    'permission_action': '权限操作',
    'expand_all': '展开全部',
    'collapse_all': '收起全部',
    'select_all_in_module': '全选本模块',
    'deselect_all_in_module': '取消全选本模块',
    'role_created': '角色创建成功',
    'role_updated': '角色更新成功',
    'role_deleted': '角色删除成功',
    'permissions_assigned': '权限分配成功',
    
    // 权限管理页面
    'permission_management_title': '权限管理',
    'page_permission_management_title': '页面权限',
    'page_permission_management_desc': '管理系统页面访问权限',
    'page_permission_platform_desc': '为租户勾选可访问的系统页面，保存后同步至该租户管理员',
    'page_permission_tenant_desc': '查看平台为本租户开通的页面权限，并在角色权限管理中分配给下属人员',
    'page_permission_platform_subtitle': '勾选后租户管理员可访问对应页面，并向下分配相关操作权限',
    'page_permission_tenant_subtitle': '以下页面已由平台开通，请前往「角色权限管理」为各角色分配具体权限',
    'page_permission_tenant_hint': '平台管理员已为本租户开通的页面权限如下。如需给同事开通，请使用「角色权限管理」或「用户角色管理」。',
    'page_permission_assign_flow_hint': '分配流程：平台管理员开通页面 → 租户管理员在「角色权限管理」中为角色勾选权限 → 在「用户角色管理」中将角色分配给用户。',
    'select_tenant_for_page_permission': '选择要分配页面权限的租户',
    'tenant_page_permission_pool': '租户页面权限池',
    'tenant_opened_page_permissions': '本租户已开通页面',
    'save_tenant_page_permissions': '保存租户页面权限',
    'go_role_permission_assign': '去分配角色权限',
    'no_page_permissions_catalog': '暂无页面权限目录，请先重启后端完成权限种子初始化',
    'no_tenant_page_permissions': '本租户尚未开通任何页面权限，请联系平台管理员',
    'role_permission_tenant_pool_hint': '以下权限列表已按本租户开通范围过滤，您只能在此范围内为角色分配权限。',
    'page_permission_search_placeholder': '搜索页面权限名称或编码...',
    'permission_search_placeholder': '搜索权限名称或编码...',
    'permission_name': '权限名称',
    'permission_code': '权限代码',
    'permission_type': '权限类型',
    'permission_resource': '权限资源',
    'permission_description': '权限描述',
    'add_permission': '添加权限',
    'edit_permission': '编辑权限',
    'add_page_permission': '添加页面权限',
    'edit_page_permission': '编辑页面权限',
    'delete_permission': '删除权限',
    // 租户管理页面
    'tenant_management_title': '租户管理',
    'tenant_list': '租户列表',
    'add_tenant': '添加租户',
    'edit_tenant': '编辑租户',
    'delete_tenant': '删除租户',
    'tenant_name': '租户名称',
    'tenant_code': '租户代码',
    'tenant_type': '租户类型',
    'tenant_status': '租户状态',
    'tenant_admin': '租户管理员',
    'tenant_created': '租户创建成功',
    'tenant_updated': '租户更新成功',
    'tenant_deleted': '租户删除成功',
    'province_level': '省级',
    'city_level': '市级',
    'county_level': '县级',
    'township_level': '乡镇级',
    
    // 组织管理页面
    'organization_management_title': '组织管理',
    'organization_list': '组织列表',
    'add_organization': '添加组织',
    'edit_organization': '编辑组织',
    'delete_organization': '删除组织',
    'organization_name': '组织名称',
    'organization_code': '组织代码',
    'parent_organization': '上级组织',
    'organization_manager': '组织负责人',
    'organization_type': '组织类型',
    'organization_created': '组织创建成功',
    'organization_updated': '组织更新成功',
    'organization_deleted': '组织删除成功',
    
    // 部门管理页面
    'department_management_title': '部门管理',
    'department_list': '部门列表',
    'add_department': '添加部门',
    'edit_department': '编辑部门',
    'delete_department': '删除部门',
    'department_name': '部门名称',
    'department_code': '部门代码',
    'parent_department': '上级部门',
    'department_manager': '部门负责人',
    'employee_count': '员工数量',
    'department_created': '部门创建成功',
    'department_updated': '部门更新成功',
    'department_deleted': '部门删除成功',
    'sort_order': '排序',
    
    // 员工管理页面
    'employee_management_title': '员工管理',
    'employee_list': '员工列表',
    'add_employee': '添加员工',
    'edit_employee': '编辑员工',
    'delete_employee': '删除员工',
    'employee_no': '员工编号',
    'employee_name': '员工姓名',
    'employee_department': '所属部门',
    'employee_position': '职位',
    'employee_status': '员工状态',
    'employee_created': '员工创建成功',
    'employee_updated': '员工更新成功',
    'employee_deleted': '员工删除成功',
    
    // 操作日志页面
    'operation_log_title': '操作日志',
    'operation_user': '操作用户',
    'operation_type': '操作类型',
    'operation_time': '操作时间',
    'operation_content': '操作内容',
    'operation_ip': '操作IP',
    'operation_result': '操作结果',
    'operation_success': '成功',
    'operation_failed': '失败',
    'log_search': '日志搜索',
    'export_logs': '导出日志',
    
    // 数据字典管理页面
    'dict_management_title': '数据字典管理',
    'dict_list': '字典列表',
    'add_dict': '添加字典',
    'edit_dict': '编辑字典',
    'delete_dict': '删除字典',
    'dict_code': '字典代码',
    'dict_name': '字典名称',
    'dict_type': '字典类型',
    'dict_items': '字典项',
    'add_dict_item': '添加字典项',
    'edit_dict_item': '编辑字典项',
    'delete_dict_item': '删除字典项',
    'item_value': '项值',
    'item_label': '项标签',
    'dict_created': '字典创建成功',
    'dict_updated': '字典更新成功',
    'dict_deleted': '字典删除成功',
    'enum_management': '枚举值管理',
    'config_management': '配置项管理',
    
    // 财务管理页面
    'finance_management_title': '财务管理',
    'payment_settings': '收款设置',
    'withdrawal_settings': '付款设置',
    'transaction_records': '交易记录',
    'payment_method': '支付方式',
    'payment_account': '支付账户',
    'transaction_amount': '交易金额',
    'transaction_status': '交易状态',
    'transaction_time': '交易时间',
    
    // 安全设置页面
    'security_settings_title': '安全设置',
    'oauth_login': '联合登录',
    'password_strength': '密码强度',
    'sms_verification': '短信验证',
    'cache_management': '缓存管理',
    'cache_monitoring': '缓存监控',
    'data_cache': '数据缓存',
    'alipay_settings': '支付宝设置',
    'wechat_settings': '微信设置',
    'third_party_login': '第三方登录',
    'min_password_length': '最小密码长度',
    'require_uppercase': '要求大写字母',
    'require_lowercase': '要求小写字母',
    'require_numbers': '要求数字',
    'require_special_chars': '要求特殊字符',
    'password_expiry': '密码有效期',
    'prevent_reuse': '防止重复使用',
    'lockout_threshold': '锁定阈值',
    'lockout_duration': '锁定时间',
    
    // 会员管理页面
    'membership_management_title': '会员管理',
    'membership_center': '会员中心',
    'membership_types': '会员套餐',
    'current_membership': '当前会员',
    'membership_status': '会员状态',
    'expiry_date': '到期时间',
    'days_remaining': '剩余天数',
    'upgrade_membership': '升级会员',
    'purchase_membership': '购买会员',
    'membership_price': '会员价格',
    'membership_duration': '会员时长',
    'membership_features': '会员权益',
    'membership_expired': '已过期',
    'membership_active': '有效',
    'renew_membership': '续费会员',
    'payment_method_label': '支付方式',
    'contact_phone': '联系电话',
    'purchase_confirm': '确认购买',
    'membership_purchased': '购买成功！',
    'membership_page_subtitle': '选择适合您的会员套餐，享受更多专属服务',
    'welcome_to_membership': '欢迎来到会员中心',
    'not_member_yet': '您还不是会员，升级会员享受更多专属服务',
    'upgrade_now': '立即升级会员',
    'admin_dashboard': '管理员界面',
    'select_payment_method': '请选择支付方式',
    'enter_phone': '请输入联系电话',
    'valid_phone': '请输入正确的手机号码',
    
    // 会员类型管理页面
    'membership_type_management': '会员类型管理',
    'add_membership_type': '添加会员类型',
    'edit_membership_type': '编辑会员类型',
    'delete_membership_type': '删除会员类型',
    'membership_type_name': '会员类型名称',
    'membership_type_price': '会员价格',
    'membership_type_duration': '会员时长',
    'membership_type_features': '会员权益',
    
    // 会员权益管理页面
    'membership_privilege_management': '会员权益管理',
    'privilege_name': '权益名称',
    'privilege_description': '权益描述',
    'privilege_type': '权益类型',
    
    // 支付方式管理页面
    'payment_method_management': '支付方式管理',
    'add_payment_method': '添加支付方式',
    'edit_payment_method': '编辑支付方式',
    'delete_payment_method': '删除支付方式',
    'payment_method_name': '支付方式名称',
    'payment_method_code': '支付方式代码',
    
    // 会员统计页面
    'membership_statistics_title': '会员统计',
    'total_members': '总会员数',
    'active_members': '活跃会员',
    'expired_members': '过期会员',
    'membership_revenue': '会员收入',
    
    // VIP管理页面
    'vip_management_title': 'VIP管理',
    'vip_level': 'VIP等级',
    'vip_benefits': 'VIP权益',
    'vip_settings': 'VIP设置',
    
    // 数据库健康检查页面
    'database_health_check_title': '数据库健康检查',
    'database_status': '数据库状态',
    'connection_status': '连接状态',
    'query_performance': '查询性能',
    'table_analysis': '表分析',
    'index_analysis': '索引分析',
    
    // 数据库错误管理页面
    'database_error_management_title': '数据库错误管理',
    'error_list': '错误列表',
    'error_type': '错误类型',
    'error_message': '错误信息',
    'error_time': '错误时间',
    
    // 组织树管理页面
    'organization_tree_management_title': '组织树管理',
    'organization_tree': '组织树',
    'expand_tree': '展开树',
    'collapse_tree': '收起树',
    
    // 组织用户管理页面
    'organization_user_management_title': '组织用户管理',
    'organization_users': '组织用户',
    'assign_users': '分配用户',
    
    // 用户角色管理页面
    'user_role_management_title': '用户角色管理',
    'user_role_assign': '用户角色分配',
    'assign_roles': '分配角色',
    
    // 角色权限管理页面
    'role_permission_management_title': '角色权限管理',
    'role_permission_assign': '角色权限分配',
    
    // 菜单会员管理页面
    'menu_membership_management_title': '菜单会员管理',
    'menu_list': '菜单列表',
    'membership_required': '需要会员',
    'trial_count': '试用次数',
    // 会员重定向页面
    'membership_redirect_title': '会员提示',
    'membership_redirect_message': '该功能需要会员权限',
    // 管理员会员仪表板
    'admin_membership_dashboard_title': '管理员会员仪表板',
    'membership_overview': '会员概览',
    'membership_trends': '会员趋势',
    // ========== 系统管理模块国际化配置结束 ==========
    // 气象数据
    'weather_data': '气象数据',
    'weather_data_collection': '气象数据收集',
    'temperature': '温度',
    'humidity': '湿度',
    'rainfall': '降雨量',
    'wind_speed': '风速',
    'wind_direction': '风向',
    'air_pressure': '气压',
    'sunshine_hours': '日照时数',
    'export_data': '导出数据',
    'show_map': '显示地图',
    'hide_map': '隐藏地图',
    'monitoring_stations': '监测站点分布',
    'map_area': '地图区域 - 监测站点分布',
    'click_station_switch': '点击站点切换数据',
    'data_filter': '数据筛选',
    'monitoring_area': '监测地区',
    'date': '日期',
    'time_range': '时间范围',
    'query_data': '查询数据',
    'extreme_weather_stats': '极端天气统计',
    'high_temperature_weather': '高温天气',
    'heavy_rain_weather': '暴雨天气',
    'strong_wind_weather': '大风天气',
    'low_visibility': '低能见度',
    'days': '天',
    'real_time_data': '实时数据',
    'weather_condition': '天气状况',
    'view_details': '查看详情',
    'trend_chart_24h': '24小时趋势',
    'uv_index': '紫外线指数',
    'visibility': '能见度',
    'record_time': '记录时间',
    'data_source': '数据来源',
    'weather_station': '气象站',
    'today': '今日',
    'this_week': '本周',
    'this_month': '本月',
    'this_quarter': '本季度',
    'fetch_weather_data_failed': '获取气象数据失败，请检查网络连接',
    'export_success': '数据导出成功',
    'export_failed': '导出失败',
    'time': '时间',
    'wind_direction': '风向',
    'precipitation': '降水量',
    'sunny': '晴天',
    'rainy': '雨天',
    'cloudy': '多云',
    'normal': '正常',
    'close': '关闭',
    'basic_info': '基本信息',
    'monitoring_location': '监测地点',
    'record_time': '记录时间',
    'weather_indicators': '气象指标',
    'detailed_indicators': '详细指标',
    'coordinate_info': '坐标信息',
    'latitude': '纬度',
    'longitude': '经度',
    'uv_low': '低',
    'uv_medium': '中等',
    'uv_high': '高',
    'uv_very_high': '很高',
    'uv_extreme': '极高',

    // 水资源
    'water_resources': '水资源',
    'water_usage': '用水量',
    'water_quality': '水质',
    'irrigation_area': '灌溉面积',

    // 土壤分析
    'soil_analysis': '土壤分析',
    'soil_type': '土壤类型',
    'soil_ph': '土壤pH值',
    'soil_moisture': '土壤湿度',
    'soil_fertility': '土壤肥力',

    // 种植建议
    'planting_advice': '种植建议',
    'crop_type': '作物类型',
    'planting_time': '种植时间',
    'harvest_time': '收获时间',
    // 历史数据
    'historical_data': '历史数据',
    'historical_data_analysis': '历史数据分析',
    'historical_data_description': '分析历史气象数据，发现变化规律和异常事件',
    'data_type': '数据类型',
    'data_date': '数据日期',
    'year_range': '年份范围',
    'time_range': '时间范围',
    'filter': '筛选',
    'refresh_data': '刷新数据',
    'export_data': '导出数据',
    'average_value': '平均值',
    'maximum_value': '最大值',
    'minimum_value': '最小值',
    'yearly_trend': '年变化趋势',
    'temperature': '温度',
    'humidity': '湿度',
    'rainfall': '降雨量',
    'yearly_comparison': '年度对比',
    'data_table': '数据表格',
    'anomaly_events': '异常事件',
    'statistical_analysis': '统计分析',
    'yearly_data_comparison': '年度数据对比',
    'monthly_trend_comparison': '月度趋势对比',
    'historical_data_table': '历史数据表格',
    'anomaly_event_records': '异常事件记录',
    'anomaly_event_statistics': '异常事件统计',
    'anomaly_event_count': '共发现 {count} 个异常事件，其中严重事件 {severe} 个',
    'data_distribution': '数据分布',
    'change_trend': '变化趋势',
    'historical_data_details': '历史数据详情',
    'january': '1月',
    'february': '2月',
    'march': '3月',
    'april': '4月',
    'may': '5月',
    'june': '6月',
    'july': '7月',
    'august': '8月',
    'september': '9月',
    'october': '10月',
    'november': '11月',
    'december': '12月',
    'year': '年',
    'operation': '操作',
    'details': '详情',
    'date': '日期',
    'event_type': '事件类型',
    'value': '数值',
    'impact_level': '影响程度',
    'description': '描述',
    'high_temperature': '高温',
    'low_temperature': '低温',
    'heavy_rain': '暴雨',
    'drought': '干旱',
    'severe': '严重',
    'moderate': '中等',
    'mild': '轻微',
    'export_success': '数据导出成功',
    'export_failed': '导出失败',
    'refresh_success': '数据已刷新',
    'yearly_average': '年平均',
    'highest_value': '最高值',
    'lowest_value': '最低值',
    'data_analysis': '数据分析',
    'data_analysis_point1': '数据变化符合季节性规律',
    'data_analysis_point2': '与历史同期相比，变化幅度在正常范围内',
    'data_analysis_point3': '无明显异常波动，数据质量良好',
    'tip': '提示',
    'please_enter': '请输入',
    'select_ai_model_to_configure': '请从左侧选择一个AI模型进行配置',
    'custom_endpoint_and_model': '自定义端点和模型',
    'preset_endpoint': '预设端点',
    'configuration': '配置',
    'success': '成功',
    'error': '错误',
    'please_wait': '请稍候',
    'api': 'API',
    'response_time': '响应时间',
    'custom': '自定义',
    'default': '默认',
    'data': '数据',
    'month': '月份',
    'tenant': '租户',
    'account': '账户',
    'name': '姓名',
    'roles': '角色',
    'operation': '操作',
    'rows_per_page': '每页显示',
    'items': '条',
    'page_info': '第 {current} 页，共 {total} 页，总计 {items} 条记录',
    'statistics': '统计',
    'print': '打印',
    'unknown_tenant': '未知租户',
    'basic_info': '基本信息',
    'update': '更新',
    'enter_username': '请输入用户名',
    'enter_real_name': '请输入真实姓名',
    'enter_email': '请输入邮箱',
    'tenant_management_subtitle': '管理多级租户架构，支持省级→市级→县级→乡镇级',
    'enter_tenant_name': '请输入租户名称',
    'data_dictionary': '数据字典',
    'privilege_config': '权益配置',
    'upgrade_rules': '升级规则',
    'organization_user_management_subtitle': '统一管理组织机构、用户、角色和权限相关功能，采用顶部导航方式切换不同功能模块',
    'back_to_system_management': '返回系统管理',
    'click_to_enter': '点击进入',
    'feature_description': '功能说明',
    'organization_management_desc': '管理组织架构、部门设置',
    'user_management_desc': '管理系统用户信息',
    'role_management_desc': '管理系统角色定义',
    'permission_management_desc': '管理系统权限配置',
    'user_role_management_desc': '分配用户角色关系',
    'role_permission_management_desc': '配置角色权限关系',
    'organization_management_feature_desc': '管理组织架构、部门设置、组织树结构等，支持多层级组织管理。',
    'user_management_feature_desc': '管理系统用户信息，包括用户创建、编辑、删除、状态管理等。',
    'role_management_feature_desc': '定义系统角色，设置角色的基本信息和描述。',
    'permission_management_feature_desc': '管理系统权限配置，定义各种操作权限。',
    'user_role_management_feature_desc': '分配用户角色关系，管理用户与角色的关联。',
    'role_permission_management_feature_desc': '配置角色权限关系，为角色分配相应的权限。',
    'please_select_tab_to_continue': '请选择上方标签页进入对应功能模块',

    // 趋势分析
    'trend_analysis': '趋势分析',
    'trend_chart': '趋势图表',
    'trend_prediction': '趋势预测',
    // 灾害预警
    'disaster_warning': '灾害预警',
    'warning_level': '预警等级',
    'warning_type': '预警类型',
    'warning_area': '预警区域',

    // 本地气候
    'local_climate': '本地气候',
    'climate_type': '气候类型',
    'suitable_crops': '适宜作物',

    // 地块管理
    'field_management': '地块管理',
    'field_name': '地块名称',
    'field_area': '地块面积',
    'field_location': '地块位置',
    'field_status': '地块状态',

    // 植保作业
    'field_operation': '植保作业',
    'operation_name': '作业名称',
    'field_operation_type': '作业类型',
    'operation_date': '作业日期',
    'operation_status': '作业状态',

    // 病害预警
    'disease_warning': '病害预警',
    'disease_type': '病害类型',
    'disease_level': '病害等级',
    'prevention_method': '防治方法',

    // 种植资产管理
    'planting_asset': '种植资产',
    'planting_asset_name': '资产名称',
    'planting_asset_type': '资产类型',
    'planting_asset_value': '资产价值',

    // 种植生产计划
    'planting_plan': '种植计划',
    'plan_name': '计划名称',
    'plan_type': '计划类型',
    'plan_status': '计划状态',

    // 资产统计
    'asset_statistics': '资产统计',
    'total_assets': '总资产',
    'asset_growth': '资产增长',

    // 经济分析
    'economic_analysis': '经济分析',
    'cost_analysis': '成本分析',
    'profit_analysis': '利润分析',
    'investment_return': '投资回报',

    // 经济统计
    'economic_statistics': '经济统计',
    'income_statistics': '收入统计',
    'expense_statistics': '支出统计',

    // 产出统计
    'output_statistics': '产出统计',
    'yield_statistics': '产量统计',
    'quality_statistics': '质量统计',

    // 绩效跟踪
    'performance_tracking': '绩效跟踪',
    'performance_indicator': '绩效指标',
    'performance_score': '绩效得分',

    // 数据看板
    'planting_data_dashboard': '数据看板',
    'planting_dashboard_overview': '看板概览',
    'planting_key_indicators': '关键指标',

    // 播种管理
    'seeding_management': '播种管理',
    'seeding_date': '播种日期',
    'seeding_method': '播种方法',
    'seeding_density': '播种密度',
    'crop': '作物',
    'area': '面积',
    'area_unit': '亩',
    'operator': '操作人',

    // 施肥管理
    'fertilization_management': '施肥管理',
    'fertilization_date': '施肥日期',
    'fertilizer_type': '肥料类型',
    'fertilization_amount': '施肥量',
    'fertilizer': '肥料',
    'amount': '用量',
    'amount_unit': 'kg',

    // 灌溉管理
    'irrigation_management': '灌溉管理',
    'irrigation_date': '灌溉日期',
    'irrigation_method': '灌溉方法',
    'irrigation_amount': '灌溉量',
    'irrigation_water': '灌溉用水',
    'water_amount': '用水量',
    'water_amount_unit': 'm³',

    // 除草管理
    'weeding_management': '除草管理',
    'weeding_date': '除草日期',
    'weeding_method': '除草方法',
    'herbicide_type': '除草剂类型',
    'herbicide': '除草剂',
    'herbicide_amount': '除草剂用量',
    'herbicide_amount_unit': 'ml',

    // 种植生产计划
    'planting_production_planning': '种植生产计划',
    'planning_name': '计划名称',

    // 网络数据模块
    'network_data': '网络数据',
    'data_crawling': '数据爬取',
    'data_analytics': '数据分析',
    'global_monitoring': '全局监控',
    'local_prevention': '本地防治',
    'pest_disease': '病虫害',
    'public_opinion': '舆情分析',
    'weather_disaster': '气象灾害',

    // 通用页面
    'not_found': '页面未找到',
    'back_home': '返回首页',
    // 支付管理
    'payment_management': '支付管理',
    'payment_methods': '支付方式',
    'refund_processing': '退款处理',
    'reconciliation_management': '对账管理',
    'financial_statistics': '财务统计',
    'payment_method': '支付方式',
    'payment_type': '支付类型',
    'online_payment': '在线支付',
    'offline_payment': '线下支付',
    'service_fee': '手续费率',
    'payment_status': '支付状态',
    'refund_amount': '退款金额',
    'refund_reason': '退款原因',
    'refund_status': '退款状态',
    'reconciliation_date': '对账日期',
    'total_amount': '总金额',
    'success_amount': '成功金额',
    'failed_amount': '失败金额',
    'reconciliation_operator': '操作员',
    'financial_revenue': '财务收入',
    'order_count': '订单数量',
    'success_rate': '成功率',
    'average_order': '平均订单',
    'planning_type': '计划类型',
    'planning_status': '计划状态',
    'planning_start_date': '计划开始日期',
    'planning_end_date': '计划结束日期',
    'planning_area': '计划面积',
    'planning_crop': '计划作物',
    'planning_yield': '计划产量',
    'planning_cost': '计划成本',
    // 种植资产管理
    'planting_asset_management': '种植资产管理',
    'comprehensive_asset_management': '植保资产管理',
    'asset_id': '资产编号',
    'asset_name': '资产名称',
    'asset_type': '资产类型',
    'asset_value': '资产价值',
    'asset_purchase_date': '购买日期',
    'asset_status': '资产状态',
    'asset_location': '资产位置',
    'asset_owner': '资产所有者',
    'asset_maintenance': '维护记录',
    'asset_code': '资产编码',
    'asset_specification': '规格参数',
    'asset_purchase_price': '采购价格',
    'asset_current_value': '当前价值',
    'asset_responsible_person': '负责人',
    'asset_category': '资产分类',
    'asset_remark': '备注信息',
    'asset_usage_record': '使用记录',
    'asset_maintenance_record': '维护记录',
    'asset_statistics': '资产统计',

    // 数据看板
    'data_dashboard': '数据看板',
    'dashboard_overview': '看板概览',
    'key_indicators': '关键指标',
    'dashboard_charts': '图表展示',
    'dashboard_statistics': '统计数据',
    'dashboard_alerts': '预警信息',
    'dashboard_tasks': '待办任务',
    'dashboard_weather': '天气信息',
    'dashboard_market': '市场行情',

    // ====== 导航栏国际化 ======
    'nav_welcome': '欢迎',
    'nav_disease_diagnosis': '病害问诊',
    'nav_plant_protection_inquiry': 'AI智能服务',
    'nav_inquiry_history': '历史问询',
    'nav_diagnosis_image': '图像诊断',
    'nav_diagnosis_text': '文字诊断',
    'nav_expert_diagnosis': '专家诊断',
    'nav_weather_agronomy': '气象农艺',
    'nav_smart_farm_cockpit': '智慧农场驾驶舱',
    'nav_plant_protection_news': '农业资讯',
    'nav_news_center': '资讯中心',
    'nav_pest_warning': '病虫害预警',
    'nav_technical_guidance': '技术指导',
    'nav_policy_interpretation': '政策解读',
    'nav_market_analysis': '市场分析',
    'nav_expert_advice': '专家建议',
    'nav_seasonal_guidance': '季节性指导',
    'nav_regional_news': '区域资讯',
    'nav_research_progress': '科研进展',
    'nav_international_news': '国际资讯',
    'nav_data_statistics': '数据统计',
    'nav_weather_data': '气象数据',
    'nav_local_climate': '本地气候',
    'nav_intervention_plans': '干预建议',
    'nav_planting_advice': '种植建议',
    'nav_soil_analysis': '土壤分析',
    'nav_water_resources': '水资源',
    'nav_historical_data': '历史数据',
    'nav_trend_analysis': '趋势分析',
    'nav_disaster_warning': '灾害预警',
    'nav_my_plant_protection': '生产管理',
    // My Plant Protection 首页
    'mpp_page_subtitle': '地块、作物、农事三维生产管控',
    'mpp_data_overview': '功能概览',
    'mpp_recent_activity': '最近事项',
    'mpp_recent_execution': '最近执行事项',
    'mpp_recent_plans': '计划排期（远期）',
    'mpp_view_all': '查看全部',
    'mpp_no_recent': '暂无最近事项',
    'mpp_no_recent_execution': '暂无执行中或已完成的农事记录',
    'mpp_no_recent_plans': '暂无远期计划排期',
    'mpp_stat_planted_crops': '种植作物',
    'mpp_stat_tasks': '任务数量',
    'mpp_completion_rate': '完成率',
    'mpp_stat_warnings': '预警数',
    'mpp_stat_completed': '已完成',
    'mpp_count_items': '{count} 项',
    'mpp_dim_all': '全部',
    'mpp_dim_land': '地块管理',
    'mpp_dim_crop': '作物种植',
    'mpp_dim_field_work': '农事管理',
    'mpp_dim_support': '支撑服务',
    'mpp_dim_land_hint': '农场、地块、资产与灌溉设施等空间载体',
    'mpp_dim_crop_hint': '种植计划、生长模型与作物全周期管理',
    'mpp_dim_field_work_hint': '执行台账、计划排期与预警防治分开展示',
    'mpp_dim_support_hint': '农资、采购、粮仓与经营分析',
    'mpp_section_execution': '执行台账',
    'mpp_section_planning': '计划排期',
    'mpp_section_pest_warning': '预警与防治',
    // My Plant Protection 首页 - 地块管理卡片
    'page_desc_land_management_hub': '查看与维护地块信息，包含地块边界与地图维护',
    'detail_land_asset_tab': '地块信息',
    'detail_land_boundary': '地块边界',
    'detail_land_map_maintenance': '地块地图维护',
    'nav_plant_growth_model': '植物生长模型',

    // Plant Protection News Module
    'ppn_category_news': '资讯类',
    'ppn_category_news_desc': '行业资讯和科研动态',
    'ppn_category_warning': '预警分析类',
    'ppn_category_warning_desc': '病虫害预警和市场分析',
    'ppn_category_environment': '环境分析类',
    'ppn_category_environment_desc': '土壤和水资源分析',
    'ppn_category_guidance': '指导建议类',
    'ppn_category_guidance_desc': '种植指导和建议',
    'ppn_category_safety': '安全环保类',
    'ppn_category_safety_desc': '安全用药和环保要求',

    // Plant Protection News Modules
    'ppn_news_center_title': '新闻资讯',
    'ppn_news_center_desc': '植保行业最新资讯、政策解读、技术动态',
    'ppn_research_progress_title': '科研进展',
    'ppn_research_progress_desc': '植保科研最新成果、技术突破、发展趋势',
    'ppn_pest_warning_title': '病虫害预警',
    'ppn_pest_warning_desc': '实时病虫害监测预警，提供防治建议',
    'ppn_market_analysis_title': '市场分析',
    'ppn_market_analysis_desc': '植保产品市场趋势、价格分析、供需信息',
    'ppn_data_statistics_title': '数据统计',
    'ppn_data_statistics_desc': '植保行业数据统计、趋势分析、报告下载',
    'ppn_network_trend_analysis_title': '网络趋势分析',
    'ppn_network_trend_analysis_desc': '基于历史数据，分析病虫害发展趋势和规律',
    
    // Network Trend Analysis Page
    'ppn_trend_analysis_page_title': '网络趋势分析',
    'ppn_trend_analysis_page_subtitle': '基于历史数据，分析病虫害发展趋势',
    'ppn_trend_period_all': '全部时期',
    'ppn_trend_period_week': '本周',
    'ppn_trend_period_month': '本月',
    'ppn_trend_period_quarter': '本季度',
    'ppn_trend_period_year': '本年',
    'ppn_trend_clear_filters': '清除筛选',
    'ppn_trend_current_filters': '当前筛选条件：',
    'ppn_trend_records_found': '找到 {count} 条记录',
    'ppn_trend_overall_card_title': '总体趋势',
    'ppn_trend_avg_change_label': '平均变化率',
    'ppn_trend_active_card_title': '活跃害虫',
    'ppn_trend_active_card_desc': '符合当前筛选条件',
    'ppn_trend_high_card_title': '高严重程度',
    'ppn_trend_high_card_desc': '需要关注',
    'ppn_trend_table_title': '害虫趋势详情',
    'ppn_trend_table_name': '害虫名称',
    'ppn_trend_table_trend': '趋势',
    'ppn_trend_table_change': '变化率',
    'ppn_trend_table_region': '地区',
    'ppn_trend_table_severity': '严重程度',
    'ppn_trend_value_up': '上升',
    'ppn_trend_value_down': '下降',
    'ppn_trend_value_stable': '稳定',
    'ppn_trend_severity_high': '高',
    'ppn_trend_severity_medium': '中',
    'ppn_trend_severity_low': '低',
    'ppn_trend_loading': '加载中...',
    'ppn_trend_toggle_light': '切换到浅色模式',
    'ppn_trend_toggle_dark': '切换到深色模式',
    'ppn_trend_pest_rice_planthopper': '稻飞虱',
    'ppn_trend_pest_corn_borer': '玉米螟',
    'ppn_trend_pest_wheat_rust': '小麦条锈病',
    'ppn_trend_pest_cotton_bollworm': '棉铃虫',
    'ppn_trend_pest_aphids': '蚜虫',
    'ppn_trend_data_type_all': '全部类型',
    'ppn_trend_data_type_pest': '虫害',
    'ppn_trend_data_type_disease': '病害',
    'ppn_trend_data_type_weather': '气象',
    'ppn_trend_data_type_market': '市场',
    'ppn_trend_chart_line_title': '趋势折线图',
    'ppn_trend_chart_area_title': '趋势面积图',
    'ppn_trend_chart_bar_title': '趋势柱状图',
    'ppn_trend_chart_total': '总计',
    'ppn_trend_no_data': '暂无数据',
    
    'ppn_soil_analysis_title': '土壤分析',
    'ppn_soil_analysis_desc': '分析土壤特性，提供土壤改良建议',
    
    // Soil Analysis Page
    'ppn_soil_analysis_page_title': '土壤分析',
    'ppn_soil_analysis_page_subtitle': '分析土壤特性，提供土壤改良建议',
    'ppn_soil_type': '土壤类型',
    'ppn_soil_ph_value': 'pH值',
    'ppn_soil_organic_matter': '有机质',
    'ppn_soil_nutrient_content': '养分含量',
    'ppn_soil_improvement_suggestions': '改良建议',
    'ppn_soil_region_north_plain': '华北平原',
    'ppn_soil_region_northeast_black': '东北黑土区',
    'ppn_soil_region_yangtze': '长江中下游',
    'ppn_soil_region_south': '华南地区',
    'ppn_soil_type_all': '全部土壤类型',
    'ppn_soil_type_brown': '棕壤',
    'ppn_soil_type_black': '黑土',
    'ppn_soil_type_paddy': '水稻土',
    'ppn_soil_type_red': '红壤',
    'ppn_soil_clear_filters': '清除筛选',
    'ppn_soil_current_filters': '当前筛选条件：',
    'ppn_soil_records_found': '找到 {count} 条记录',
    'ppn_soil_toggle_light': '切换到浅色模式',
    'ppn_soil_toggle_dark': '切换到深色模式',
    'ppn_soil_card_avg_ph_title': '平均pH值',
    'ppn_soil_card_ph_range': '推荐范围：6.0-7.5',
    'ppn_soil_card_organic_title': '有机质',
    'ppn_soil_card_organic_target': '目标：>2.5%',
    'ppn_soil_card_nitrogen_title': '氮含量',
    'ppn_soil_card_nitrogen_range': '推荐范围：80-150',
    'ppn_soil_card_phosphorus_title': '磷含量',
    'ppn_soil_card_phosphorus_range': '推荐范围：30-80',
    'ppn_soil_unit_mgkg': 'mg/kg',
    'ppn_soil_table_title': '土壤分析详情',
    'ppn_soil_table_region': '地区',
    'ppn_soil_table_type': '土壤类型',
    'ppn_soil_table_ph': 'pH',
    'ppn_soil_table_organic': '有机质 (%)',
    'ppn_soil_table_nitrogen': '氮 (mg/kg)',
    'ppn_soil_table_phosphorus': '磷 (mg/kg)',
    'ppn_soil_table_potassium': '钾 (mg/kg)',
    'ppn_soil_table_status': '状态',
    'ppn_soil_status_excellent': '优秀',
    'ppn_soil_status_good': '良好',
    'ppn_soil_status_warning': '需改善',
    'ppn_soil_status_poor': '较差',
    'ppn_soil_status_unknown': '未知',
    'ppn_soil_loading': '加载中...',
    'ppn_soil_recommendations_title': '土壤改良建议',
    'ppn_soil_rec_add_organic': '增施有机肥',
    'ppn_soil_rec_rotation': '实施轮作',
    'ppn_soil_rec_deep_tillage': '深耕改良',
    'ppn_soil_rec_conservation_tillage': '保护性耕作',
    'ppn_soil_rec_straw_return': '秸秆还田',
    'ppn_soil_rec_scientific_fertilization': '科学施肥',
    'ppn_soil_rec_add_phosphate': '增施磷肥',
    'ppn_soil_rec_improve_drainage': '改善排水',
    'ppn_soil_rec_adjust_ph': '调节土壤pH',
    'ppn_soil_rec_add_lime': '施用石灰',
    'ppn_soil_rec_improve_organic': '改善有机质',
    'ppn_soil_rec_balance_fertilization': '平衡施肥',
    
    'ppn_water_resources_title': '水资源分析',
    'ppn_water_resources_desc': '分析水文数据，评估水资源状况',
    'ppn_seasonal_guidance_title': '季节性指导',
    'ppn_seasonal_guidance_desc': '按季节提供植保建议和注意事项',
    'ppn_expert_advice_title': '专家观点',
    'ppn_expert_advice_desc': '植保专家观点、案例分析、经验分享与咨询',
    'ppn_planting_advice_title': '种植建议',
    'ppn_planting_advice_desc': '基于气候、土壤、水文数据提供种植建议',
    'ppn_safe_pesticide_use_title': '安全用药',
    'ppn_safe_pesticide_use_desc': '农药安全使用指南、中毒急救、防护措施等',
    'ppn_environmental_protection_title': '环保要求',
    'ppn_environmental_protection_desc': '环境友好型防治方法、农药环境影响评估等',

    // News Center Page
    'ppn_news_center_page_title': '资讯中心',
    'ppn_news_center_page_subtitle': '获取植保行业最新资讯、政策解读、技术动态和市场分析',
    'ppn_admin_mode': '管理员模式：您拥有所有功能的访问权限',
    'ppn_search_placeholder': '搜索资讯...',
    'ppn_category_all': '全部',
    'ppn_category_policy': '政策法规',
    'ppn_category_technology': '技术动态',
    'ppn_category_market': '市场资讯',
    'ppn_category_research': '科研进展',
    'ppn_category_industry': '行业动态',
    'ppn_views': '阅读',
    'ppn_author': '作者',
    'ppn_bookmark': '收藏',
    'ppn_share': '分享',
    'ppn_read_full': '阅读全文',
    'ppn_no_news': '暂无相关资讯',
    'ppn_no_image': '暂无图片',

    // Pest Warning Page - Common
    'ppn_region_all': '全部地区',
    'ppn_region_north': '华北地区',
    'ppn_region_northeast': '东北地区',
    'ppn_region_east': '华东地区',
    'ppn_region_central': '华中地区',
    'ppn_region_south': '华南地区',
    'ppn_region_west': '西部地区',
    'ppn_region_southwest': '西南地区',
    'ppn_region_northwest': '西北地区',
    'ppn_crop_all': '全部作物',
    'ppn_crop_rice': '水稻',
    'ppn_crop_wheat': '小麦',
    'ppn_crop_corn': '玉米',
    'ppn_crop_soybean': '大豆',
    'ppn_crop_cotton': '棉花',
    'ppn_crop_vegetable': '蔬菜',
    'ppn_crop_fruit': '果树',
    'ppn_level_all': '全部级别',
    'ppn_level_low': '低风险',
    'ppn_level_medium': '中风险',
    'ppn_level_high': '高风险',
    'ppn_level_critical': '极高风险',

    // Pest Warning Page
    'ppn_pest_warning_page_title': '病虫害预警',
    'ppn_pest_warning_page_subtitle': '实时监测病虫害发生情况，及时发布预警信息，提供防治建议',
    'ppn_filter_by_region': '按地区筛选',
    'ppn_filter_by_crop': '按作物筛选',
    'ppn_filter_by_level': '按风险等级筛选',
    'ppn_affected_area': '受影响面积',
    'ppn_start_date': '开始日期',
    'ppn_end_date': '结束日期',
    'ppn_prevention_measures': '防治措施',
    'ppn_risk_factors': '风险因素',
    'ppn_status_active': '进行中',
    'ppn_status_resolved': '已解决',
    'ppn_view_details': '查看详情',
    'ppn_no_warnings': '暂无预警信息',

    // Market Analysis Page
    'ppn_market_analysis_page_title': '市场分析',
    'ppn_market_analysis_page_subtitle': '植保产品市场趋势、价格分析、供需信息',
    'ppn_market_category_all': '全部市场',
    'ppn_market_category_pesticide': '农药市场',
    'ppn_market_category_fertilizer': '肥料市场',
    'ppn_market_category_seed': '种子市场',
    'ppn_market_category_equipment': '设备市场',
    'ppn_market_category_biotech': '生物技术',
    'ppn_market_category_organic': '有机市场',
    'ppn_market_search_placeholder': '搜索市场分析...',
    'ppn_market_size': '市场规模',
    'ppn_market_growth_rate': '增长率',
    'ppn_market_forecast_period': '预测周期',
    'ppn_market_views_label': '阅读',
    'ppn_market_bookmark': '收藏',
    'ppn_market_share': '分享',
    'ppn_market_download': '下载报告',
    'ppn_market_view_details': '查看详情',
    'ppn_market_no_results': '暂无相关市场分析',

    'ppn_market_analysis_1_title': '2024年生物农药市场趋势分析',
    'ppn_market_analysis_1_summary': '生物农药市场需求持续增长，市场规模预计突破500亿元',
    'ppn_market_analysis_1_content': '随着环保要求的提高和绿色防控理念的普及，生物农药市场需求持续增长。预计2024年市场规模将达到520亿元，年增长率保持在15%以上。企业需要加强研发投入，拓展高效、低残留的绿色产品。',
    'ppn_market_analysis_1_market_size': '520亿元',
    'ppn_market_analysis_1_growth_rate': '15.2%',
    'ppn_market_analysis_1_forecast': '2024-2026',

    'ppn_market_analysis_2_title': '智能植保设备市场发展报告',
    'ppn_market_analysis_2_summary': '无人机植保设备市场快速增长，智能化成为主要趋势',
    'ppn_market_analysis_2_content': '智能植保设备市场呈现快速增长态势，其中无人机植保设备表现突出。预计2024年市场规模将达到180亿元，智能化、精准化成为主要发展方向。企业需重点布局自动化与数据分析能力。',
    'ppn_market_analysis_2_market_size': '180亿元',
    'ppn_market_analysis_2_growth_rate': '25.8%',
    'ppn_market_analysis_2_forecast': '2024-2026',

    'ppn_market_analysis_3_title': '有机肥料市场供需分析',
    'ppn_market_analysis_3_summary': '有机肥料市场需求旺盛，供应缺口持续扩大',
    'ppn_market_analysis_3_content': '随着有机农业的快速发展，有机肥料市场需求旺盛。当前市场供应缺口约30%，预计未来三年内供需矛盾将进一步加剧。企业需提高产能并完善质量管理体系。',
    'ppn_market_analysis_3_market_size': '320亿元',
    'ppn_market_analysis_3_growth_rate': '18.5%',
    'ppn_market_analysis_3_forecast': '2024-2026',

    'ppn_market_analysis_4_title': '转基因种子市场政策影响分析',
    'ppn_market_analysis_4_summary': '政策调整对转基因种子市场产生重大影响',
    'ppn_market_analysis_4_content': '近期政策调整对转基因种子市场产生重大影响，市场格局面临重新洗牌。企业需要积极应对政策变化，调整市场策略并强化合规管理。',
    'ppn_market_analysis_4_market_size': '450亿元',
    'ppn_market_analysis_4_growth_rate': '8.3%',
    'ppn_market_analysis_4_forecast': '2024-2026',

    'ppn_market_analysis_5_title': '生物技术产品市场前景展望',
    'ppn_market_analysis_5_summary': '生物技术产品市场前景广阔，投资热度持续升温',
    'ppn_market_analysis_5_content': '生物技术产品市场前景广阔，尤其在基因编辑、生物育种等领域。投资热度持续升温，预计未来五年将迎来爆发式增长，建议关注核心技术研发与产业化布局。',
    'ppn_market_analysis_5_market_size': '280亿元',
    'ppn_market_analysis_5_growth_rate': '22.1%',
    'ppn_market_analysis_5_forecast': '2024-2026',

    'ppn_market_author_research': '市场研究部',
    'ppn_market_author_equipment': '设备分析中心',
    'ppn_market_author_fertilizer': '肥料研究所',
    'ppn_market_author_policy': '政策研究中心',
    'ppn_market_author_biotech': '生物技术研究院',

    'ppn_market_tag_bio_pesticide': '生物农药',
    'ppn_market_tag_market_trend': '市场趋势',
    'ppn_market_tag_green_control': '绿色防控',
    'ppn_market_tag_smart_equipment': '智能设备',
    'ppn_market_tag_uav': '无人机',
    'ppn_market_tag_precision_agriculture': '精准农业',
    'ppn_market_tag_organic_fertilizer': '有机肥料',
    'ppn_market_tag_supply_demand': '供需分析',
    'ppn_market_tag_organic_farming': '有机农业',
    'ppn_market_tag_gm': '转基因',
    'ppn_market_tag_policy': '政策影响',
    'ppn_market_tag_market_adjustment': '市场调整',
    'ppn_market_tag_biotech': '生物技术',
    'ppn_market_tag_gene_editing': '基因编辑',
    'ppn_market_tag_investment_outlook': '投资前景',

    'ppn_market_download_header': '市场分析报告',
    'ppn_market_download_title_label': '标题：',
    'ppn_market_download_summary_label': '摘要：',
    'ppn_market_download_category_label': '分类：',
    'ppn_market_download_publish_label': '发布时间：',
    'ppn_market_download_author_label': '作者：',
    'ppn_market_download_market_size_label': '市场规模：',
    'ppn_market_download_growth_label': '增长率：',
    'ppn_market_download_forecast_label': '预测周期：',
    'ppn_market_download_detail_label': '详细内容：',
    'ppn_market_download_detail_placeholder': '详细内容请查看完整报告。',
    'ppn_market_download_tags_label': '标签：',
    'ppn_market_download_generated_label': '报告生成时间：',
    'ppn_market_download_success': '分析报告"{title}"下载成功！',
    // Data Statistics Page
    'ppn_data_statistics_page_title': '数据统计',
    'ppn_data_statistics_page_subtitle': '植保行业数据统计、趋势分析、报告下载',
    'ppn_data_statistics_search_placeholder': '搜索数据统计...',
    'ppn_data_statistics_category_all': '全部',
    'ppn_data_statistics_category_production': '生产统计',
    'ppn_data_statistics_category_market': '市场统计',
    'ppn_data_statistics_category_trade': '贸易统计',
    'ppn_data_statistics_category_consumption': '消费统计',
    'ppn_data_statistics_category_policy': '政策统计',
    'ppn_data_statistics_category_research': '科研统计',
    'ppn_data_statistics_data_period': '数据周期',
    'ppn_data_statistics_data_source': '数据来源',
    'ppn_data_statistics_file_size': '文件大小',
    'ppn_data_statistics_views_label': '阅读',
    'ppn_data_statistics_downloads_label': '下载',
    'ppn_data_statistics_author_label': '编制单位',
    'ppn_data_statistics_download': '下载报告',
    'ppn_data_statistics_view_details': '查看详情',
    'ppn_data_statistics_bookmark': '收藏',
    'ppn_data_statistics_share': '分享',
    'ppn_data_statistics_no_results': '暂无相关数据统计',
    'ppn_data_statistics_period_label': '统计周期',
    'ppn_data_statistics_period_day': '日',
    'ppn_data_statistics_period_week': '周',
    'ppn_data_statistics_period_month': '月',
    'ppn_data_statistics_period_year': '年',
    'ppn_data_statistics_trend_analysis': '趋势分析图表',
    'ppn_data_statistics_category_distribution': '数据类型分布',
    'ppn_data_statistics_key_metric_total': '总数据量',
    'ppn_data_statistics_key_metric_production': '生产数据',
    'ppn_data_statistics_key_metric_market': '市场数据',
    'ppn_data_statistics_key_metric_trade': '贸易数据',
    'ppn_data_statistics_key_metric_consumption': '消费数据',
    'ppn_data_statistics_key_metric_avg_growth': '平均增长率',
    'ppn_data_statistics_change_from_previous': '较上期',
    'ppn_statistics_type_production': '生产统计',
    'ppn_statistics_type_sales': '销售统计',
    'ppn_statistics_type_pest': '病虫害统计',
    'ppn_statistics_type_prevention': '防治统计',
    'ppn_data_source': '数据来源',
    'ppn_update_time': '更新时间',
    'ppn_total_records': '总记录数',

    'ppn_data_statistics_1_title': '2024年植保产品生产统计报告',
    'ppn_data_statistics_1_summary': '全面分析2024年植保产品生产情况，包括产量、产值和区域分布',
    'ppn_data_statistics_1_content': '2024年植保产品生产总体保持稳定增长态势，总产量达到280万吨，同比增长8.5%。其中生物农药产量增长最快，达到45万吨，同比增长25%。',
    'ppn_data_statistics_1_period': '2024年全年',
    'ppn_data_statistics_1_source': '国家统计局',
    'ppn_data_statistics_1_file_size': '2.5MB',
    'ppn_data_statistics_1_author': '统计信息中心',
    'ppn_data_statistics_2_title': '植保产品进出口贸易数据分析',
    'ppn_data_statistics_2_summary': '详细分析植保产品进出口贸易情况，包括贸易额、主要贸易伙伴和趋势',
    'ppn_data_statistics_2_content': '2024年植保产品进出口贸易总额达到180亿美元，其中出口120亿美元，进口60亿美元。主要出口市场为东南亚、南美和非洲地区。',
    'ppn_data_statistics_2_period': '2024年全年',
    'ppn_data_statistics_2_source': '海关总署',
    'ppn_data_statistics_2_file_size': '1.8MB',
    'ppn_data_statistics_2_author': '贸易分析部',

    'ppn_data_statistics_3_title': '植保产品消费市场调研报告',
    'ppn_data_statistics_3_summary': '基于大数据的植保产品消费行为分析和市场趋势预测',
    'ppn_data_statistics_3_content': '全国主要农业产区调研显示，生物农药使用比例逐年提高，精准用药意识增强，绿色防控需求明显增长。',
    'ppn_data_statistics_3_period': '2024年Q4',
    'ppn_data_statistics_3_source': '市场调研',
    'ppn_data_statistics_3_file_size': '3.2MB',
    'ppn_data_statistics_3_author': '市场调研中心',

    'ppn_data_statistics_4_title': '植保政策实施效果评估报告',
    'ppn_data_statistics_4_summary': '评估各项植保政策的实施效果，为政策调整提供数据支撑',
    'ppn_data_statistics_4_content': '绿色防控、农药减量、统防统治等政策实施效果显著，但仍需加强协同监管和技术推广。',
    'ppn_data_statistics_4_period': '2023-2024年',
    'ppn_data_statistics_4_source': '政策评估',
    'ppn_data_statistics_4_file_size': '2.1MB',
    'ppn_data_statistics_4_author': '政策评估中心',
    'ppn_data_statistics_5_source': '科技部',
    'ppn_data_statistics_5_file_size': '1.5MB',
    'ppn_data_statistics_5_author': 'Research Statistics Center',
    'ppn_data_statistics_tag_production': 'Production',
    'ppn_data_statistics_tag_output': 'Output Analysis',
    'ppn_data_statistics_tag_distribution': 'Regional Distribution',
    'ppn_data_statistics_tag_trade': 'Trade',
    'ppn_data_statistics_tag_import_export': 'Import & Export',
    'ppn_data_statistics_tag_market_analysis': 'Market Analysis',
    'ppn_data_statistics_tag_consumption': 'Consumption',
    'ppn_data_statistics_tag_market_research': 'Market Research',
    'ppn_data_statistics_tag_behavior': 'Behavior Analysis',
    'ppn_data_statistics_tag_policy': 'Policy Assessment',
    'ppn_data_statistics_tag_implementation': 'Implementation Effect',
    'ppn_data_statistics_tag_data_support': 'Data Support',
    'ppn_data_statistics_tag_research': 'Research',
    'ppn_data_statistics_tag_investment': 'Investment',
    'ppn_data_statistics_tag_transformation': 'Technology Transfer',
    'ppn_data_statistics_download_header': '数据统计报告',
    'ppn_data_statistics_download_title_label': '标题：',
    'ppn_data_statistics_download_summary_label': '摘要：',
    'ppn_data_statistics_download_category_label': '分类：',
    'ppn_data_statistics_download_publish_label': '发布时间：',
    'ppn_data_statistics_download_author_label': '编制单位：',
    'ppn_data_statistics_download_period_label': '数据周期：',
    'ppn_data_statistics_download_source_label': '数据来源：',
    'ppn_data_statistics_download_size_label': '文件大小：',
    'ppn_data_statistics_download_detail_label': '详细内容：',
    'ppn_data_statistics_download_detail_placeholder': '详细内容请查看完整报告。',
    'ppn_data_statistics_download_tags_label': '标签：',
    'ppn_data_statistics_download_generated_label': '报告生成时间：',
    'ppn_data_statistics_download_success': '报告"{title}"下载成功！',

    // Water Resources Page
    'ppn_water_resources_page_title': '水资源分析',
    'ppn_water_resources_page_subtitle': '分析水文数据，评估水资源状况',
    'ppn_water_quality': '水质',
    'ppn_water_level': '水位',
    'ppn_irrigation_status': '灌溉状况',
    'wr_filter_region_all': '全部地区',
    'wr_region_north': '华北平原',
    'wr_region_central': '长江中下游',
    'wr_region_northwest': '西北地区',
    'wr_region_south': '华南地区',
    'wr_filter_water_type_all': '全部水源类型',
    'wr_water_type_groundwater': '地下水',
    'wr_water_type_surface': '地表水',
    'wr_water_type_rainwater': '雨水',
    'wr_clear_filters': '清除筛选',
    'wr_current_filters': '当前筛选：',
    'wr_records_found': '共找到 {count} 条记录',
    'switch_to_en': '切换到英文',
    'switch_to_zh': '切换到中文',
    'wr_status_excellent': '优秀',
    'wr_status_good': '良好',
    'wr_status_warning': '需改善',
    'wr_status_poor': '较差',
    'wr_status_unknown': '未知',
    'wr_metric_ph_title': '平均pH值',
    'wr_metric_ph_range': '适宜范围: {range}',
    'wr_metric_conductivity_title': '电导率',
    'wr_metric_conductivity_target': '目标: {target}',
    'wr_metric_hardness_title': '硬度',
    'wr_metric_hardness_range': '适宜范围: {range}',
    'wr_metric_nitrate_title': '硝酸盐',
    'wr_metric_nitrate_standard': '标准: {standard}',
    'wr_analysis_detail_title': '水资源分析详情',
    'wr_column_region': '地区',
    'wr_column_water_type': '水源类型',
    'wr_column_ph': 'pH值',
    'wr_column_conductivity': '电导率(μS/cm)',
    'wr_column_hardness': '硬度(mg/L)',
    'wr_column_nitrate': '硝酸盐(mg/L)',
    'wr_column_status': '水质状况',
    'wr_management_suggestions_title': '水资源管理建议',
    'wr_recommendation_north_1': '定期监测',
    'wr_recommendation_north_2': '合理开采',
    'wr_recommendation_north_3': '保护水源',
    'wr_recommendation_central_1': '保持水质',
    'wr_recommendation_central_2': '生态修复',
    'wr_recommendation_central_3': '污染防控',
    'wr_recommendation_northwest_1': '降低硬度',
    'wr_recommendation_northwest_2': '减少盐分',
    'wr_recommendation_northwest_3': '改善水质',
    'wr_recommendation_south_1': '收集利用',
    'wr_recommendation_south_2': '净化处理',
    'wr_recommendation_south_3': '生态保护',
    'recommendations': '建议',
    'recommendations_placeholder': '请输入建议，每行一条',
    'remarks': '备注',
    'remarks_placeholder': '请输入备注信息',

    // Seasonal Guidance Page
    'ppn_seasonal_guidance_page_title': '季节性指导',
    'ppn_seasonal_guidance_page_subtitle': '按季节提供植保建议和注意事项',
    'ppn_season_spring': '春季',
    'ppn_season_summer': '夏季',
    'ppn_season_autumn': '秋季',
    'ppn_season_winter': '冬季',
    'ppn_current_season': '当前季节',
    'seasonal_guidance_title': '季节性指导',
    'seasonal_guidance_subtitle': '按季节提供植保建议和注意事项，科学安排植保作业',
    'seasonal_guidance_add_button': '新增指导',
    'seasonal_guidance_select_season': '选择季节',
    'seasonal_guidance_current_season_badge': '当前季节',
    'seasonal_guidance_crop_label': '作物类型',
    'seasonal_guidance_region_label': '地区',
    'seasonal_guidance_search_label': '搜索',
    'seasonal_guidance_search_placeholder': '搜索标题、内容或作者...',
    'seasonal_guidance_current_filters': '当前筛选：',
    'seasonal_guidance_search_tag': '搜索: {keyword}',
    'seasonal_guidance_clear_filters': '清除筛选',
    'seasonal_guidance_records_found': '共找到 {count} 条记录',
    'seasonal_guidance_list_title': '指导列表',
    'seasonal_guidance_loading': '加载中...',
    'seasonal_guidance_empty': '暂无指导数据',
    'seasonal_guidance_author_label': '作者: {author}',
    'seasonal_guidance_created_at_label': '创建时间: {date}',
    'seasonal_guidance_updated_at_label': '更新时间: {date}',
    'seasonal_guidance_view': '查看详情',
    'seasonal_guidance_edit': '编辑',
    'seasonal_guidance_delete': '删除',
    'seasonal_guidance_delete_confirm': '确定要删除这个指导吗？',
    'seasonal_guidance_delete_success': '指导删除成功！',
    'seasonal_guidance_delete_failed': '删除指导失败，请重试！',
    'seasonal_guidance_add_success': '指导添加成功！',
    'seasonal_guidance_add_failed': '添加指导失败，请重试！',
    'seasonal_guidance_update_success': '指导更新成功！',
    'seasonal_guidance_update_failed': '更新指导失败，请重试！',
    'seasonal_guidance_form_incomplete': '请填写完整的指导信息！',
    'seasonal_guidance_form_heading_edit': '编辑指导',
    'seasonal_guidance_form_heading_create': '新增指导',
    'seasonal_guidance_form_title_label': '标题 *',
    'seasonal_guidance_form_title_placeholder': '请输入指导标题',
    'seasonal_guidance_form_season_label': '季节 *',
    'seasonal_guidance_form_crop_label': '作物类型 *',
    'seasonal_guidance_form_region_label': '地区 *',
    'seasonal_guidance_form_author_label': '作者 *',
    'seasonal_guidance_form_author_placeholder': '请输入作者姓名',
    'seasonal_guidance_form_content_label': '指导内容 *',
    'seasonal_guidance_form_content_placeholder': '请输入详细的指导内容...',
    'seasonal_guidance_form_cancel': '取消',
    'seasonal_guidance_form_submit_update': '更新',
    'seasonal_guidance_form_submit_create': '创建',
    'seasonal_guidance_validation_title': '请输入指导标题！',
    'seasonal_guidance_validation_content': '请输入指导内容！',
    'seasonal_guidance_validation_author': '请输入作者姓名！',
    'seasonal_guidance_submit_failed': '提交失败，请重试！',
    'seasonal_guidance_init_failed': '页面加载失败，请刷新页面重试！',
    'seasonal_crop_all': '全部作物',
    'seasonal_crop_grain': '粮食作物',
    'seasonal_crop_economic': '经济作物',
    'seasonal_crop_vegetable': '蔬菜作物',
    'seasonal_crop_fruit': '果树作物',
    'seasonal_region_all': '全国',
    'seasonal_region_north': '华北',
    'seasonal_region_northeast': '东北',
    'seasonal_region_east': '华东',
    'seasonal_region_central': '华中',
    'seasonal_region_south': '华南',
    'seasonal_region_southwest': '西南',
    'seasonal_region_northwest': '西北',
    'seasonal_guidance_item_spring_wheat_title': '春季小麦种植指导',
    'seasonal_guidance_item_spring_wheat_content': '春季是小麦生长的关键时期，需要注意以下几点：1. 及时浇水，保持土壤湿润；2. 合理施肥，促进分蘖；3. 防治病虫害，特别是蚜虫和锈病。',
    'seasonal_guidance_item_summer_rice_title': '夏季水稻管理要点',
    'seasonal_guidance_item_summer_rice_content': '夏季高温多雨，水稻管理要点：1. 控制水位，防止倒伏；2. 及时除草，减少杂草竞争；3. 防治稻飞虱和纹枯病。',
    'seasonal_guidance_item_autumn_fruit_title': '秋季果树修剪技术',
    'seasonal_guidance_item_autumn_fruit_content': '秋季果树修剪技术要点：1. 疏除过密枝条，改善通风透光；2. 短截结果枝，促进花芽分化；3. 防治病虫害，保护树体健康。',
    'seasonal_guidance_item_winter_vegetable_title': '冬季蔬菜大棚管理',
    'seasonal_guidance_item_winter_vegetable_content': '冬季蔬菜大棚管理要点：1. 控制温度，防止冻害；2. 合理通风，减少病害；3. 补充光照，促进生长。',

    // Planting Advice Page
    'ppn_planting_advice_page_title': '种植建议',
    'ppn_planting_advice_page_subtitle': '基于气候、土壤、水文数据提供种植建议',
    'ppn_suitable_crops': '适宜作物',
    'ppn_planting_time': '种植时间',
    'ppn_management_points': '管理要点',
    'planting_filter_region_all': '全部地区',
    'planting_region_north': '华北平原',
    'planting_region_central': '长江中下游',
    'planting_region_northeast': '东北地区',
    'planting_region_south': '华南地区',
    'planting_filter_crop_all': '全部作物',
    'planting_crop_wheat': '小麦',
    'planting_crop_rice': '水稻',
    'planting_crop_corn': '玉米',
    'planting_crop_soybean': '大豆',
    'planting_clear_filters': '清除筛选',
    'planting_current_filters': '当前筛选：',
    'planting_records_found': '共找到 {count} 条记录',
    'planting_overview_suitable_title': '适宜种植',
    'planting_overview_suitable_desc': '种作物适宜当前季节',
    'planting_overview_focus_title': '重点关注',
    'planting_overview_focus_desc': '个地区需要特别关注',
    'planting_overview_pest_title': '病虫害预警',
    'planting_overview_pest_desc': '种病虫害需要预防',
    'planting_overview_weather_title': '天气适宜',
    'planting_overview_weather_desc': '的地区天气适宜种植',
    'planting_details_title': '种植建议详情',
    'planting_loading': '加载中...',
    'planting_season_advice': '{season}种植建议',
    'planting_soil_section_title': '土壤条件',
    'planting_water_section_title': '水分条件',
    'planting_climate_section_title': '气候条件',
    'planting_recommendations_title': '种植建议',
    'planting_pest_prevention_title': '病虫害预防',
    'planting_soil_good': '良好',
    'planting_soil_excellent': '优秀',
    'planting_water_adequate': '充足',
    'planting_water_moderate': '一般',
    'planting_climate_suitable': '适宜',
    'planting_condition_unknown': '未知',
    'planting_priority_high': '高优先级',
    'planting_priority_medium': '中优先级',
    'planting_priority_low': '低优先级',
    'planting_priority_unknown': '未知',
    'planting_rec_select_resistant': '选择抗病品种',
    'planting_rec_timely_sowing': '适时播种',
    'planting_rec_reasonable_density': '合理密植',
    'planting_rec_scientific_fertilization': '科学施肥',
    'planting_rec_timely_irrigation': '及时灌溉',
    'planting_rec_select_quality_varieties': '选择优质品种',
    'planting_rec_timely_transplanting': '适时插秧',
    'planting_rec_scientific_irrigation': '科学灌溉',
    'planting_rec_pest_management': '病虫害防治',
    'planting_rec_select_early_maturing': '选择早熟品种',
    'planting_rec_timely_weeding': '及时除草',
    'planting_rec_select_high_yield': '选择高产品种',
    'planting_pest_wheat_stripe_rust': '预防条锈病',
    'planting_pest_control_aphids': '防治蚜虫',
    'planting_pest_monitor_powdery_mildew': '监控白粉病',
    'planting_pest_prevent_rice_blast': '预防稻瘟病',
    'planting_pest_control_planthopper': '防治稻飞虱',
    'planting_pest_monitor_sheath_blight': '监控纹枯病',
    'planting_pest_prevent_corn_borer': '预防玉米螟',
    'planting_pest_control_armyworm': '防治粘虫',
    'planting_pest_monitor_leaf_blight': '监控大斑病',
    'planting_pest_prevent_soybean_phytophthora': '预防大豆疫病',
    'planting_pest_control_pod_borer': '防治豆荚螟',
    'planting_pest_monitor_downy_mildew': '监控霜霉病',

    // Safe Pesticide Use Page
    'ppn_safe_pesticide_page_title': '安全用药',
    'ppn_safe_pesticide_page_subtitle': '农药安全使用指南、中毒急救、防护措施',
    'safe_pesticide_title': '安全用药指南',
    'safe_pesticide_subtitle': '农药安全使用指南、中毒急救、防护措施等安全信息',
    'safe_pesticide_tab_guidelines': '安全指南',
    'safe_pesticide_tab_emergency': '中毒急救',
    'safe_pesticide_tab_protection': '防护措施',
    'safe_pesticide_search_placeholder': '搜索安全指南...',
    'safe_pesticide_filter_category_all': '全部',
    'safe_pesticide_filter_category_preparation': '使用前准备',
    'safe_pesticide_filter_category_protection': '个人防护',
    'safe_pesticide_filter_category_operation': '操作规范',
    'safe_pesticide_filter_category_interval': '安全间隔期',
    'safe_pesticide_guideline_preparation_title': '农药使用前准备',
    'safe_pesticide_guideline_preparation_item_1': '仔细阅读农药标签和使用说明',
    'safe_pesticide_guideline_preparation_item_2': '检查农药是否在有效期内',
    'safe_pesticide_guideline_preparation_item_3': '准备必要的防护装备',
    'safe_pesticide_guideline_preparation_item_4': '了解农药的毒性等级',
    'safe_pesticide_guideline_preparation_item_5': '确认天气条件适合施药',
    'safe_pesticide_guideline_protection_title': '个人防护措施',
    'safe_pesticide_guideline_protection_item_1': '穿戴防护服、手套、口罩等防护装备',
    'safe_pesticide_guideline_protection_item_2': '避免皮肤直接接触农药',
    'safe_pesticide_guideline_protection_item_3': '施药时不要吸烟、饮食',
    'safe_pesticide_guideline_protection_item_4': '施药后及时清洗身体和衣物',
    'safe_pesticide_guideline_protection_item_5': '保持工作区域通风良好',
    'safe_pesticide_guideline_operation_title': '施药操作规范',
    'safe_pesticide_guideline_operation_item_1': '按照推荐剂量使用，不要超量',
    'safe_pesticide_guideline_operation_item_2': '避免在风力较大时施药',
    'safe_pesticide_guideline_operation_item_3': '注意施药方向和距离',
    'safe_pesticide_guideline_operation_item_4': '避免农药飘散到非目标区域',
    'safe_pesticide_guideline_operation_item_5': '施药后做好记录',
    'safe_pesticide_guideline_interval_title': '安全间隔期',
    'safe_pesticide_guideline_interval_item_1': '严格遵守安全间隔期',
    'safe_pesticide_guideline_interval_item_2': '收获前停止使用农药',
    'safe_pesticide_guideline_interval_item_3': '注意不同作物的安全间隔期差异',
    'safe_pesticide_guideline_interval_item_4': '记录施药时间和收获时间',
    'safe_pesticide_guideline_interval_item_5': '确保农产品安全',
    'safe_pesticide_emergency_notice_title': '紧急提醒',
    'safe_pesticide_emergency_notice_desc': '如发生农药中毒，请立即拨打急救电话或前往医院就医，不要自行处理。',
    'safe_pesticide_emergency_symptoms_title': '症状表现：',
    'safe_pesticide_emergency_treatment_title': '急救措施：',
    'safe_pesticide_emergency_skin_title': '皮肤接触中毒',
    'safe_pesticide_emergency_skin_symptom_1': '皮肤发红',
    'safe_pesticide_emergency_skin_symptom_2': '瘙痒',
    'safe_pesticide_emergency_skin_symptom_3': '灼烧感',
    'safe_pesticide_emergency_skin_symptom_4': '起泡',
    'safe_pesticide_emergency_skin_treatment_1': '立即脱去污染的衣物',
    'safe_pesticide_emergency_skin_treatment_2': '用大量清水冲洗皮肤',
    'safe_pesticide_emergency_skin_treatment_3': '不要使用肥皂或清洁剂',
    'safe_pesticide_emergency_skin_treatment_4': '及时就医治疗',
    'safe_pesticide_emergency_inhale_title': '吸入中毒',
    'safe_pesticide_emergency_inhale_symptom_1': '头晕',
    'safe_pesticide_emergency_inhale_symptom_2': '恶心',
    'safe_pesticide_emergency_inhale_symptom_3': '呼吸困难',
    'safe_pesticide_emergency_inhale_symptom_4': '咳嗽',
    'safe_pesticide_emergency_inhale_treatment_1': '立即离开污染区域',
    'safe_pesticide_emergency_inhale_treatment_2': '呼吸新鲜空气',
    'safe_pesticide_emergency_inhale_treatment_3': '保持呼吸道通畅',
    'safe_pesticide_emergency_inhale_treatment_4': '及时就医治疗',
    'safe_pesticide_emergency_ingest_title': '误食中毒',
    'safe_pesticide_emergency_ingest_symptom_1': '腹痛',
    'safe_pesticide_emergency_ingest_symptom_2': '恶心呕吐',
    'safe_pesticide_emergency_ingest_symptom_3': '腹泻',
    'safe_pesticide_emergency_ingest_symptom_4': '意识模糊',
    'safe_pesticide_emergency_ingest_treatment_1': '不要催吐',
    'safe_pesticide_emergency_ingest_treatment_2': '立即就医',
    'safe_pesticide_emergency_ingest_treatment_3': '携带农药包装',
    'safe_pesticide_emergency_ingest_treatment_4': '告知医生中毒情况',
    'safe_pesticide_protection_equipment_title': '防护装备选择',
    'safe_pesticide_protection_equipment_item_1': '防护服：选择防渗透材料',
    'safe_pesticide_protection_equipment_item_2': '手套：使用化学防护手套',
    'safe_pesticide_protection_equipment_item_3': '口罩：选择防毒面具或N95口罩',
    'safe_pesticide_protection_equipment_item_4': '护目镜：防止农药溅入眼睛',
    'safe_pesticide_protection_equipment_item_5': '靴子：防水防渗透工作靴',
    'safe_pesticide_protection_environment_title': '工作环境安全',
    'safe_pesticide_protection_environment_item_1': '保持工作区域通风良好',
    'safe_pesticide_protection_environment_item_2': '避免在密闭空间使用农药',
    'safe_pesticide_protection_environment_item_3': '设置警示标志',
    'safe_pesticide_protection_environment_item_4': '准备应急处理设备',
    'safe_pesticide_protection_environment_item_5': '建立安全操作规程',
    'safe_pesticide_protection_storage_title': '农药储存安全',
    'safe_pesticide_protection_storage_item_1': '存放在专用仓库',
    'safe_pesticide_protection_storage_item_2': '远离食品和饮用水',
    'safe_pesticide_protection_storage_item_3': '保持干燥通风',
    'safe_pesticide_protection_storage_item_4': '定期检查包装完整性',
    'safe_pesticide_protection_storage_item_5': '建立出入库记录',
    'ppn_usage_guide': '使用指南',
    'ppn_safety_precautions': '安全防护',
    'ppn_emergency_treatment': '急救措施',
    // Environmental Protection Page
    'ppn_environmental_page_title': '环保要求',
    'ppn_environmental_page_subtitle': '环境友好型防治方法、农药环境影响评估',
    'ppn_eco_friendly_methods': '环保方法',
    'ppn_environmental_impact': '环境影响',

    // Research Progress Page
    'ppn_research_page_title': '科研进展',
    'ppn_research_page_subtitle': '植保科研最新成果、技术突破、发展趋势',

    // Network Trend Analysis Page
    'ppn_trend_analysis_page_title': '网络趋势分析',
    'ppn_trend_analysis_page_subtitle': '基于历史数据，分析病虫害发展趋势',
    'ppn_trend_period_all': '全部时期',
    'ppn_trend_period_week': '本周',
    'ppn_trend_period_month': '本月',
    'ppn_trend_period_quarter': '本季度',
    'ppn_trend_period_year': '本年',
    'ppn_trend_clear_filters': '清除筛选',
    'ppn_trend_current_filters': '当前筛选条件：',
    'ppn_trend_records_found': '找到 {count} 条记录',
    'ppn_trend_overall_card_title': '总体趋势',
    'ppn_trend_avg_change_label': '平均变化率',
    'ppn_trend_active_card_title': '活跃害虫',
    'ppn_trend_active_card_desc': '符合当前筛选条件',
    'ppn_trend_high_card_title': '高严重程度',
    'ppn_trend_high_card_desc': '需要关注',
    'ppn_trend_table_title': '害虫趋势详情',
    'ppn_trend_table_name': '害虫名称',
    'ppn_trend_table_trend': '趋势',
    'ppn_trend_table_change': '变化率',
    'ppn_trend_table_region': '地区',
    'ppn_trend_table_severity': '严重程度',
    'ppn_trend_value_up': '上升',
    'ppn_trend_value_down': '下降',
    'ppn_trend_value_stable': '稳定',
    'ppn_trend_severity_high': '高',
    'ppn_trend_severity_medium': '中',
    'ppn_trend_severity_low': '低',
    'ppn_trend_loading': '加载中...',
    'ppn_trend_toggle_light': '切换到浅色模式',
    'ppn_trend_toggle_dark': '切换到深色模式',
    'ppn_trend_pest_rice_planthopper': '稻飞虱',
    'ppn_trend_pest_corn_borer': '玉米螟',
    'ppn_trend_pest_wheat_rust': '小麦条锈病',
    'ppn_trend_pest_cotton_bollworm': '棉铃虫',
    'ppn_trend_pest_aphids': '蚜虫',
    'ppn_trend_data_type_all': '全部类型',
    'ppn_trend_data_type_pest': '虫害',
    'ppn_trend_data_type_disease': '病害',
    'ppn_trend_data_type_weather': '气象',
    'ppn_trend_data_type_market': '市场',
    'ppn_trend_chart_line_title': '趋势折线图',
    'ppn_trend_chart_area_title': '趋势面积图',
    'ppn_trend_chart_bar_title': '趋势柱状图',
    'ppn_trend_chart_total': '总计',
    'ppn_trend_no_data': '暂无数据',

    // Common Actions
    'ppn_filter': '筛选',
    'ppn_reset': '重置',
    'ppn_export': '导出',
    'ppn_print': '打印',
    'ppn_refresh': '刷新',

    // Welcome Page
    'welcome_greeting': '你好',
    'welcome_guest': '农友',
    'welcome_subtitle': '今日农情驾驶舱',
    'welcome_inquiry_count': '问询',
    'welcome_pest_count': '病虫害',
    'welcome_knowledge_count': '知识库',
    'welcome_default_location': '使用默认位置，点击重新定位',
    'welcome_relocate': '重新定位',
    'welcome_solar_term': '节气',
    'welcome_hou': '候',
    'welcome_ai_diagnosis': 'AI诊断',
    'welcome_plant_protection_mgmt': '植保管理',
    'welcome_plant_advice': '植保建议',
    'welcome_agri_mall': '农资商城',
    'welcome_knowledge_base': '知识库',
    'welcome_equipment_mgmt': '设备管理',
    'welcome_weather_forecast': '天气预报',
    'welcome_quick_nav': '快捷导航',
    'welcome_location_failed': '定位失败',
    'welcome_allow_location': '请在浏览器设置中允许位置访问，或点击下方按钮重新定位',
    
    // Weather
    'weather_temperature': '温度',
    'weather_humidity': '湿度',
    'weather_wind': '风况',
    'weather_sunrise': '日出',
    'weather_wind_force_unit': '级',
    'weather_sunset': '日落',
    'weather_unknown': '未知',
    'weather_current': '当前天气',
    'weather_sunny': '晴',
    'weather_cloudy': '多云',
    'weather_rainy': '雨',
    'weather_snowy': '雪',
    'weather_thunderstorm': '雷阵雨',
    'weather_trend_15days': '气象趋势',
    'weather_temp_high': '最高温度',
    'weather_temp_low': '最低温度',
    'weather_wind_force': '风力',
    
    // Plant Protection
    'plant_protection_advice': '植保建议',
    'plant_protection_warning': '病虫害预警',
    'plant_protection_inquiry': 'AI智能服务',
    'plant_protection_no_data': '暂无',
    'plant_protection_upload': '上传',
    'plant_protection_inquire': '问询',
    'plant_protection_placeholder': '粘贴图片或询问任何植保问题',

    // Equipment Management
    'equipment_mgmt_title': '设备管理',
    'equipment_name': '设备名称',
    'equipment_type': '设备类型',
    'equipment_status': '设备状态',
    'equipment_location': '所在位置',
    'equipment_operator': '操作员',
    'equipment_fuel_level': '燃油量',
    'equipment_working_hours': '工作小时',
    'last_maintenance': '上次维护',
    'next_maintenance': '下次维护',
    'equipment_tractor': '拖拉机',
    'equipment_seeder': '播种机',
    'equipment_harvester': '收割机',
    'equipment_irrigation': '灌溉设备',
    'equipment_other': '其他',
    'status_operational': '运行中',
    'status_maintenance': '维护中',
    'status_idle': '闲置',
    'status_broken': '故障',
    'add_equipment': '添加设备',
    'maintenance_record': '维护记录',

    // Knowledge Base
    'knowledge_base_title': '知识库',
    'knowledge_search': '搜索知识...',
    'knowledge_category': '知识分类',
    'knowledge_all': '全部知识',
    'knowledge_pest_disease': '病虫害',
    'knowledge_fertilizer': '施肥技术',
    'knowledge_irrigation': '灌溉技术',
    'knowledge_crop_protection': '作物保护',
    'knowledge_soil': '土壤管理',
    'knowledge_detail': '知识详情',
    'related_knowledge': '相关知识',
    'knowledge_added': '添加时间',

    // Mall
    'mall_title': '植保商城',
    'mall_product': '商品',
    'mall_category': '分类',
    'mall_price': '价格',
    'mall_stock': '库存',
    'mall_sales': '销量',
    'mall_add_to_cart': '加入购物车',
    'mall_buy_now': '立即购买',
    'mall_cart': '购物车',
    'mall_order': '订单',
    'mall_my_orders': '我的订单',
    'mall_product_detail': '商品详情',
    'mall_search_placeholder': '搜索商品、品牌或关键字...',
    'mall_all_categories': '全部分类',
    'mall_pesticide': '农药',
    'mall_fertilizer': '肥料',
    'mall_seed': '种子',
    'mall_equipment': '设备',
    'mall_tools': '工具',
    'mall_my_favorites': '我的收藏',
    'mall_my_mall': '我的商城',
    'mall_management_title': '商城管理',
    'mall_min_price': '最低价',
    'mall_max_price': '最高价',
    'mall_all_time': '全部时间',
    'mall_last_7_days': '近7天',
    'mall_last_30_days': '近30天',
    'mall_last_90_days': '近90天',
    'mall_sort_comprehensive': '综合排序',
    'mall_sort_sales': '销量优先',
    'mall_sort_price_asc': '价格从低到高',
    'mall_sort_price_desc': '价格从高到低',
    'mall_sort_latest': '上新排序',
    'mall_in_stock_only': '仅看有货',
    'mall_found': '共找到',
    'mall_items': '件商品',
    'mall_keyword': '关键词：',
    'mall_filter_category': '分类:',
    'mall_filter_search': '搜索:',
    'mall_filter_price': '价格:',
    'mall_filter_listing': '上架:',
    'mall_filter_days': '近{days}天',
    'mall_filter_in_stock': '仅现货',
    'mall_temp_cart': '临时购物车',
    'mall_temp_cart_desc': '登录后可同步到账号',
    'mall_view_cart': '查看',
    'mall_price_update': '价格有更新',
    'mall_price_changed_msg': '商品价格已发生变化，请确认后再提交订单。',
    'mall_refresh_price': '刷新价格',
    'mall_favorites_page': '收藏页面',
    'mall_back_to_all': '返回全部商品',
    'mall_badge_new': '新品',
    'mall_badge_hot': '热卖',
    'mall_badge_low_stock': '库存紧张',
    'mall_badge_out_of_stock': '缺货',
    'mall_no_favorites': '暂无收藏商品',
    'mall_no_products': '暂无商品',
    'mall_no_favorites_desc': '您还没有收藏任何商品',
    'mall_no_products_desc': '没有找到符合条件的商品',
    'mall_clear_filters': '清空筛选条件',
    'mall_stock_count': '库存 {count}',
    'mall_sales_count': '销量 {count}',
    'mall_member_price': '会员价 {price}',
    'mall_prev_page': '上一页',
    'mall_next_page': '下一页',
    'mall_page_num': '第{num}页',
    'mall_search_history': '搜索历史',
    'mall_search_suggestions': '搜索建议',
    'mall_clear_search': '清空搜索',
    'mall_remove_filter': '移除筛选',
    'mall_add_to_favorites': '收藏商品',
    'mall_remove_from_favorites': '取消收藏',
    'mall_skip_to_content': '跳到主内容',
    'mall_favorites_count': '{count} 件商品',
    'mall_uncategorized': '未分类',
    'mall_cart_merged': '临时购物车已合并到账号',
    'mall_added_to_temp_cart': '已添加到临时购物车，登录后可同步到账号',
    'mall_load_failed': '商品数据加载失败',
    'mall_invalid_user_id': '无效的用户ID: {id}，请重新登录',

    // System Management
    'system_management': '系统管理',
    'user_management': '用户管理',
    'role_management': '角色管理',
    'permission_management': '权限管理',
    'menu_management': '菜单管理',
    'tenant_management': '租户管理',
    'organization_management': '组织管理',
    'operation_log': '操作日志',
    'system_settings': '系统设置',
    'ai_settings': 'AI设置',
    'security_settings': '安全设置',

    // My Plant Protection Module
    'my_plant_protection_title': '生产管理',
    'planting_planning': '种植规划',
    'field_management': '田间管理',
    'sowing_management': '播种管理',
    'fertilization_management': '施肥管理',
    'irrigation_management': '灌溉管理',
    'weeding_management': '除草管理',
    'harvest_management': '收获管理',
    'disease_warning': '病害预警',
    'land_plot': '地块',
    'crop_variety': '作物品种',
    'planting_area': '种植面积',
    'planting_date': '种植日期',
    'expected_harvest': '预计收获',
    'growth_stage': '生长阶段',
    'task_list': '任务列表',
    'add_task': '添加任务',
    'task_name': '任务名称',
    'task_type': '任务类型',
    'task_status': '任务状态',
    'task_priority': '优先级',
    'task_assignee': '执行人',
    'task_deadline': '截止日期',
    'task_completed': '已完成',
    'task_pending': '待处理',
    'task_in_progress': '进行中',

    'nav_planting_plan': '种植计划',
    'nav_field_operation': '植保作业',
    'nav_field_task': '作业任务',
    'land_management': '地块管理',
    'field_task': '作业任务',
    'environment_monitoring': '环境监控',
    'warning_management': '预警管理',
    'nav_environment_monitoring': '土壤墒情',
    'nav_warning_management': '预警管理',
    'nav_data_visualization': '数据可视化',
    'nav_field_management': '田间管理',
    'nav_field_work_overview': '农事总览',
    'nav_field_operations': '田间作业台账',
    'nav_planting_planning': '种植计划',
    'nav_sowing_management': '播种管理',
    'nav_fertilization_management': '施肥管理',
    'nav_irrigation_management': '灌溉管理',
    'nav_smart_irrigation_hub': '智慧灌溉与监控',
    'nav_weeding_management': '除草管理',
    'nav_field_operation': '植保作业',
    'nav_disease_warning': '病害预警',
    'nav_asset_management': '资产管理',
    'nav_production_planning': '种植生产规划',
    'nav_knowledge': '知识库',
    'nav_plant_protection_mall': '农资商城',
    'nav_profile': '个人中心',
    'nav_account_settings': '账户设置',
    'nav_my_comments': '我的评论',
    'nav_my_favorites': '我的收藏',
    'nav_my_likes': '我的点赞',
    'nav_my_orders': '我的订单',
    'nav_my_shares': '我的分享',
    'nav_membership': '会员中心',
    'membership_history': '会员记录',

    // 地块管理页面 i18n（仅本页使用）
    'land_page_title': '地块管理',
    'land_page_subtitle': '管理与查看地块信息',

    'land_stat_total_count': '地块总数',
    'land_stat_total_area': '总面积',
    'land_stat_in_progress': '种植中',
    'land_stat_idle': '闲置中',
    'land_unit_block': '个地块',
    'land_unit_area': '亩',

    'land_data_source_tip': '数据来源：已开启的种植计划',

    'land_search_code': '地块编码',
    'land_search_name': '地块名称',
    'land_search_crop': '作物类型',
    'land_search_status': '种植状态',
    'land_placeholder_code': '请输入地块编码',
    'land_placeholder_name': '请输入地块名称',
    'land_placeholder_select_crop': '请选择作物类型',
    'land_placeholder_select_status': '请选择状态',

    'land_button_refresh': '刷新列表',
    'land_button_add': '新增地块',

    'land_column_code': '地块编码',
    'land_column_name': '地块名称',
    'land_column_crop': '作物',
    'land_column_area': '面积',
    'land_column_location': '位置',
    'land_column_soil': '土壤',
    'land_column_irrigation': '灌溉',
    'land_column_status': '状态',
    'land_column_planting_date': '开始日期',
    'land_column_operator': '操作人',
    'land_column_notes': '备注',
    'land_column_actions': '操作',
    'land_action_view': '查看',

    'land_status_planting': '种植中',
    'land_status_idle': '闲置',
    'land_status_fallow': '休耕',
    'land_status_constructing': '建设中',

    'land_soil_loam': '壤土',
    'land_soil_sandy': '沙土',
    'land_soil_clay': '黏土',
    'land_soil_silt': '粉砂土',
    'land_soil_black': '黑土',

    'land_irrigation_spray': '喷灌',
    'land_irrigation_drip': '滴灌',
    'land_irrigation_furrow': '沟灌',
    'land_irrigation_flood': '漫灌',
    'land_irrigation_none': '无',

    'land_unknown_name': '未知地块',
    'land_unknown_crop': '未知作物',
    'land_unknown_location': '未知位置',
    'land_unknown_operator': '未知操作人',
    'land_generated_notes': '系统生成备注',

    'land_load_failed': '地块数据加载失败',
    'land_delete_success': '删除成功',
    'land_delete_failed': '删除失败',
    'land_confirm_delete_message': '确定要删除这个地块吗？此操作不可恢复。',
    'land_batch_delete_empty': '请先选择要删除的地块',
    'land_batch_delete_success': '批量删除成功',
    'land_edit_success': '修改成功',
    'land_add_success': '新增成功',
    'land_default_operator': '系统',

    'land_modal_view_title': '地块详情',
    'land_modal_edit_title': '编辑地块',
    'land_modal_add_title': '新增地块',

    'land_field_code': '地块编码',
    'land_field_name': '地块名称',
    'land_field_crop': '作物类型',
    'land_field_area': '面积',
    'land_field_location': '位置',
    'land_field_soil': '土壤类型',
    'land_field_irrigation': '灌溉方式',
    'land_field_operator': '操作人',
    'land_field_notes': '备注',
    'land_field_status': '状态',
    'land_field_planting_date': '种植日期',

    'land_rule_code': '请输入地块编码',
    'land_rule_name': '请输入地块名称',
    'land_rule_crop': '请选择作物类型',
    'land_rule_area': '请输入面积',
    'land_rule_location': '请输入位置',
    'land_rule_soil': '请选择土壤类型',
    'land_rule_irrigation': '请选择灌溉方式',
    'land_rule_operator': '请输入操作人',

    'land_placeholder_area': '请输入面积',
    'land_placeholder_location': '请输入位置',
    'land_placeholder_operator': '请输入操作人',
    'land_placeholder_notes': '请输入备注',
    'land_placeholder_select_soil': '请选择土壤类型',
    'land_placeholder_select_irrigation': '请选择灌溉方式',

    'land_crop_wheat': '小麦',
    'land_crop_corn': '玉米',
    'land_crop_rice': '水稻',
    'land_crop_vegetable': '蔬菜',
    'land_crop_fruit': '水果',

    'land_pagination_total': '第{start}-{end}条，共{total}条',

    // Growth Budget page i18n
    'gb_page_title': '生长预算管理',
    'gb_page_subtitle': '作物生长测算、产量预估、成本预算分析，为种植计划提供科学依据',
    'gb_stat_total_crops': '总作物数',
    'gb_stat_total_area': '总面积',
    'gb_stat_avg_profit': '平均利润',
    'gb_stat_total_profit': '总利润',
    'gb_unit_crop_kind': '种',
    'gb_unit_mu': '亩',
    'gb_unit_yuan_per_mu': '元/亩',
    'gb_unit_yuan': '元',
    'gb_filter_crop_label': '作物类型：',
    'gb_filter_all_crops': '全部作物',
    'gb_action_add_budget': '新增预算',
    'gb_chart_growth_cycle': '生长周期预测',
    'gb_series_days_grown': '已生长天数',
    'gb_series_days_remaining': '剩余天数',
    'gb_chart_yield_profit': '产量与利润预测',
    'gb_series_expected_yield_kg': '预计产量(kg)',
    'gb_series_profit_yuan': '利润(元)',
    'gb_chart_time_analysis': '时间预测分析',
    'gb_series_days': '天数',
    'gb_key_time_nodes': '关键时间节点',
    'gb_stage_sowing_short': '播种',
    'gb_stage_heading_short': '抽穗',
    'gb_stage_harvest_short': '收获',
    'gb_stage_next_batch_short': '下一批',
    'gb_table_title': '生长预算列表',
    'gb_pagination_total': '第{start}-{end}条/总共{total}条',
    'gb_modal_edit_title': '编辑生长预算',
    'gb_modal_add_title': '新增生长预算',
    'gb_field_crop_name': '作物名称',
    'gb_field_land_name': '地块名称',
    'gb_field_planting_date': '种植日期',
    'gb_field_current_stage': '当前阶段',
    'gb_field_expected_heading': '预计抽穗时间',
    'gb_field_expected_harvest': '预计收获时间',
    'gb_field_next_planting': '下一批种植时间',
    'gb_field_growth_cycle_days': '生长周期(天)',
    'gb_field_expected_yield': '预计产量(kg/亩)',
    'gb_field_cost_per_mu': '成本(元/亩)',
    'gb_field_expected_revenue': '预期收入(元/亩)',
    'gb_field_profit_per_mu': '利润(元/亩)',
    'gb_field_notes': '备注',
    'gb_rule_crop_name': '请选择作物名称',
    'gb_rule_land_name': '请输入地块名称',
    'gb_rule_planting_date': '请选择种植日期',
    'gb_rule_current_stage': '请选择当前阶段',
    'gb_rule_expected_heading': '请选择预计抽穗时间',
    'gb_rule_expected_harvest': '请选择预计收获时间',
    'gb_rule_next_planting': '请选择下一批种植时间',
    'gb_rule_growth_cycle': '请输入生长周期',
    'gb_rule_expected_yield': '请输入预计产量',
    'gb_rule_cost_per_mu': '请输入成本',
    'gb_rule_expected_revenue': '请输入预期收入',
    'gb_rule_profit_per_mu': '请输入利润',
    'gb_placeholder_crop_name': '请选择作物名称',
    'gb_placeholder_land_name': '请输入地块名称',
    'gb_placeholder_current_stage': '请选择当前阶段',
    'gb_placeholder_days': '天数',
    'gb_placeholder_yield': '产量',
    'gb_placeholder_cost': '成本',
    'gb_placeholder_revenue': '收入',
    'gb_placeholder_profit': '利润',
    'gb_placeholder_notes': '请输入备注信息',
    'gb_crop_wheat': '小麦',
    'gb_crop_corn': '玉米',
    'gb_crop_rice': '水稻',
    'gb_crop_vegetable': '蔬菜',
    'gb_stage_sowing': '播种期',
    'gb_stage_seedling': '苗期',
    'gb_stage_tillering': '分蘖期',
    'gb_stage_jointing': '拔节期',
    'gb_stage_heading': '抽穗期',
    'gb_stage_flowering': '开花期',
    'gb_stage_filling': '灌浆期',
    'gb_stage_maturity': '成熟期',

    // Growth Budget - table columns
    'gb_column_crop_name': '作物名称',
    'gb_column_land_name': '地块名称',
    'gb_column_planting_date': '种植日期',
    'gb_column_current_stage': '当前阶段',
    'gb_column_expected_heading': '预计抽穗时间',
    'gb_column_expected_harvest': '预计收获时间',
    'gb_column_next_planting': '下一批种植',
    'gb_column_growth_cycle_days': '生长周期(天)',
    'gb_column_expected_yield_kg_per_mu': '预计产量(kg/亩)',
    'gb_column_cost_yuan_per_mu': '成本(元/亩)',
    'gb_column_expected_revenue': '预期收入(元/亩)',
    'gb_column_profit_per_mu': '利润(元/亩)',
    'gb_column_actions': '操作',

    // Warning Analysis page i18n (zh-CN)
    'wa_page_title': '预警分析管理',
    'wa_page_subtitle': '针对已种植地块的病虫害、天气等预警分析，及时发现问题并采取措施',
    'wa_stat_total': '总预警数',
    'wa_stat_pending': '待处理预警',
    'wa_stat_high_level': '高级别预警',
    'wa_stat_total_loss': '预估总损失',
    'wa_unit_item': '条',
    'wa_unit_mu': '亩',
    'wa_filter_type_label': '预警类型：',
    'wa_filter_all_types': '全部类型',
    'wa_type_pest': '病虫害预警',
    'wa_type_weather': '天气预警',
    'wa_type_growth_abnormal': '生长异常预警',
    'wa_type_soil': '土壤预警',
    'wa_type_water_fertilizer': '水肥预警',
    'wa_filter_status_label': '预警状态：',
    'wa_filter_all_status': '全部状态',
    'wa_status_pending': '待处理',
    'wa_status_processing': '处理中',
    'wa_status_resolved': '已解决',
    'wa_status_ignored': '已忽略',
    'wa_level_high': '高',
    'wa_level_medium': '中',
    'wa_level_low': '低',
    'wa_crop_wheat': '小麦',
    'wa_crop_corn': '玉米',
    'wa_crop_rice': '水稻',
    'wa_crop_vegetable': '蔬菜',
    'wa_action_add_warning': '新增预警',
    'wa_table_title': '预警列表',
    'wa_pagination_total': '第{start}-{end}条/总共{total}条',
    'wa_column_warning_code': '预警编号',
    'wa_column_warning_type': '预警类型',
    'wa_column_warning_level': '预警等级',
    'wa_column_land_name': '地块名称',
    'wa_column_crop_name': '作物名称',
    'wa_column_warning_content': '预警内容',
    'wa_column_detected_date': '检测日期',
    'wa_column_status': '状态',
    'wa_column_actions': '操作',
    'wa_modal_view_title': '预警详情',
    'wa_modal_edit_title': '编辑预警',
    'wa_modal_add_title': '新增预警',
    'wa_field_warning_code': '预警编号',
    'wa_field_warning_type': '预警类型',
    'wa_field_warning_level': '预警等级',
    'wa_field_land_name': '地块名称',
    'wa_field_crop_name': '作物名称',
    'wa_field_detected_date': '检测日期',
    'wa_field_status': '状态',
    'wa_field_priority': '优先级',
    'wa_field_warning_content': '预警内容',
    'wa_field_affected_area': '受影响面积',
    'wa_field_estimated_loss': '预估损失',
    'wa_field_suggested_action': '建议措施',
    'wa_field_operator': '操作员',
    'wa_field_notes': '备注',
    'wa_rule_warning_type': '请选择预警类型',
    'wa_rule_warning_level': '请选择预警等级',
    'wa_rule_land_name': '请输入地块名称',
    'wa_rule_crop_name': '请输入作物名称',
    'wa_rule_priority': '请选择优先级',
    'wa_rule_affected_area': '请输入受影响面积',
    'wa_rule_estimated_loss': '请输入预估损失',
    'wa_rule_status': '请选择状态',
    'wa_rule_warning_content': '请输入预警内容',
    'wa_rule_suggested_action': '请输入建议措施',
    'wa_placeholder_warning_type': '请选择预警类型',
    'wa_placeholder_warning_level': '请选择预警等级',
    'wa_placeholder_land_name': '请输入地块名称',
    'wa_placeholder_crop_name': '请输入作物名称',
    'wa_placeholder_priority': '请选择优先级',
    'wa_placeholder_area': '面积',
    'wa_placeholder_loss': '损失金额',
    'wa_placeholder_status': '请选择状态',
    'wa_placeholder_warning_content': '请输入预警内容',
    'wa_placeholder_suggested_action': '请输入建议措施',
    'wa_placeholder_notes': '请输入备注信息',

    // Expert Advice page i18n (zh-CN)
    'ea_page_title': '专家建议管理',
    'ea_page_subtitle': '基于地块和作物状态的专家建议，包含病虫害防治、水肥管理、种植技术指导等',
    'ea_stat_total': '总建议数',
    'ea_stat_active': '活跃建议',
    'ea_stat_avg_effectiveness': '平均效果评分',
    'ea_stat_total_benefit': '预估总收益',
    'ea_unit_item': '条',
    'ea_unit_score': '分',
    'ea_filter_type_label': '建议类型：',
    'ea_filter_all_types': '全部类型',
    'ea_type_pest_control': '病虫害防治',
    'ea_type_water_fertilizer': '水肥管理',
    'ea_type_planting_tech': '种植技术',
    'ea_type_environment': '环境管理',
    'ea_filter_crop_label': '作物名称：',
    'ea_filter_all_crops': '全部作物',
    'ea_action_add_advice': '新增建议',
    'ea_table_title': '专家建议列表',
    'ea_pagination_total': '第{start}-{end}条/总共{total}条',
    'ea_column_advice_code': '建议编号',
    'ea_column_advice_type': '建议类型',
    'ea_column_crop_name': '作物名称',
    'ea_column_land_name': '地块名称',
    'ea_column_expert_name': '专家姓名',
    'ea_column_advice_title': '建议标题',
    'ea_column_advice_date': '建议日期',
    'ea_column_priority': '优先级',
    'ea_column_adoption_rate': '采纳率',
    'ea_column_effectiveness': '效果评分',
    'ea_column_estimated_cost': '预估成本',
    'ea_column_estimated_benefit': '预估收益',
    'ea_column_actions': '操作',
    'ea_modal_edit_title': '编辑专家建议',
    'ea_modal_add_title': '新增专家建议',
    'ea_modal_view_title': '专家建议详情',
    'ea_field_advice_code': '建议编号',
    'ea_field_advice_type': '建议类型',
    'ea_field_crop_name': '作物名称',
    'ea_field_land_name': '地块名称',
    'ea_field_expert_name': '专家姓名',
    'ea_field_expert_title': '专家职称',
    'ea_field_advice_date': '建议日期',
    'ea_field_priority': '优先级',
    'ea_field_estimated_cost': '预估成本(元)',
    'ea_field_estimated_benefit': '预估收益(元)',
    'ea_field_advice_title': '建议标题',
    'ea_field_advice_content': '建议内容',
    'ea_field_implementation_steps': '实施步骤',
    'ea_field_precautions': '注意事项',
    'ea_field_follow_up': '后续行动',
    'ea_rule_advice_type': '请选择建议类型',
    'ea_rule_crop_name': '请选择作物名称',
    'ea_rule_land_name': '请输入地块名称',
    'ea_rule_priority': '请选择优先级',
    'ea_rule_expert_name': '请输入专家姓名',
    'ea_rule_expert_title': '请输入专家职称',
    'ea_rule_estimated_cost': '请输入预估成本',
    'ea_rule_estimated_benefit': '请输入预估收益',
    'ea_rule_advice_title': '请输入建议标题',
    'ea_rule_advice_content': '请输入建议内容',
    'ea_rule_implementation_steps': '请输入实施步骤',
    'ea_placeholder_advice_type': '请选择建议类型',
    'ea_placeholder_crop_name': '请选择作物名称',
    'ea_placeholder_land_name': '请输入地块名称',
    'ea_placeholder_priority': '请选择优先级',
    'ea_placeholder_expert_name': '请输入专家姓名',
    'ea_placeholder_expert_title': '请输入专家职称',
    'ea_placeholder_cost': '成本',
    'ea_placeholder_benefit': '收益',
    'ea_placeholder_advice_title': '请输入建议标题',
    'ea_placeholder_advice_content': '请输入建议内容',
    'ea_placeholder_implementation_steps': '请输入实施步骤，每行一个步骤',
    'ea_placeholder_precautions': '请输入注意事项',
    'ea_placeholder_follow_up': '请输入后续行动建议',
    'ea_tip_viewing_for_crop': '正在查看 {crop} 的专家建议',
    'ea_field_crop_id': '作物ID',
    'ea_not_specified': '未指定',
    'ea_action_clear_filter': '清除筛选',
    'ea_section_basic_info': '基本信息',
    'ea_section_content': '建议内容',
    'ea_section_notes': '注意事项',
    'ea_section_follow_up': '后续行动',
    'ea_section_evaluation': '效果评估',
    'ea_section_feedback': '用户反馈',

    // Seasonal Guidance page (zh-CN)
    'sg_page_title': '季节性指导管理',
    'sg_page_subtitle': '提供季节性种植指导，植保作业日历提醒，病虫害预防和天气应对建议',
    'sg_current_season': '当前季节',
    'sg_now_is_season': '现在是{season}，请关注相关作物的季节性管理要点',
    'sg_stat_total': '总指导数',
    'sg_stat_active': '活跃指导',
    'sg_stat_high_priority': '高优先级',
    'sg_stat_total_yield': '预估总产量',
    'sg_unit_item': '条',
    'sg_unit_kg_per_mu': 'kg/亩',
    'sg_filter_season_label': '季节：',
    'sg_filter_all_seasons': '全部季节',
    'sg_season_spring': '春季',
    'sg_season_summer': '夏季',
    'sg_season_autumn': '秋季',
    'sg_season_winter': '冬季',
    'sg_filter_crop_label': '作物名称：',
    'sg_action_add_guidance': '新增指导',
    'sg_table_title': '季节性指导列表',
    'sg_pagination_total': '第{start}-{end}条/总共{total}条',
    'sg_column_guidance_code': '指导编号',
    'sg_column_season': '季节',
    'sg_column_crop_name': '作物名称',
    'sg_column_guidance_title': '指导标题',
    'sg_column_date_range': '时间范围',
    'sg_column_priority': '优先级',
    'sg_column_estimated_yield': '预估产量',
    'sg_column_risk_factors': '风险因素',
    'sg_column_actions': '操作',
    'sg_modal_edit_title': '编辑季节性指导',
    'sg_modal_add_title': '新增季节性指导',
    'sg_modal_view_title': '季节性指导详情',
    'sg_field_guidance_code': '指导编号',
    'sg_field_season': '季节',
    'sg_field_crop_name': '作物名称',
    'sg_field_guidance_title': '指导标题',
    'sg_field_guidance_content': '指导内容',
    'sg_field_start_date': '开始日期',
    'sg_field_end_date': '结束日期',
    'sg_field_priority': '优先级',
    'sg_field_estimated_yield': '预估产量',
    'sg_field_weather_notes': '天气注意事项',
    'sg_field_pest_prevention': '病虫害预防',
    'sg_field_farming_tasks': '植保作业任务',
    'sg_field_risk_factors': '风险因素',
    'sg_field_status': '状态',
    'sg_section_basic_info': '基本信息',
    'sg_section_content': '指导内容',
    'sg_section_history_compare': '历史数据对比',
    'sg_field_year': '年份',
    'sg_field_yield': '产量(kg/亩)',
    'sg_field_main_issues': '主要问题',
    'sg_column_actions_tip': '操作',
    'sg_rule_season': '请选择季节',
    'sg_rule_crop_name': '请选择作物名称',
    'sg_rule_start_date': '请选择开始日期',
    'sg_rule_end_date': '请选择结束日期',
    'sg_rule_priority': '请选择优先级',
    'sg_rule_estimated_yield': '请输入预估产量',
    'sg_rule_guidance_title': '请输入指导标题',
    'sg_rule_guidance_content': '请输入指导内容',
    'sg_placeholder_season': '请选择季节',
    'sg_placeholder_crop_name': '请选择作物名称',
    'sg_placeholder_yield': '产量',
    'sg_placeholder_guidance_title': '请输入指导标题',
    'sg_placeholder_guidance_content': '请输入指导内容',
    'sg_placeholder_weather_notes': '请输入天气注意事项',
    'sg_placeholder_pest_prevention': '请输入病虫害预防要点',
    'sg_placeholder_farming_tasks': '请输入植保作业任务，每行一个任务',
    'sg_placeholder_risk_factors': '请输入风险因素，用逗号分隔',
    'sg_crop_all': '全部作物',
    'sg_crop_wheat': '小麦',
    'sg_crop_corn': '玉米',
    'sg_crop_rice': '水稻',
    'sg_crop_vegetable': '蔬菜',
    'sg_priority_high': '高',
    'sg_priority_medium': '中',
    'sg_priority_low': '低',
    'sg_action_view': '查看',
    'sg_action_edit': '编辑',
    'sg_action_delete': '删除',
    'sg_action_confirm': '确定',
    'sg_action_cancel': '取消',
    'sg_date_start': '开始',
    'sg_date_end': '结束',
    'sg_msg_delete_success': '删除成功',
    'sg_msg_edit_success': '编辑成功',
    'sg_msg_add_success': '新增成功',
    'sg_msg_form_validation_failed': '表单验证失败',
    'sg_tab_seasonal_advice': '季节性种植建议',
    'sg_tab_solar_term': '节气植保指导',
    'sg_tab_pest_control': '季节性病虫害防治',
    'sg_tab_management': '季节性管理要点',

  // Agricultural Materials (zh-CN)
  'am_page_title': '农资信息管理',
  'am_page_subtitle': '管理农药、化肥、种子等农资信息，包含分类属性、使用说明、安全提示、供应商信息等',
  'am_stat_total': '总农资数',
  'am_stat_active': '活跃农资',
  'am_stat_avg_quality': '平均质量评分',
  'am_stat_total_value': '总价值',
  'am_unit_kind': '种',
  'am_unit_score': '分',
  'am_filter_category_label': '农资分类：',
  'am_filter_all_categories': '全部分类',
  'am_category_pesticide': '农药',
  'am_category_fertilizer': '化肥',
  'am_category_seed': '种子',
  'am_category_tool': '农具',
  'am_filter_supplier_label': '供应商：',
  'am_filter_all_suppliers': '全部供应商',
  'am_action_add_material': '新增农资',
  'am_table_title': '农资信息列表',
  'am_pagination_total': '第{start}-{end}条/总共{total}条',
  'am_column_code': '农资编号',
  'am_column_name': '农资名称',
  'am_column_category': '分类',
  'am_column_brand': '品牌',
  'am_column_supplier': '供应商',
  'am_column_spec': '规格',
  'am_column_package': '包装规格',
  'am_column_price': '价格',
  'am_column_quality': '质量评分',
  'am_column_safety': '安全等级',
  'am_column_actions': '操作',
  'am_modal_edit_title': '编辑农资信息',
  'am_modal_add_title': '新增农资信息',
  'am_modal_view_title': '农资详细信息',
  'am_section_basic_info': '基本信息',
  'am_section_inventory': '库存信息',
  'am_load_failed': '获取农资数据失败',
  'am_field_name': '农资名称',
  'am_rule_name': '请输入农资名称',
  'am_placeholder_name': '请输入农资名称',
  'am_field_code': '农资编号',
  'am_rule_code': '请输入农资编号',
  'am_placeholder_code': '请输入农资编号',
  'am_field_category': '农资分类',
  'am_rule_category': '请选择农资分类',
  'am_placeholder_category': '请选择农资分类',
  'am_field_subcategory': '子分类',
  'am_placeholder_subcategory': '请输入子分类',
  'am_field_brand': '品牌',
  'am_rule_brand': '请输入品牌',
  'am_placeholder_brand': '请输入品牌',
  'am_field_spec': '规格',
  'am_rule_spec': '请输入规格',
  'am_placeholder_spec': '请输入规格',
  'am_field_package': '包装规格',
  'am_placeholder_package': '请输入包装规格',
  'am_field_unit': '单位',
  'am_rule_unit': '请输入单位',
  'am_placeholder_unit': '请输入单位',
  'am_field_price': '价格(元)',
  'am_rule_price': '请输入价格',
  'am_placeholder_price': '价格',
  'am_field_safety': '安全等级',
  'am_placeholder_safety': '请选择安全等级',
  'am_safety_high': '高毒',
  'am_safety_medium': '中等毒',
  'am_safety_low': '低毒',
  'am_safety_very_low': '微毒',
  'am_not_set': '未设置',
  'am_field_quantity': '当前库存',
  'am_placeholder_quantity': '当前库存',
  'am_field_min_stock': '最低库存',
  'am_placeholder_min_stock': '最低库存',
  'am_field_max_stock': '最高库存',
  'am_placeholder_max_stock': '最高库存',
  'am_field_storage_location': '存放位置',
  'am_placeholder_storage_location': '请输入存放位置',
  'am_field_supplier': '供应商',
  'am_placeholder_supplier': '请输入供应商',
  'am_field_quality': '质量评分',
  'am_field_expiry_date': '到期时间',
  'am_placeholder_expiry_date': '选择到期时间',
  'am_field_usage_instructions': '使用说明',
  'am_placeholder_usage_instructions': '请输入使用说明',
  'am_field_safety_notes': '安全注意事项',
  'am_placeholder_safety_notes': '请输入安全注意事项',
  'am_none': '暂无',
  'am_search_placeholder': '搜索农资名称、品牌或供应商...',
  'am_filter_all_categories': '全部分类',
  'am_filter_all_status': '全部状态',
  'am_status_active': '正常',
  'am_status_low_stock': '库存不足',
  'am_status_out_of_stock': '缺货',
  'am_status_expiring_soon': '即将过期',
  'am_status_expired': '已过期',
  'am_action_add': '添加农资',
  'am_action_batch_delete': '批量删除',
  'am_action_import': '导入',
  'am_action_export': '导出',
  'am_action_edit': '编辑',
  'am_action_delete': '删除',
  'am_action_view': '查看',
  'am_action_purchase': '采购',
  'am_stat_total_materials': '总农资数',
  'am_stat_normal_stock': '正常库存',
  'am_stat_low_stock_count': '库存不足',
  'am_stat_out_of_stock_count': '缺货',
  'am_column_material_info': '农资信息',
  'am_column_price_stock': '价格/库存',
  'am_column_status': '状态',
  'am_table_stock': '库存',
  'am_table_min_stock': '最低库存',
  'am_pagination_showing': '显示第 {start} 到 {end} 条，共 {total} 条记录',
  'am_pagination_prev': '上一页',
  'am_pagination_next': '下一页',
  'am_confirm_delete': '确定要删除这个农资吗？',
  'am_confirm_batch_delete': '确定要删除选中的 {count} 个农资吗？',
  'am_msg_select_items': '请选择要删除的农资',
  'am_msg_import_success': '成功导入 {count} 条农资数据',
  'am_msg_import_failed': '导入失败，请检查文件格式',
  'am_msg_delete_success': '删除成功',
  'am_msg_update_success': '更新成功',
  'am_msg_create_success': '新增成功',
  'am_tab_inventory': '库存管理',
  'am_tab_purchase': '采购管理',
  'am_tab_usage': '使用记录',

    // 生长周期页面 i18n（仅本页使用）
    'growth_page_title': '植株生长周期',
    'growth_page_subtitle': '生长记录、健康评分与阶段分布',

    'growth_stat_total_records': '生长记录总数',
    'growth_stat_avg_health': '平均健康评分',
    'growth_stat_active_crops': '活跃作物数',
    'growth_stat_today_records': '今日新增记录',
    'growth_unit_record': '条记录',
    'growth_unit_score': '分',
    'growth_unit_crop': '个作物',
    'growth_unit_cm': 'cm',

    'growth_filter_crop_label': '作物',
    'growth_filter_crop_all': '全部作物',
    'growth_filter_date_range': '日期范围',

    'growth_action_add_record': '新增记录',
    'growth_action_view': '查看',
    'growth_action_edit': '编辑',
    'growth_action_delete': '删除',

    'growth_chart_title': '生长趋势',
    'growth_chart_height': '植株高度',
    'growth_chart_leaf_age': '叶龄',

    'growth_health_distribution_title': '健康度分布',
    'growth_health_excellent': '优',
    'growth_health_good': '良',
    'growth_health_normal': '中',
    'growth_health_poor': '差',

    'growth_timeline_title': '生长阶段时间线',
    'growth_stage_description': '{stage} 阶段说明',
    'growth_stage_duration': '持续时长：{days} 天',

    'growth_table_title': '生长记录',
    'growth_pagination_total': '第{start}-{end}条，共{total}条',

    'growth_modal_view_title': '生长记录详情',
    'growth_modal_edit_title': '编辑生长记录',
    'growth_modal_add_title': '新增生长记录',

    'growth_column_crop': '作物',
    'growth_column_land': '地块',
    'growth_column_stage': '生长阶段',
    'growth_column_leaf_age': '叶龄',
    'growth_column_height': '高度',
    'growth_column_stem_diameter': '茎粗',
    'growth_column_leaf_count': '叶片数',
    'growth_column_health_score': '健康评分',
    'growth_column_record_date': '记录日期',
    'growth_column_operator': '操作人',
    'growth_column_notes': '备注',
    'growth_column_actions': '操作',

    'growth_field_crop': '作物',
    'growth_field_land': '地块',
    'growth_field_stage': '生长阶段',
    'growth_field_record_date': '记录日期',
    'growth_field_leaf_age': '叶龄',
    'growth_field_height': '高度',
    'growth_field_stem_diameter': '茎粗',
    'growth_field_leaf_count': '叶片数',
    'growth_field_health_score': '健康评分',
    'growth_field_operator': '操作人',
    'growth_field_notes': '备注',

    'growth_rule_crop': '请选择作物',
    'growth_rule_land': '请输入地块',
    'growth_rule_stage': '请选择阶段',
    'growth_rule_record_date': '请选择记录日期',
    'growth_rule_leaf_age': '请输入叶龄',
    'growth_rule_height': '请输入高度',
    'growth_rule_stem_diameter': '请输入茎粗',
    'growth_rule_leaf_count': '请输入叶片数',
    'growth_rule_health_score': '请输入健康评分',
    'growth_rule_operator': '请输入操作人',

    'growth_placeholder_select_crop': '请选择作物',
    'growth_placeholder_land': '请输入地块',
    'growth_placeholder_select_stage': '请选择阶段',
    'growth_placeholder_leaf_age': '请输入叶龄',
    'growth_placeholder_height': '请输入高度',
    'growth_placeholder_stem_diameter': '请输入茎粗',
    'growth_placeholder_leaf_count': '请输入叶片数',
    'growth_placeholder_health_score': '请输入健康评分',
    'growth_placeholder_operator': '请输入操作人',
    'growth_placeholder_notes': '请输入备注',

    'growth_crop_wheat': '小麦',
    'growth_crop_corn': '玉米',
    'growth_crop_rice': '水稻',
    'growth_crop_vegetable': '蔬菜',

    'growth_land_north_wheat': '北区小麦地块',
    'growth_land_south_corn': '南区玉米地块',
    'growth_land_east_vegetable': '东区蔬菜地块',

    'growth_operator_zhangsan': '张三',
    'growth_operator_lisi': '李四',
    'growth_operator_wangwu': '王五',

    'growth_notes_normal': '生长正常',
    'growth_notes_good_tillering': '分蘖良好',
    'growth_notes_strong_stem': '茎秆健壮',
    'growth_notes_need_management': '需加强管理',

    'growth_stage_sowing': '播种期',
    'growth_stage_seedling': '苗期',
    'growth_stage_tillering': '分蘖期',
    'growth_stage_jointing': '拔节期',
    'growth_stage_booting': '孕穗期',
    'growth_stage_heading': '抽穗期',
    'growth_stage_filling': '灌浆期',
    'growth_stage_maturity': '成熟期',
    'growth_stage_tasseling': '抽雄期',
    'growth_stage_flowering': '开花期',
    'growth_stage_growth': '生长期',
    'growth_stage_fruiting': '坐果期',

    'growth_delete_success': '删除成功',
    'growth_edit_success': '修改成功',
    'growth_add_success': '新增成功',
    'growth_default_operator': '系统',

    // 我的植保模块 - 种植计划（原已种植作物管理）相关翻译键
    'nav_planted_crops': '种植计划',
    'pp_select_crop': '选择作物',
    'pp_select_crop_placeholder': '请选择种植作物',
    'pp_select_land': '选择地块',
    'pp_select_land_placeholder': '请选择种植地块',
    'pp_plan_area': '计划面积(亩)',
    'pp_plan_name': '计划名称',
    'pp_plan_name_placeholder': '自动生成，可修改',
    'pp_start_date': '计划开始日期',
    'pp_leader': '负责人',
    'pp_leader_placeholder': '请输入负责人',
    'pp_priority': '优先级',
    'pp_priority_high': '高',
    'pp_priority_medium': '中',
    'pp_priority_low': '低',
    'pp_stage_plan': '阶段计划',
    'pp_stage_order': '序号',
    'pp_stage_name': '阶段名称',
    'pp_stage_days': '预计天数',
    'pp_stage_date_range': '起止日期',
    'pp_stage_measures': '建议措施',
    'pp_stage_notes': '备注',
    'pp_total_cycle': '预计总周期',
    'pp_expected_harvest': '预计收获日期',
    'pp_land_info': '地块信息',
    'pp_soil_type': '土壤类型',
    'pp_irrigation': '灌溉条件',
    'pp_estimated_yield': '预估产量(kg)',
    'pp_estimated_cost': '预估成本(元)',
    'pp_remark': '备注',
    'pp_remark_placeholder': '请输入备注信息',
    'pp_no_stage_hint': '请先选择地块',
    'pp_empty_hint': '暂无种植计划数据',
    'pp_empty_add_hint': '点击「新增种植计划」开始制定作物全生命周期种植方案',
    'pp_day_unit': '天',
    'pp_plan_detail': '种植计划详情',
    'pp_crop_info': '作物信息',
    'pp_crop_category': '作物分类',
    'pp_cat_grain': '粮食作物',
    'pp_cat_economic': '经济作物',
    'pp_cat_vegetable': '蔬菜作物',
    'pp_temp_range': '适宜积温范围',
    'pp_precip_range': '适宜降水范围',
    'pp_stage_overview': '生长阶段概览',
    'pp_stage_description': '阶段描述',
    'pp_no_stage_desc': '暂无阶段详细信息',
    'pp_stage_notes_placeholder': '可选备注',
    'pp_suitable_temp': '适宜温度',
    'pp_suitable_humidity': '适宜湿度',
    'pp_stage_duration': '阶段周期',
    'pp_land_area': '地块面积',
    'pp_land_location': '位置',
    'pp_land_type': '地块类型',
    'pp_land_manager': '地块负责人',
    'pp_soil_ph': '土壤pH值',
    'pp_ph_normal': '适宜',
    'pp_ph_acidic': '偏酸',
    'pp_ph_alkaline': '偏碱',
    'pp_drainage': '排水条件',
    'pp_area_unit': '亩',
    'pp_current_crop': '当前种植作物',
    'pp_in_use': '使用中',
    'pp_land_planting_date': '当前种植日期',
    'pp_land_harvest_date': '预计收获日期',
    'nav_land_management': '种植地块',
    'nav_growth_cycle': '生长周期',
    'nav_growth_budget': '生长预算',
    'nav_warning_analysis': '预警分析',

    // 我的植保模块 - 农资管理相关翻译键
    'nav_agricultural_materials': '农资管理',
    'nav_materials_info': '农资信息',
    'nav_materials_management': '农资管理',
    // 我的植保模块 - 数据统计相关翻译键
    'nav_sales_statistics': '销售统计',
    'nav_data_analysis': '数据分析统计',
    'nav_network_trends': '网络趋势分析',

    // 我的植保模块 - 资产管理相关翻译键
    'nav_asset_info': '资产信息',

    // 种植计划模块相关翻译键
    'nav_planting_plan': '种植计划',

    // 气象农艺模块相关翻译键
    'nav_weather_agronomy': '气象农艺',
    'nav_data_crawling': '数据爬取',
    'nav_data_analytics': '数据分析',
    'nav_global_monitoring': '全局监控',
    'nav_local_prevention': '本地防治',
    'nav_pest_disease': '病虫害',
    'nav_public_opinion': '舆情分析',
    'nav_weather_disaster': '气象灾害',
    'nav_network_trend_analysis': '网络趋势分析',
    'nav_system_management': '系统管理',
    'nav_user_management': '用户管理',
    'nav_role_management': '角色管理',
    'nav_permission_management': '用户权限管理',
    'nav_user_role': '用户角色',
    'nav_role_permission': '角色权限',
    'nav_page_permission': '页面权限',
    'nav_organization': '组织机构',
    'nav_tenant_management': '租户管理',
    'nav_operation_log': '操作日志',
    'nav_resource_monitoring': '资源监控',
    'nav_agricultural_material': '农资管理',
    'nav_machine_management': '农机管理',
    'nav_machine_rental': '农机租赁',
    'nav_planting_resource': '种植资源',
    'nav_planting_plan': '种植计划',
    'nav_field_operation': '植保作业',
    'nav_disease_diagnosis_system': '病害问诊',
    'nav_knowledge_system': '知识库',
    'nav_notification': '通知管理',
    'nav_statistics': '统计分析',
    'nav_asset_statistics': '资产统计',
    'nav_output_statistics': '产出统计',
    'nav_performance_tracking': '绩效跟踪',
    'nav_economic_analysis': '经济分析',
    'nav_resource_monitoring_system': '资源监控',
    'nav_planning_statistics': '规划统计',
    'nav_land_management': '地块管理',
    'nav_system_settings': '系统设置',
    'nav_cache_management': '缓存管理',
    'nav_ai_settings': 'AI设置',
    'nav_database_health_check': '数据库健康检查',
    'nav_dict_management': '字典管理',
    'nav_finance_management': '财务管理',
    'nav_security_settings': '安全设置',
    'nav_mall_management': '商城管理',
    'nav_vip_management': 'VIP管理',
    'nav_membership_management': '会员管理',
    'nav_asset_management': '资产管理',
    'nav_economic_statistics': '经济统计',
    'nav_data_visualization': '数据可视化',

    // 页面详情国际化
    'page_detail_land_management': '种植地块',
    'page_detail_growth_cycle': '生长周期',
    'page_detail_growth_budget': '生长预算',
    'page_detail_warning_analysis': '预警分析',
    'page_detail_expert_advice': '专家建议',
    'page_detail_seasonal_guidance': '季节性指导',
    'page_detail_materials_info': '农资信息',
    'page_detail_materials_management': '农资管理',
    'page_detail_field_operations': '农事总览',
    'page_detail_operation_tasks': '作业任务',
    'page_detail_planting_planning': '种植计划（远期）',
    'page_detail_sales_statistics': '销售统计',
    'page_detail_data_analysis': '数据分析统计',
    'page_detail_environment_monitoring': '土壤墒情',
    'page_detail_network_trends': '网络趋势分析',
    'page_detail_asset_info': '资产信息',
    'page_detail_asset_management': '资产管理',
    // 页面标题和描述国际化
    'page_title_planted_crops': '种植计划',
    'page_desc_planted_crops': '作物全生命周期计划：生长动态、测算预测与季节性指导',
    'btn_add_planting_plan': '新增种植计划',
    'modal_edit_planting_plan': '编辑种植计划',
    'page_title_agricultural_materials': '农资管理',
    'page_desc_agricultural_materials': '农药、化肥、种子等农资管理，缺少时报警',
    'page_title_field_management': '农事管理',
    'page_desc_field_management': '农事计划、任务执行、环境监控与预警',
    'page_title_warning_management': '预警管理',
    'page_desc_warning_management': '预警规则配置、手动触发与预警记录处理',
    'page_title_data_statistics': '营收统计',
    'page_desc_data_statistics': '销售统计、数据分析统计',
    'page_title_asset_management': '资产管理',
    'page_desc_asset_management': '资产信息管理',
    'page_title_my_farm': '我的农场',
    'page_desc_my_farm': '物理资产、地块、设备与空间资源的静态与状态管理（农场空间载体）',
    'my_farm_feature_hub_title': '农场功能',
    'my_farm_feature_hub_subtitle': '空间载体层：农场、地块、设备、IoT 与环境监测的档案与运行状态。',
    'my_farm_nav_manage_desc': '农场与地块关系维护、归属调整与基础信息管理。',
    'my_farm_page_subtitle': '空间载体层：农场、地块、设备、灌溉与环境监测。作物过程与经营分析请从上方快捷入口进入「生产管理」。',
    'my_farm_group_carrier': '载体核心',
    'my_farm_group_land_archives': '地块档案与监测',
    'my_farm_group_shortcuts': '进入生产管理',
    'my_farm_shortcut_production_hub': '生产管理 Hub',
    'my_farm_shortcut_planting': '种植计划',
    'my_farm_shortcut_field_work_hub': '农事计划与任务',
    'my_farm_shortcut_pest': '病虫害防治',
    'my_farm_shortcut_scheme': 'AI 方案中心',
    'my_farm_shortcut_business': '营收统计',
    'my_farm_data_section_title': '农场数据',
    'my_farm_feature_enter': '进入',
    'page_title_smart_irrigation_hub': '智慧灌溉与监控',
    'page_desc_smart_irrigation_hub': '网关中间层状态、紧急停灌与恢复、灌溉统计与环境地块一览（传感器优先，全自动闭环由现场网关执行）。',
    'sih_detail_gateway': '设备网关状态',
    'sih_detail_emergency': '紧急停灌 / 恢复自动',
    'sih_detail_logs': '操作留痕',
    'sih_gateway_card_title': '灌溉网关（中间层）',
    'sih_adapter_type': '适配器类型',
    'sih_device_connected': '设备链路',
    'sih_emergency_stop': '紧急停灌',
    'sih_emergency_on': '已启用 — 不应自动下发灌溉',
    'sih_emergency_off': '未启用 — 允许自动闭环',
    'sih_btn_emergency_abort': '紧急停灌',
    'sih_btn_resume': '解除停灌',
    'sih_yes': '已连接',
    'sih_no': '未连接',
    'sih_irrigation_overview': '灌溉计划概览',
    'sih_stat_total_plans': '计划总数',
    'sih_stat_farms': '农场数',
    'sih_stat_planned': '计划中',
    'sih_stat_in_progress': '进行中',
    'sih_stat_completed': '已完成',
    'sih_quick_links': '快捷入口',
    'sih_land_list_title': '土壤墒情地块列表',
    'sih_land_empty': '暂无地块数据（环境服务返回空列表时可先维护土地资源）',
    'sih_col_land_name': '地块名称',
    'sih_col_land_id': '地块ID',
    'sih_event_log_title': '网关事件留痕',
    'sih_event_empty': '暂无事件',
    'sih_col_time': '时间',
    'sih_col_type': '类型',
    'sih_col_operator': '操作人',
    'sih_col_note': '备注',
    'sih_event_abort': '紧急停灌',
    'sih_event_resume': '恢复自动',
    'sih_confirm_emergency_abort_title': '确认紧急停灌？',
    'sih_confirm_emergency_abort_content': '将记录停灌事件并标记租户为紧急停灌状态；现场网关中间层应停止自动灌溉输出。',
    'sih_confirm_abort_ok': '确认停灌',
    'sih_confirm_resume_title': '解除紧急停灌？',
    'sih_confirm_resume_content': '将恢复允许自动闭环；请确认田间已安全。',
    'sih_msg_load_failed': '加载智慧灌溉数据失败',
    'sih_msg_abort_ok': '已执行紧急停灌',
    'sih_msg_resume_ok': '已解除停灌',
    'sih_msg_operation_failed': '操作失败',
    'sih_back_to_my_farm': '返回我的农场',
    'sih_under_my_farm_hint': '本页从「我的农场 → 农场功能」进入，归属农场模块。',
    'detail_farm_list': '农场列表',
    'detail_farm_plots': '多地块',
    'detail_farm_assign': '地块归属',
    'detail_farm_management': '地块管理',
    'my_farm_msg_fetch_farms_failed': '获取农场列表失败',
    'my_farm_msg_fetch_plots_failed': '获取地块列表失败',
    'my_farm_msg_enter_name': '请输入农场名称',
    'my_farm_msg_enter_person': '请输入负责人',
    'my_farm_msg_update_success': '更新成功',
    'my_farm_msg_create_success': '创建成功',
    'my_farm_msg_operation_failed': '操作失败',
    'my_farm_msg_invalid_item': '无法删除该条目',
    'my_farm_msg_delete_failed': '删除失败',
    'my_farm_msg_delete_success': '删除成功',
    'my_farm_msg_assign_success': '归属更新成功',
    'my_farm_msg_update_failed': '更新失败',
    'my_farm_plot_count': '{count} 块地',
    'my_farm_area_mu': '{area} 亩',
    'my_farm_plot_list': '地块列表 ({count})',
    'my_farm_no_plots': '暂无地块',
    'my_farm_change_assignment': '更改归属',
    'my_farm_manage_plots': '农场管理',
    'my_farm_btn_parcel_management': '地块管理',
    'my_farm_land_resources': '土地资源',
    'my_farm_land_resources_tooltip': '土地资源与作物绑定（与「农场管理」入口的地块档案数据源可能不同；查看详情可阅阶段示例图）',
    'my_farm_land_hub_tooltip': '进入地块管理：地块测绘与档案列表',
    'land_hub_back_parent': '返回上一级',
    'land_hub_title': '地块管理',
    'land_hub_center_title': '地块管理',
    'land_hub_subtitle': '地块测绘与档案；种植规划与阶段图请在地块详情「种植规划」中查看',
    'land_hub_entry_resources': '土地资源',
    'land_hub_entry_survey': '地块管理中心',
    'land_hub_desc_resources': '作物绑定、种植状态与阶段示例图（土地资源数据）',
    'land_hub_desc_survey': '地块档案、边界测绘与地图维护',
    'land_hub_enter': '进入',
    'land_hub_back': '返回地块管理',
    'land_hub_current_resources': '当前：土地资源',
    'land_hub_current_survey': '当前：地块管理中心',
    'land_hub_go_survey': '去地块管理中心',
    'land_hub_go_resources': '去土地资源',
    'land_hub_features_title': '功能说明',
    'land_hub_highlights_title': '要点',
    'land_hub_btn_resources': '进入土地资源',
    'land_hub_btn_survey': '进入地块管理中心',
    'land_hub_redirecting_tip': '正在进入地块管理中心…',
    'land_hub_res_feat_1': '维护土地资源与种植相关字段，支撑列表与详情查看',
    'land_hub_res_feat_2': '详情内按需展示作物阶段示例图（无图时使用仿生图）',
    'land_hub_res_feat_3': '已合并至地块测绘；历史入口将跳转至地块列表',
    'land_hub_survey_feat_1': '维护地块台账：名称、编号、农场归属、状态等',
    'land_hub_survey_feat_2': '测绘与几何：边界、面积、绘制状态',
    'land_hub_survey_feat_3': '联动地图页面进行范围查看与编辑',
    'land_hub_res_tag1': '作物绑定',
    'land_hub_res_tag1_d': '种植与状态字段',
    'land_hub_res_tag2': '阶段示例图',
    'land_hub_res_tag2_d': '详情内查看',
    'land_hub_res_tag3': '资源列表',
    'land_hub_res_tag3_d': '查询与维护',
    'land_hub_survey_tag1': '地块档案',
    'land_hub_survey_tag1_d': '资产台账',
    'land_hub_survey_tag2': '测绘',
    'land_hub_survey_tag2_d': '边界与面积',
    'land_hub_survey_tag3': '地图',
    'land_hub_survey_tag3_d': '查看与编辑',
    'my_farm_create': '新建农场',
    'my_farm_empty': '暂无农场，点击「新建农场」创建',
    'my_farm_edit': '编辑农场',
    'my_farm_name': '农场名称',
    'my_farm_name_placeholder': '例如：东区农场',
    'my_farm_person_in_charge': '负责人',
    'my_farm_person_in_charge_placeholder': '请输入负责人姓名',
    'my_farm_description': '描述',
    'my_farm_description_placeholder': '农场简要描述',
    'my_farm_location': '位置（省 / 市 / 区）',
    'my_farm_location_placeholder': '请选择省、市、区',
    'my_farm_selected_location': '已选：',
    'my_farm_legacy_location_hint': '当前为历史录入位置，请从上级联重新选择以更新：',
    'my_farm_delete_confirm_title': '确认删除',
    'my_farm_delete_confirm_content': '确定要删除农场「{name}」吗？地块将变为未归属状态。',
    'my_farm_assign_modal_title': '更改地块归属',
    'my_farm_plot_label': '地块：',
    'my_farm_assign_farm': '归属农场',
    'my_farm_unassigned': '未归属',
    'my_farm_search_placeholder': '请输入农场名称、描述、位置或负责人',
    'my_farm_empty_search': '未找到匹配的农场',
    'my_farm_stat_count_label': '个数',
    'my_farm_create_plot': '新建地块',
    'my_farm_plot_name': '地块名称',
    'my_farm_plot_area_mu': '面积（亩）',
    'my_farm_plot_name_ph': '请输入地块名称',
    'my_farm_plot_notes': '备注',
    'my_farm_msg_plot_name_required': '请输入地块名称',
    'my_farm_msg_plot_area_required': '请输入面积',
    'my_farm_msg_create_plot_success': '地块创建成功',
    'my_farm_msg_create_plot_failed': '地块创建失败',
    'my_farm_plot_current_crop': '当前作物',
    'my_farm_plot_no_crop': '未填写',

    // 页面详情标题国际化
    'page_details_title': '页面详情',

    // 我的植保 - 作物卡片
    'planting_area': '种植面积',
    'growth_days': '生长天数',
    'growth_stage': '生长阶段',
    'management_measures': '管理措施',
    'edit': '编辑',
    'hub_edit_planting': '编辑种植',
    'hub_edit_planting_title': '前往已种作物与种植计划管理',
    'hub_crop_warning_pest_title': '查看作物预警分析',
    'hub_crop_warning_weather_title': '查看农事预警管理',
    'edit_measures_title': '点击编辑管理措施',
    'pest_prevention_warning': '病虫害防治预警',
    'weather_warning': '天气预警',
    'growth_environment': '生长环境',
    'healthy_degree': '健康度',
    'environment_desc': '土壤肥沃，气候适宜，灌溉充足，光照充足',
    'more_plots_hidden': '还有 {count} 个种植地块未显示',
    'view_all_plots': '进入种植地块页面查看全部',
    'unknown_crop': '未知作物',
    'unknown_plot': '未知地块',
    'in_progress': '进行中',
    'mu_unit': '亩',
    'days_unit': '天',
    
    // 我的植保 - 生长阶段
    'stage_seeding': '播种期',
    'stage_emergence': '出苗期',
    'stage_seedling': '苗期',
    'stage_tillering': '分蘖期',
    'stage_jointing': '拔节期',
    'stage_heading': '抽穗期',
    'stage_flowering': '开花期',
    'stage_filling': '灌浆期',
    'stage_mature': '成熟期',
    
    // 我的植保 - 详情页面项
    'detail_land_management': '种植地块',
    'detail_growth_cycle': '生长周期',
    'detail_growth_budget': '生长预算',
    'detail_warning_analysis': '预警分析',
    'detail_warning_management': '预警管理',
    'detail_expert_advice': '专家建议',
    'detail_seasonal_guidance': '季节性指导',
    'detail_materials_info': '农资信息',
    'detail_materials_management': '农资管理',
    'detail_field_operations': '农事总览',
    'detail_operation_tasks': '作业任务',
    'detail_planting_planning': '种植计划（远期）',
    'detail_sales_statistics': '销售统计',
    'detail_data_analysis': '数据分析统计',
    'detail_environment_monitoring': '土壤墒情',
    'detail_trend_analysis': '趋势分析',
    'detail_network_trends': '网络趋势分析',
    'detail_asset_info': '资产信息',
    'detail_asset_management': '资产管理',
    
    // 错误提示
    'fetch_data_failed': '获取种植地块数据失败',
    'fetch_data_retry': '获取种植地块数据失败，请重试',

    // 科研进展
    'research_progress': '科研进展',
    'research_progress_desc': '了解植保科研最新成果、技术突破、发展趋势，把握科技前沿',
    'search_research': '搜索科研进展...',
    'research_institution': '研究机构',
    
    // 研究领域
    'all_fields': '全部领域',
    'biocontrol': '生物防治',
    'pesticide_research': '农药研发',
    'monitoring_tech': '监测技术',
    'equipment_tech': '设备技术',
    'genetics_breeding': '遗传育种',
    
    // 研究机构
    'all_institutions': '全部机构',
    'caas': '中国农科院',
    'universities': '高等院校',
    'research_institutes': '科研院所',
    'enterprise_rd': '企业研发',
    
    // 研究状态
    'completed': '已完成',
    'ongoing': '进行中',
    'planned': '计划中',
    
    // 研究内容
    'key_findings': '主要发现',
    'applications': '应用前景',
    'research_impact': '研究影响',
    'research_team': '研究团队',
    'publish_date': '发布日期',
    'views': '阅读',
    'view_details': '查看详情',
    'bookmark': '收藏',
    'share': '分享',
    
    // 研究成果示例
    'biotech_breakthrough_title': '新型生物农药在防治稻瘟病方面取得重大突破',
    'biotech_breakthrough_summary': '科研团队开发的新型生物农药可有效防治稻瘟病，减少化学农药使用',
    'smart_monitoring_title': '智能植保监测系统研发成功',
    'smart_monitoring_summary': '基于AI技术的智能植保监测系统实现病虫害自动识别和预警',
    'slow_release_title': '新型缓释农药制剂技术突破',
    'slow_release_summary': '开发的新型缓释农药制剂可延长药效，减少用药次数',
    'uav_precision_title': '植保无人机精准施药技术研究',
    'uav_precision_summary': '企业研发团队在植保无人机精准施药技术方面取得重要进展',
    // 知识库
    'knowledge_base': '知识库',
    'all_categories': '全部分类',
    'all_subcategories': '全部子分类',
    'pest_disease_knowledge': '病虫害知识',
    'planting_skills': '种植技能',
    'agricultural_technology': '农业技术',
    'soil_management': '土壤管理',
    'fertilizer_use': '肥料使用',
    'irrigation_technology': '灌溉技术',
    'disease_identification': '病害识别',
    'pest_control': '虫害防治',
    'prevention_measures': '预防措施',
    'treatment_methods': '治疗方法',
    'seeding_technology': '播种技术',
    'seedling_technology': '育苗技术',
    'transplanting_technology': '移栽技术',
    'pruning_technology': '修剪技术',
    'organic_agriculture': '有机农业',
    'precision_agriculture': '精准农业',
    'smart_agriculture': '智慧农业',
    'ecological_agriculture': '生态农业',
    'search_knowledge': '搜索知识...',
    'reset_filter': '重置筛选',
    'create_article': '创建文章',
    'article_title': '文章标题',
    'article_summary': '文章摘要',
    'article_content': '文章内容',
    'article_category': '文章分类',
    'article_subcategory': '子分类',
    'article_tags': '标签',
    'cover_image': '封面图片',
    'upload_cover': '上传封面',
    'submitting': '提交中...',
    'article_created': '文章创建成功！',
    'like': '点赞',
    'favorite': '收藏',
    'comment': '评论',
    'link_copied': '文章链接已复制到剪贴板',
    'featured_articles': '推荐文章',
    'category_statistics': '分类统计',
    'related_articles': '相关文章',
    'search_articles': '搜索文章...',
    'clear_search': '清除搜索内容',
    'category_filter': '分类筛选',
    'main_category': '主分类',
    'subcategory': '子分类',
    'sort_by': '排序方式',
    'sort_by_time': '按时间',
    'sort_by_views': '按阅读量',
    'sort_by_likes': '按点赞数',
    'publish_article': '发布文章',
    'enter_title': '请输入标题',
    'enter_summary': '请输入摘要',
    'enter_content': '请输入内容',
    'enter_tags': '请输入标签，多个标签用逗号分隔',
    'select_category': '请选择分类',
    'publish': '发布',
    'no_articles': '暂无文章',
    'showing_results': '显示第 {start} - {end} 条，共 {total} 条',
    'previous_page': '上一页',
    'next_page': '下一页',
    'by_comments': '按评论数',
    'title_preview': '标题：{title}',
    'enter_article_title': '请输入文章标题',
    'select_main_category': '请选择主分类',
    'select_subcategory': '请选择子分类',
    'enter_article_content': '请输入文章内容，支持富文本编辑...',

    // ====== 面包屑导航国际化 ======
    'breadcrumb_planting_asset': '种植资产管理',
    'breadcrumb_production_planning': '种植生产规划',
    'breadcrumb_field_management': '植保作业管理',
    'breadcrumb_economic_statistics': '经济统计',
    'breadcrumb_disease_warning': '病害预警',
    'breadcrumb_data_dashboard': '数据看板',
    'breadcrumb_planning_statistics': '规划统计',
    'breadcrumb_sowing_management': '播种管理',
    'breadcrumb_fertilization_management': '施肥管理',
    'breadcrumb_irrigation_management': '灌溉管理',
    'breadcrumb_weeding_management': '除草管理',
    'breadcrumb_pest_control_management': '病虫害防治',
    'breadcrumb_inspection_management': '巡田作业',
    'breadcrumb_employee': '人员管理',
    'breadcrumb_data_crawling': '数据抓取配置',
    'breadcrumb_opinion': '舆情分析',
    'breadcrumb_pest_disease': '病虫害数据',
    'breadcrumb_weather': '气象灾害预警',
    'breadcrumb_trends': '发展趋势分析',
    'breadcrumb_prevention': '本地预防建议',
    'breadcrumb_analytics': '数据分析报告',
    'breadcrumb_global': '全球监测',
    'breadcrumb_weather_data': '气象数据收集',
    'breadcrumb_warning': '灾害预警',
    'breadcrumb_weather_trends': '趋势分析',
    'breadcrumb_weather_history': '历史数据分析',
    'breadcrumb_climate': '本地气候分析',
    'breadcrumb_soil': '土壤分析',
    'breadcrumb_water': '水资源分析',
    'breadcrumb_advice': '种植建议',
    'breadcrumb_planting_planning': '种植计划（远期）',
    'breadcrumb_land': '地块管理',
    'breadcrumb_output_statistics': '产出统计',
    'breadcrumb_performance_tracking': '绩效跟踪',
    'breadcrumb_planting_plan': '种植规划',
    'breadcrumb_organization_management': '组织机构管理',
    'breadcrumb_department_management': '部门管理',
    'breadcrumb_user_management': '用户管理',
    'breadcrumb_role_management': '角色管理',
    'breadcrumb_permission_management': '权限管理',
    'breadcrumb_tenant_management': '租户管理',
    'breadcrumb_operation_log': '操作日志',
    'breadcrumb_role_permission_management': '角色权限管理',
    'breadcrumb_page_permission_management': '页面权限',
    'breadcrumb_user_role_management': '用户角色管理',
    'breadcrumb_account_settings': '账户设置',
    'breadcrumb_mall_management': '商城管理',

    // 系统设置相关翻译键
    'nav_login_security_settings': '登录安全设置',
    'nav_sms_settings': '短信设置',
    'nav_alipay_login_settings': '支付宝登录设置',
    'nav_wechat_login_settings': '微信登录设置',

    // 商城管理相关翻译键
    'nav_product_management': '商品管理',
    'nav_order_management': '订单管理',
    'nav_network_data': '网络数据',
    'nav_employee': '员工管理',

    // 系统管理模块相关翻译键
    'nav_planting_resource': '种植资源',
    'nav_disease_diagnosis_system': '病害问诊系统',
    'nav_knowledge_system': '知识库系统',
    'nav_notification': '通知管理',
    'nav_resource_monitoring_system': '资源监控系统',

    // 统计分析模块相关翻译键
    'nav_economic_statistics': '经济统计',

    // 个人中心模块相关翻译键
    'nav_my_shares': '我的分享',

    'nav_inventory_management': '库存管理',
    'nav_sales_management': '销售管理',

    'nav_payment_management': '支付管理',
    'nav_logistics_management': '物流管理',
  },
  'en-US': {
    'environmental_requirements': 'Environmental Requirements',
    'environmental_requirements_desc': 'Eco-friendly control methods and environmental impact assessment info',
    'all': 'All',
    'biological_control': 'Biological Control',
    'physical_control': 'Physical Control',
    'agricultural_control': 'Agricultural Control',
    'chemical_control_optimized': 'Chemical Control',
    'friendly_methods': 'Friendly Control',
    'environmental_impact': 'Environmental Impact',
    'regulatory_requirements': 'Regulatory Requirements',
    'specific_methods': 'Specific Methods',
    'advantages': 'Advantages',
    'high_risk': 'High Risk',
    'medium_risk': 'Medium Risk',
    'low_risk': 'Low Risk',
    'impact_factors': 'Impact Factors',
    'recommended_measures': 'Recommended Measures',
    'must_comply': 'Must Comply',
    'recommended_to_comply': 'Recommended to Comply',
    // Research Progress page i18n keys
    'biotech_breakthrough_content': 'The CAAS team achieved a major breakthrough in biopesticide R&D...',
    'smart_monitoring_content': 'A university team made important progress on an intelligent plant protection monitoring system...',
    'slow_release_content': 'A research institute achieved progress in slow-release pesticide formulations...',
    'uav_precision_content': 'A tech company advanced UAV-based precision spraying for plant protection...',

    'tag_bio_pesticide': 'Biopesticide',
    'tag_rice_blast': 'Rice blast',
    'tag_green_control': 'Green control',
    'tag_major_breakthrough': 'Breakthrough',
    'tag_ai_tech': 'AI',
    'tag_smart_monitoring': 'Smart monitoring',
    'tag_auto_identification': 'Auto identification',
    'tag_early_warning': 'Early warning',
    'tag_slow_release': 'Slow-release',
    'tag_pesticide_tech': 'Pesticide tech',
    'tag_longer_efficacy': 'Longer efficacy',
    'tag_less_dose_more_effect': 'Less dose, more effect',
    'tag_uav': 'UAV',
    'tag_precision_application': 'Precision spraying',
    'tag_intelligent_control': 'Intelligent control',
    'tag_work_efficiency': 'Work efficiency',
    'rp1_kf_1': 'Discovered new antagonistic strain',
    'rp1_kf_2': 'Developed efficient fermentation process',
    'rp1_kf_3': 'Established quality control standards',
    'rp1_kf_4': 'Completed field trials',
    'rp1_app_1': 'Rice blast control',
    'rp1_app_2': 'Reduce chemical pesticide use',
    'rp1_app_3': 'Improve food safety',
    'rp1_app_4': 'Protect environment',
    'rp1_impact': 'This will boost the biopesticide industry and support green agriculture',
    'rp2_kf_1': 'Developed image recognition algorithm',
    'rp2_kf_2': 'Built pest-disease database',
    'rp2_kf_3': 'Real-time monitoring and early warning',
    'rp2_kf_4': 'Integrated multi-source data fusion',
    'rp2_app_1': 'Field pest monitoring',
    'rp2_app_2': 'Intelligent early-warning system',
    'rp2_app_3': 'Guidance for precision control',
    'rp2_app_4': 'Statistical analysis',
    'rp2_impact': 'Significantly improves monitoring efficiency and accuracy for precision plant protection',

    'rp3_kf_1': 'Developed slow-release carriers',
    'rp3_kf_2': 'Optimized formulation',
    'rp3_kf_3': 'Established release control mechanism',
    'rp3_kf_4': 'Completed efficacy evaluation',
    'rp3_app_1': 'Control for multiple crops',
    'rp3_app_2': 'Reduce application frequency',
    'rp3_app_3': 'Improve control efficacy',
    'rp3_app_4': 'Lower environmental impact',
    'rp3_impact': 'Improves pesticide utilization and reduces pollution, upgrading the industry',
    'rp4_kf_1': 'Developed precise positioning',
    'rp4_kf_2': 'Optimized spraying parameters',
    'rp4_kf_3': 'Built intelligent control system',
    'rp4_kf_4': 'Improved operation accuracy',
    'rp4_app_1': 'Field crop protection',
    'rp4_app_2': 'Orchard pest control',
    'rp4_app_3': 'Precision spraying',
    'rp4_app_4': 'Higher operation efficiency',
    'rp4_impact': 'Enhances efficiency and accuracy of operations and promotes mechanization',
    // Calendar
    'prev_month': 'Prev',
    'next_month': 'Next',
    'switch_to_light': 'Switch to Light Mode',
    'switch_to_dark': 'Switch to Dark Mode',
    'reminders': 'Reminders',
    'add_reminder': 'Add Reminder',
    'loading_reminders': 'Loading reminders...',
    'no_reminders': 'No reminders',
    'add_reminder_hint': 'Click "Add Reminder" to create a new one',
    'gregorian': 'Gregorian',
    'lunar': 'Lunar',
    'hou': 'Hou',
    'solar_term': 'Solar Term',
    'weather': 'Weather',
    'farming_activities': 'Farming Activities',
    'no_farming_activities_today': 'No farming activities today',
    'type': 'Type',
    'crop': 'Crop',
    'importance': 'Importance',
    'enter_reminder_title': 'Please enter reminder title',
    'enter_reminder_content_optional': 'Please enter reminder content (optional)',
    'reminder_add_success': 'Reminder added successfully',
    'reminder_add_failed_retry': 'Failed to add reminder, please try again later',
    'reminder_delete_success': 'Reminder deleted successfully',
    'reminder_delete_failed_retry': 'Failed to delete reminder, please try again later',
    'success': 'Success',
    // Knowledge page additions
    'cover_preview': 'Cover Preview',
    'or_enter_image_url': 'Or enter image URL directly',
    'article_detail': 'Article Details',
    'views': 'Views',
    'post_comment': 'Post Comment',
    'no_comments_encourage': 'No comments yet. Be the first to comment!',
    // Common
    'nav_home': 'Home',
    'nav_page': 'Page {number}',
    'loading': 'Loading...',
    'user': 'User',
    'logout': 'Logout',
    'profile': 'Profile',
    'accountSettings': 'Account Settings',
    'notifications': 'Notifications',
    'darkMode': 'Dark Mode',
    'lightMode': 'Light Mode',
    'save': 'Save',
    'cancel': 'Cancel',
    'delete': 'Delete',
    'edit': 'Edit',
    'add': 'Add',
    'search': 'Search',
    'export': 'Export',
    'import': 'Import',
    'refresh': 'Refresh',
    'back': 'Back',
    'next': 'Next',
    'previous': 'Previous',
    'confirm': 'Confirm',
    'close': 'Close',
    'submit': 'Submit',
    'reset': 'Reset',
    'filter': 'Filter',
    'sort': 'Sort',
    'view': 'View',
    'download': 'Download',
    'upload': 'Upload',
    'select_all': 'Select All',
    'deselect_all': 'Deselect All',
    'selected_count': 'Selected',
    'no_data': 'No Data',
    'save_success': 'Save Successfully',
    'delete_success': 'Delete Successfully',
    'add_success': 'Add Successfully',
    'update_success': 'Update Successfully',
    'operation_failed': 'Operation Failed',
    'batch_assign_success': 'Batch Assign Successfully',
    'batch_delete_success': 'Batch Delete Successfully',
    'import_success': 'Import Successfully',
    'export_success': 'Export Successfully',

    // System name
    'systemName': 'Qushui Daoxiang',

    // Notifications
    'systemNotification': 'System Notification',
    'welcomeMessage': 'Welcome to Qushui Daoxiang',
    'diseaseWarning': 'Disease Warning',
    'diseaseRisk': 'Potential disease risk detected',
    'taskCompleted': 'Task Completed',
    'fieldTaskCompleted': 'Field operation task completed',
    'noNotifications': 'No Notifications',

    // Time
    'justNow': 'Just now',
    'minutesAgo': 'minutes ago',
    'hoursAgo': 'hours ago',
    'daysAgo': 'days ago',

    // Login page
    'login_subtitle': 'Plant Protection Management System',
    'login_session_expired': 'Your session has expired. Please sign in again.',
    'login_password_tab': 'Password Login',
    'login_sms_tab': 'SMS Login',
    'login_qrcode_tab': 'QR Code Login',
    'login_username_label': 'Username',
    'login_username_placeholder': 'Enter username',
    'login_password_label': 'Password',
    'login_password_placeholder': 'Enter password',
    'login_remember_me': 'Remember me',
    'login_submit': 'Sign in',
    'login_submitting': 'Signing in...',
    'login_phone_label': 'Phone',
    'login_phone_placeholder': 'Enter phone number',
    'login_code_label': 'Verification Code',
    'login_code_placeholder': 'Enter verification code',
    'login_send_code': 'Send code',
    'login_sending_code': 'Sending...',
    'login_generating_qrcode': 'Generating QR code...',
    'login_qrcode_expired': 'QR code expired',
    'login_regenerate': 'Generate again',
    'login_qrcode_scanning': 'Scan successful, signing in...',
    'login_qrcode_success': 'Signed in successfully!',
    'login_qrcode_instruction': 'Use Qushui Daoxiang App to scan and sign in',
    'login_qrcode_validity': 'QR code is valid for 5 minutes',
    'login_open_app': 'Open Qushui Daoxiang App',
    'login_open_scanner': 'Tap "Scan" feature',
    'login_scan_tip': 'Scan the QR code above to sign in',
    'login_refresh_qrcode': 'Refresh QR code',
    'login_refreshing_qrcode': 'Refreshing...',
    'login_wechat': 'Sign in with WeChat',
    'login_alipay': 'Sign in with Alipay',
    'login_register': 'Register',
    'login_forgot_password': 'Forgot password?',
    'login_alert_title': 'Notice',
    'login_switch_to_en': 'Switch to English',
    'login_switch_to_zh': '切换到中文',
    'login_bind_title': 'Bind Account',
    'login_bind_subtitle_wechat': 'Detected your first sign-in with WeChat',
    'login_bind_subtitle_alipay': 'Detected your first sign-in with Alipay',
    'login_bind_wechat_user': 'WeChat User',
    'login_bind_alipay_user': 'Alipay User',
    'login_create_and_bind': 'Create new account and bind',
    'login_bind_existing': 'Bind existing account',
    'login_or': 'or',
    'login_error_required_credentials': 'Username and password are required',
    'login_error_login_failed': 'Sign-in failed',
    'login_error_enter_phone': 'Please enter phone number',
    'login_error_wechat_failed': 'WeChat sign-in failed',
    'login_error_qrcode_expired': 'QR code expired, please get a new one',
    'login_error_alipay_failed': 'Alipay sign-in failed',
    'login_error_timeout': 'Session timed out, please scan again',
    'login_error_bind_failed': 'Binding failed',
    'login_error_create_failed': 'Failed to create account',
    'login_sms_send_success_title': 'Success',
    'login_sms_send_success_message': 'Verification code has been sent to your phone.',
    'login_sms_send_failed_title': 'Error',
    'login_sms_send_failed_message': 'Send failed',
    'login_wechat_modal_title': 'WeChat QR Sign-in',
    'login_wechat_modal_generating': 'Generating QR code...',
    'login_wechat_modal_instruction': 'Scan the QR code with WeChat to sign in',
    'login_simulate_scan': 'Simulate Scan',
    'login_cancel': 'Cancel',
    'login_wechat_modal_failed': 'QR code generation failed',
    'login_wechat_modal_retry': 'Please try again',
    'login_wechat_qr_alt': 'WeChat sign-in QR code',
    'login_alipay_modal_title': 'Alipay QR Sign-in',
    'login_alipay_modal_instruction': 'Scan the QR code with Alipay to sign in',
    'login_alipay_qr_alt': 'Alipay sign-in QR code',
    'login_alipay_modal_failed': 'QR code generation failed',

    // Register page
    'register_title': 'Create Account',
    'register_subtitle': 'After registration your account waits for binding. Sign in to request a tenant or contact an administrator.',
    'register_submitting': 'Registering...',
    'register_tenant_label': 'Tenant',
    'register_tenant_placeholder': 'Please select tenant',
    'register_loading_tenants': 'Loading tenants...',
    'register_username_placeholder': 'Enter username',
    'register_password_placeholder': 'Enter password',
    'register_button': 'Register',
    'register_to_login': 'Back to login',
    'register_error_required': 'Username and password are required',
    'register_error_password_length': 'Password must be at least 6 characters',
    'register_error_fetch_tenants': 'Failed to load tenant list, please refresh',
    'register_error_failed': 'Registration failed',
    'register_success': 'Registration successful, please sign in',

    // Tenant Selector
    'tenant_selector_all': 'All Tenants',
    'tenant_selector_placeholder': 'Select tenant',
    'platform_view_tenant_label': 'View tenant',
    'platform_view_tenant_current': 'Current',
    'tenant_type_province': 'Province',
    'tenant_type_city': 'City',
    'tenant_type_county': 'County',
    'tenant_type_township': 'Township',

    // Page loader
    'page_loader_loading': 'Loading page...',
    'page_loader_check_status': 'Checking page status...',
    'page_loader_refresh_detected': 'Detected page refresh, restoring state...',
    'page_loader_check_permissions': 'Checking permissions...',
    'page_loader_redirect_login': 'Redirecting to login...',
    'page_loader_ready': 'Page is ready',
    'page_loader_processing': 'Please wait, the system is processing your request...',
    'page_loader_error_title': 'Page load failed',
    'page_loader_reload': 'Reload',
    'page_loader_back_home': 'Back to home',
    'page_loader_default_error': 'Page initialization failed, please try again later',

    // Reset password page
    'reset_password_title': 'Reset Password',
    'reset_password_step1_title': 'Reset Password',
    'reset_password_step2_title': 'Enter Verification Code',
    'reset_password_step_info': 'Current step: {step}, Email: {email}',
    'reset_password_email_not_provided': 'Not provided',
    'reset_password_email_label': 'Email Address',
    'reset_password_email_placeholder': 'Enter your email address',
    'reset_password_send_button': 'Send Verification Code',
    'reset_password_sending': 'Sending...',
    'reset_password_back_to_login': 'Back to login',
    'reset_password_error_enter_email': 'Please enter your email address',
    'reset_password_error_invalid_email': 'Please enter a valid email address',
    'reset_password_code_sent': 'Verification code has been sent to your email.',
    'reset_password_error_send_failed': 'Failed to send verification code',
    'reset_password_error_email_unregistered': 'Email not registered. Please sign up or use a registered email.',
    'reset_password_error_too_frequent': 'Verification code sent too frequently. Please try again later.',
    'reset_password_error_required_fields': 'Please fill in all fields',
    'reset_password_error_password_length': 'Password must be at least 6 characters',
    'reset_password_error_password_mismatch': 'Passwords do not match',
    'reset_password_success': 'Password reset successful! Redirecting to login...',
    'reset_password_error_reset_failed': 'Password reset failed',
    'reset_password_code_label': 'Verification Code',
    'reset_password_code_placeholder': 'Enter 6-digit code',
    'reset_password_resend': 'Resend',
    'reset_password_resend_countdown': '{seconds}s',
    'reset_password_new_password_label': 'New Password',
    'reset_password_new_password_placeholder': 'Enter new password (at least 6 characters)',
    'reset_password_confirm_password_label': 'Confirm Password',
    'reset_password_confirm_password_placeholder': 'Re-enter new password',
    'reset_password_reset_button': 'Reset Password',
    'reset_password_resetting': 'Resetting...',
    'reset_password_back_step': 'Back to previous step',

    // Pest warning filters
    'ppn_filter_region_label': 'Region',
    'ppn_filter_crop_label': 'Crop',
    'ppn_filter_level_label': 'Risk Level',
    'ppn_filter_active_summary': 'Current filters:',
    'ppn_filter_clear': 'Clear filters',
    'ppn_no_warnings': 'No warning information',
    'ppn_card_affected_area': 'Affected Area',
    'ppn_card_risk_factors': 'Risk Factors',
    'ppn_card_prevention': 'Control Measures',
    'ppn_admin_mode_notice': '🔓 Admin mode: you have access to all features',

    // Pest warning content
    'ppn_warning_rice_south_title': 'Rice Blast Situation in South China',
    'ppn_warning_rice_south_desc': 'Continuous rainfall has triggered a high incidence of rice blast in South China. Please take timely control measures.',
    'ppn_warning_rice_south_area': 'Approx. 500,000 mu',
    'ppn_warning_rice_south_measure_1': 'Drain fields promptly to reduce humidity',
    'ppn_warning_rice_south_measure_2': 'Spray tricyclazole or other fungicides',
    'ppn_warning_rice_south_measure_3': 'Apply potassium fertilizer to enhance resistance',
    'ppn_warning_rice_south_measure_4': 'Remove diseased plants and leaves in time',
    'ppn_warning_rice_south_factor_1': 'Continuous rainfall',
    'ppn_warning_rice_south_factor_2': 'High field humidity',
    'ppn_warning_rice_south_factor_3': 'Low variety resistance',
    'ppn_warning_wheat_north_measure_2': 'Spray tebuconazole or similar fungicides',
    'ppn_warning_wheat_north_measure_3': 'Adjust planting density to improve ventilation',
    'ppn_warning_wheat_north_measure_4': 'Remove diseased residues promptly',
    'ppn_warning_wheat_north_factor_1': 'Suitable temperature',
    'ppn_warning_wheat_north_factor_2': 'Susceptible varieties',
    'ppn_warning_wheat_north_factor_3': 'Improper field management',
    'ppn_warning_corn_northeast_measure_2': 'Spray Bacillus thuringiensis formulations',
    'ppn_warning_corn_northeast_measure_3': 'Remove corn stalks promptly',
    'ppn_warning_corn_northeast_measure_4': 'Implement crop rotation',
    'ppn_warning_corn_northeast_factor_1': 'Temperature rising',
    'ppn_warning_corn_northeast_factor_2': 'Large pest base',
    'ppn_warning_corn_northeast_factor_3': 'Delayed control',

    // Module names
    'diseaseDiagnosis': 'Disease Diagnosis',
    'weatherAgronomy': 'Weather & Agronomy',
    'myPlantProtection': 'Production Management',
    'knowledge': 'Knowledge Base',
    'plantProtectionMall': 'Agri Supplies Mall',
    'networkData': 'Network Data',
    'systemManagement': 'System Management',

    // Profile
    'my_orders': 'My Orders',
    'my_shares': 'My Shares',
    'my_favorites': 'My Favorites',
    'my_likes': 'My Likes',
    'my_comments': 'My Comments',
    'my_comments_desc': 'View your published comments and open the original content',
    'view_original': 'View Original',
    'address_management': 'Shipping Address',
    'profile_center': 'Profile Center',
    'profile_subtitle': 'Manage your personal information and account settings',
    'my_account': 'My Account',
    'basic_info': 'Basic Information',
    'username': 'Username',
    'real_name': 'Real Name',
    'phone': 'Phone',
    'email': 'Email',
    'register_time': 'Registration Time',
    'last_login': 'Last Login',
    'not_member_yet': 'You are not a member yet',
    'upgrade_member_desc': 'Upgrade to membership for more exclusive services',
    'upgrade_now': 'Upgrade Now',
    'member': 'Member',
    'expire_date': 'Expiration Date',
    'current_member': 'Current Member',
    'remaining_days': 'Remaining Days',
    'days': 'Days',
    'member_level': 'Member Level',
    'level': 'Level',
    'points_balance': 'Points Balance',
    'points': 'Points',
    'renew_membership': 'Renew Membership',
    'member_benefits': 'Member Benefits',
    'exclusive_features': 'Exclusive Features',
    'exclusive_features_desc': 'AI diagnosis, data analysis and other advanced features',
    'points_reward': 'Points Reward',
    'points_reward_desc': 'Earn points from purchases, redeemable for products',
    'priority_service': 'Priority Service',
    'priority_service_desc': 'Priority customer service response and technical support',
    'exclusive_discount': 'Exclusive Discount',
    'exclusive_discount_desc': 'Member-exclusive prices and promotional activities',
    'account_statistics': 'Account Statistics',
    'login_count': 'Login Count',
    'usage_days': 'Usage Days',
    'operation_count': 'Operation Count',
    'favorite_count': 'Favorite Count',
    'account_settings_tab': 'Account Settings',
    'modify_profile': 'Modify Profile',
    'security_settings': 'Security Settings',
    'reset_password': 'Reset Password',
    'login_security': 'Login Security',
    'purchase_membership': 'Purchase Membership',
    'select_membership_plan': 'Select a membership plan that suits you and enjoy more exclusive services',
    'validity_period': 'Validity Period',
    'load_user_info_failed': 'Failed to load user information',
    'select_membership_type': 'Please select membership type',
    'purchase_success': 'Purchase successful!',
    'purchase_failed': 'Purchase failed, please try again',
    'times': 'Times',

    // Orders
    'order_status_pending': 'Pending Payment',
    'order_status_paid': 'Paid',
    'order_status_shipped': 'Shipped',
    'order_status_delivered': 'Delivered',
    'order_status_cancelled': 'Cancelled',
    'order_status_failed': 'Payment Failed',
    'order_status_refund_pending': 'Refunding',
    'order_status_refunding': 'Refunding',
    'order_status_refunded': 'Refunded',
    'order_status_refund_failed': 'Refund Failed',
    'order_number': 'Order Number',
    'order_status': 'Order Status',
    'order_time': 'Order Time',
    'payment_time': 'Payment Time',
    'order_details': 'Order Details',
    'order_items': 'Order Items',
    'go_shopping': 'Go Shopping',
    'go_pay': 'Pay Now',
    'cancel_order': 'Cancel Order',
    'apply_refund': 'Apply for Refund',
    'no_orders': 'No Orders',
    'no_orders_desc': 'You don\'t have any order records yet',
    'search_order_placeholder': 'Search order number or product name...',
    'all_status': 'All Status',
    'quantity': 'Quantity',
    'unit_price': 'Unit Price',
    'product_total': 'Product Total',
    'shipping_fee': 'Shipping Fee',
    'discount': 'Discount',
    'actual_payment': 'Actual Payment',
    'receiver_info': 'Receiver Information',
    'receiver_name': 'Receiver Name',
    'receiver_phone': 'Contact Phone',
    'receiver_address': 'Delivery Address',
    'product_info': 'Product Information',
    'amount_info': 'Amount Information',
    'not_paid': 'Not Paid',
    'unknown_product': 'Unknown Product',
    'product_image': 'Product Image',
    'confirm_refund': 'Are you sure you want to apply for a refund?',
    'confirm_cancel_order': 'Are you sure you want to cancel this order? This action cannot be undone.',
    'refund_submitted': 'Refund request submitted',
    'refund_failed': 'Refund failed, please try again later',
    'order_cancelled': 'Order cancelled successfully',
    'cancel_order_failed': 'Failed to cancel order, please try again later',
    'cannot_load_order_details': 'Cannot load order details',
    'user_not_logged_in': 'User not logged in, unable to fetch order data',

    // Favorites
    'search_favorites_placeholder': 'Search favorites...',
    'clear_search': 'Clear search',
    'no_favorites': 'No Favorites',
    'no_favorites_desc': 'You haven\'t favorited any content yet',
    'type': 'Type',
    'author': 'Author',
    'collect_date': 'Favorited Date',
    'type_article': 'Article',
    'type_product': 'Product',
    'type_video': 'Video',
    'confirm_remove_favorite': 'Are you sure you want to unfavorite this?',

    // Likes
    'search_likes_placeholder': 'Search likes...',
    'no_likes': 'No Likes',
    'no_likes_desc': 'You haven\'t liked any content yet',
    'like_date': 'Liked Date',
    'confirm_remove_like': 'Are you sure you want to unlike this?',
    // Comments
    'search_comments_placeholder': 'Search comments...',
    'no_comments': 'No Comments',
    'no_comments_desc': 'You haven\'t posted any comments yet',
    'comment_target': 'Comment Target',
    'comment_date': 'Comment Date',
    'edit_comment': 'Edit',
    'save_comment': 'Save',
    'cancel_edit': 'Cancel',
    'confirm_delete_comment': 'Are you sure you want to delete this comment?',
    'comment_empty': 'Comment content cannot be empty!',
    'comment_updated': 'Comment updated successfully!',
    'comment_placeholder': 'Please enter your comment...',
    'replies': 'Replies',
    // Shares
    'search_shares_placeholder': 'Search share title or content...',
    'all_categories': 'All Categories',
    'category_experience': 'Planting Experience',
    'category_technology': 'Technology Sharing',
    'category_news': 'Industry News',
    'category_question': 'Questions',
    'no_shares': 'No Shares',
    'no_shares_desc': 'You haven\'t shared any content yet',
    'share_title': 'Title',
    'share_content': 'Content',
    'share_category': 'Category',
    'publish_date': 'Publish Date',
    'views': 'Views',
    'shares': 'Shares',
    'confirm_delete_share': 'Are you sure you want to delete this share?',
    'share_link_copied': 'Share link copied to clipboard!',
    'copy_share_link': 'Please copy the following share link:',
    // Membership History
    'membership_purchase_history': 'Membership Purchase History',
    'membership_purchase_desc': 'View all your membership purchases and renewals',
    'total_records': '{count} records in total',
    'membership_type': 'Membership Type',
    'purchase_time': 'Purchase Time',
    'validity_period': 'Validity Period',
    'amount': 'Amount',
    'status': 'Status',
    'action': 'Action',
    'view_details': 'View Details',
    'status_active': 'Active',
    'status_expired': 'Expired',
    'status_cancelled': 'Cancelled',
    'no_purchase_records': 'No Purchase Records',
    'no_purchase_records_desc': 'You haven\'t purchased any membership services yet',
    'purchase_details': 'Purchase Details',
    'close': 'Close',
    'start_time': 'Start Time',
    'expiry_time': 'Expiry Time',
    'payment_amount': 'Payment Amount',
    'membership_status': 'Membership Status',
    'contact_phone': 'Contact Phone',
    'remark': 'Remark',
    'payment_method': 'Payment Method',
    'unknown': 'Unknown',
    'pagination_total': '{start}-{end} of {total} records',
    // User Feedback
    'function_feedback': 'Function Feedback',
    'feedback_type': 'Feedback Type',
    'problem_title': 'Problem Title',
    'problem_description': 'Problem Description',
    'error_details': 'Error Details (Optional)',
    'severity': 'Problem Severity',
    'submit_feedback': 'Submit Feedback',
    'my_feedback_history': 'My Feedback History',
    'feedback_details': 'Feedback Details',
    'admin_reply': 'Admin Reply',
    'processing_time': 'Processing Time',
    'select_feedback_type': 'Please select feedback type',
    'enter_problem_title': 'Please enter problem title',
    'enter_problem_description': 'Please describe the problem in detail',
    'select_severity': 'Please select severity',
    'feedback_submitted': 'Feedback submitted successfully! We will handle your issue as soon as possible.',
    'feedback_submit_failed': 'Submit failed',
    'load_feedback_types_failed': 'Failed to load feedback types',
    'load_feedback_history_failed': 'Failed to load feedback history',
    'status_pending': 'Pending',
    'status_in_progress': 'In Progress',
    'status_resolved': 'Resolved',
    'status_rejected': 'Rejected',
    'problem_title_placeholder': 'Please briefly describe the problem',
    'problem_description_placeholder': 'Please describe the problem you encountered in detail, including operation steps, expected results and actual results...',
    'error_details_placeholder': 'If there are error messages, error codes or screenshot descriptions, please provide them here...',
    'feedback_guide_severity': 'Severity:',
    'feedback_guide_severity_desc': 'Select the appropriate level according to the impact scope of the problem',
    'feedback_process_title': 'Feedback Processing Flow:',
    'feedback_process_step1': 'After submitting feedback, the system will automatically record and assign it to relevant technical personnel',
    'feedback_process_step2': 'Technical personnel will analyze the problem and provide solutions',
    'feedback_process_step3': 'You can view the processing progress and results in the feedback history',
    'feedback_process_step4': 'If you have any questions, you can contact customer service or technical support',
    'none': 'None',

    // Account Settings - Membership Center
    'welcome_to_membership': 'Welcome to Membership Center',
    'not_member_intro': 'You are currently a free member, upgrade to membership for more exclusive services',
    'upgrade_membership': 'Upgrade Membership Now',
    'view_all_membership_types': 'Click to view all membership types and benefits',
    'membership_active': 'Active',
    'membership_expired': 'Expired',
    'expiry_date': 'Expiry Date',
    'expired_date': 'Expired Date',
    'days_remaining': '{days} days remaining',
    'view_purchase_history': 'View Purchase History',
    'renew': 'Renew',
    'per_year': '/year',
    'select_payment_method': 'Please select payment method',
    'agree_to_terms': 'Please agree to the membership purchase agreement first',
    'processing': 'Processing...',
    'confirm_purchase': 'Confirm Purchase',
    'select_this_membership': 'Select This Membership',
    'membership_agreement': 'Membership Purchase Agreement',
    'agreement_intro': 'Dear user, welcome to purchase our membership service. Before you purchase membership, please read the following agreement carefully:',
    'i_agree': 'I have read and agree to',
    'i_have_read': 'I have read and agree to the above membership purchase agreement',
    'membership_benefits_title': 'Membership Benefits:',
    'benefit_customer_service': 'Exclusive Customer Service',
    'benefit_priority_guidance': 'Priority Technical Guidance',
    'benefit_advanced_features': 'Advanced Features Access',
    'benefit_exclusive_offers': 'Exclusive Promotional Activities',
    'benefit_expert_consultation': 'One-on-One Expert Consultation',
    'benefit_custom_service': 'Customized Service',
    'permanent': 'Permanent',
    'months': 'months',
    'province_city_district': 'Province/City/District',
    'province': 'Province',
    'city': 'City',
    'district': 'District',
    'location': 'Location',
    'auto_get_location': 'Auto-get current location',
    'full_address': 'Full Address:',
    'detail_address': 'Detailed Address',
    'detail_address_placeholder': 'Please enter detailed address',
    'postal_code': 'Postal Code',
    'postal_code_placeholder': 'Please enter postal code',
    'geolocation_not_supported': 'Your browser does not support geolocation',
    'getting_location': 'Getting location information...',
    'location_success': 'Address information obtained successfully!',
    'location_failed': 'Failed to get address information, please enter manually',
    'location_permission_denied': 'User denied geolocation request',
    'location_unavailable': 'Location information unavailable',
    'location_timeout': 'Getting location information timeout',
    'location_unknown_error': 'Unknown error occurred while getting location information',
    'user_info_not_exist': 'User information does not exist, cannot save',
    'save_failed': 'Save failed:',
    'purchase_membership_title': 'Purchase Membership',
    'validity': 'Validity',
    'description': 'Description',
    'purchase_agreement_confirm': 'I have read and agree to the membership purchase agreement',
    'select_membership_type_title': 'Select Membership Type',

    // Plant Protection Inquiry / AI Smart Service
    'plant_protection_inquiry': 'AI Smart Service',
    'new_conversation': 'New Conversation',
    'close_conversation': 'Close Conversation',
    'simulation_mode': 'Simulation Mode',
    'real_api': 'Real API',
    'ai_assistant': 'AI Assistant',
    'welcome_inquiry': 'Hello! I am your AI Smart Service assistant. Describe your issue or upload a photo for advice.',
    'ask_question_placeholder': 'Ask plant protection questions...',
    'welcome_service': 'Welcome to AI Smart Service',
    'preparing_assistant': 'Describe symptoms or upload a photo for recommendations',
    'thinking': 'Thinking...',
    'me': 'Me',
    'please_login_first': 'Please login first',
    'start_conversation_failed': 'Failed to start conversation',
    'start_conversation_retry': 'Failed to start conversation, please try again later',
    'recording': 'Recording...',
    'voice_input': 'Voice Input',
    'clear_input': 'Clear Input',
    'send_message': 'Send Message',
    'input_tip': 'Tip: Press Enter to send, supports image and attachment upload, supports voice input',
    'inquiry_record': 'Plant Protection Inquiry Record',
    'inquiry_hist_panel_title': 'History',
    'inquiry_hist_filter_category': 'Category',
    'inquiry_hist_search_placeholder': 'Search question text…',
    'inquiry_hist_default_category': 'Default category for new Q&A',
    'inquiry_hist_no_match': 'No records match filters',
    'inquiry_hist_cat_uncategorized': 'Uncategorized',
    'inquiry_hist_cat_pest_disease': 'Pests & diseases',
    'inquiry_hist_cat_fertilizer': 'Fertilizer & nutrition',
    'inquiry_hist_cat_watering': 'Irrigation & water',
    'inquiry_hist_cat_soil': 'Soil management',
    'inquiry_hist_cat_growth': 'Growth & development',
    'inquiry_hist_cat_pesticide': 'Pesticide use',
    'inquiry_hist_cat_other': 'Other',
    // Quick Replies
    'quick_reply_yellow_leaves': 'My plant leaves are turning yellow',
    'quick_reply_pest': 'Have pest problems to deal with',
    'quick_reply_slow_growth': 'Slow plant growth',
    'quick_reply_fertilizer': 'Need fertilizer advice',
    'quick_reply_watering': 'Watering frequency questions',
    'quick_reply_soil': 'Soil improvement suggestions',
    'quick_reply_disease': 'How to prevent diseases',
    'quick_reply_light': 'What to do with insufficient light',
    // Account Settings
    'account_settings': 'Account Settings',
    'basic_info': 'Basic Information',
    'account': 'Account',
    'real_name': 'Real Name',
    'email': 'Email',
    'phone': 'Phone',
    'avatar': 'Avatar',
    'save_basic_info': 'Save Basic Information',
    'saving': 'Saving...',
    'basic_info_save_success': 'Basic information saved successfully!',
    'change_password': 'Change Password',
    'current_password': 'Current Password',
    'new_password': 'New Password',
    'confirm_new_password': 'Confirm New Password',
    'password_mismatch': 'New password and confirm password do not match',
    'password_too_short': 'New password must be at least 6 characters',
    'changing': 'Changing...',
    'password_change_success': 'Password changed successfully!',
    'privacy_settings': 'Privacy Settings',
    'show_email_address': 'Show Email Address',
    'show_email_desc': 'Allow other users to view your email address',
    'show_phone_number': 'Show Phone Number',
    'show_phone_desc': 'Allow other users to view your phone number',
    'receive_notifications': 'Receive Notifications',
    'receive_notifications_desc': 'Receive system notifications and message reminders',
    'marketing_info': 'Marketing Information',
    'marketing_info_desc': 'Receive product promotions and marketing information',
    'save_privacy_settings': 'Save Privacy Settings',
    'privacy_settings_save_success': 'Privacy settings saved successfully!',

    // Login Register
    'login': 'Login',
    'register': 'Register',
    'username': 'Username',
    'password': 'Password',
    'tenant': 'Tenant ID',
    // User Management
    'user_management': 'User Management',
    'user_role_assign': 'User Role Assignment',
    'select_user': 'Select User',
    'or_batch_assign': 'Or Batch Assign',
    'select_roles': 'Select Roles',
    'batch_assign_roles': 'Batch Assign Roles',
    'batch_assign': 'Batch Assign',

    // Role Management
    'role_management': 'Role Management',
    'role_name': 'Role Name',
    'role_code': 'Role Code',
    'description': 'Description',
    'status': 'Status',
    'select_role': 'Select Role',
    'select_permissions': 'Select Permissions',
    'batch_assign_permissions': 'Batch Assign Permissions',

    // Permission Management
    'permission_management': 'Permission Management',
    'permission_name': 'Permission Name',
    'permission_code': 'Permission Code',

    // Organization Management
    'organization_management': 'Organization Management',
    'organization_name': 'Organization Name',
    'organization_code': 'Organization Code',
    // Department Management
    'department_management': 'Department Management',
    'department_management_desc': 'Manage department tree with create, edit and delete',
    'department_name': 'Department Name',
    'department_code': 'Department Code',
    // Tenant Management
    'tenant_management': 'Tenant Management',
    'tenant_name': 'Tenant Name',
    'tenant_code': 'Tenant Code',
    // Operation Log
    'operation_log': 'Operation Log',
    'operation_time': 'Operation Time',
    'operation_type': 'Operation Type',
    'operation_user': 'Operation User',
    'operation_content': 'Operation Content',

    // Resource Monitoring
    'resource_monitoring': 'Resource Monitoring',
    'cpu_usage': 'CPU Usage',
    'memory_usage': 'Memory Usage',
    'disk_usage': 'Disk Usage',
    'network_usage': 'Network Usage',

    // Agricultural Material
    'agricultural_material': 'Agricultural Material',
    'material_name': 'Material Name',
    'material_type': 'Material Type',
    'material_price': 'Material Price',
    'material_stock': 'Material Stock',

    // Machine Management
    'machine_management': 'Machine Management',
    'machine_name': 'Machine Name',
    'machine_type': 'Machine Type',
    'machine_status': 'Machine Status',

    // System Settings
    'system_settings': 'System Settings',
    'login_security': 'Login Security',
    'sms_settings': 'SMS Settings',
    'alipay_login': 'Alipay Login',
    'wechat_login': 'WeChat Login',

    // Mall Management
    'mall_management': 'Mall Management',
    'product_management': 'Product Management',
    'inventory_management': 'Inventory Management',
    'order_management': 'Order Management',
    'customer_management': 'Customer Management',
    'logistics_management': 'Logistics Management',
    'payment_management': 'Payment Management',

    // Product Related
    'product_name': 'Product Name',
    'product_price': 'Product Price',
    'product_stock': 'Product Stock',
    'product_category': 'Product Category',

    // Order Related
    'order_number': 'Order Number',
    'order_date': 'Order Date',
    'order_status': 'Order Status',
    'order_amount': 'Order Amount',

    // Customer Related
    'customer_name': 'Customer Name',
    'customer_phone': 'Customer Phone',
    'customer_email': 'Customer Email',
    'register_time': 'Register Time',



    // Inventory Related
    'inventory_record': 'Inventory Record',
    'inbound_time': 'Inbound Time',
    'outbound_time': 'Outbound Time',
    'stock_quantity': 'Stock Quantity',



    // Logistics Related
    'logistics_record': 'Logistics Record',
    'tracking_number': 'Tracking Number',
    'shipping_address': 'Shipping Address',
    'delivery_status': 'Delivery Status',

    // Dict Management
    'dict_management': 'Dictionary Management',
    'dict_type': 'Dictionary Type',
    'dict_key': 'Dictionary Key',
    'dict_value': 'Dictionary Value',
    'dict_remark': 'Dictionary Remark',

    // Finance Management
    'finance_management': 'Finance Management',
    'income': 'Income',
    'expense': 'Expense',
    'balance': 'Balance',

    // VIP Management
    'vip_management': 'VIP Management',
    'vip_level': 'VIP Level',
    'vip_benefits': 'VIP Benefits',

    // AI Settings
    'ai_settings': 'AI Settings',
    'ai_model': 'AI Model',
    'ai_parameters': 'AI Parameters',

    // Security Settings
    'security_settings': 'Security Settings',
    'password_policy': 'Password Policy',
    'login_policy': 'Login Policy',

    // ========== System Management Module - Complete Internationalization ==========
    
    // System Management Main Page
    'system_management_page_title': 'System Management',
    'system_management_page_subtitle': 'Unified management of system configuration, user permissions, organizational structure, etc.',
    'organization_user_management': 'Organization & User Management',
    'organization_user_management_desc': 'Unified management of organizations, users, roles and permissions',
    'tenant_management_module': 'Tenant Management',
    'tenant_management_desc': 'Tenant information management in multi-tenant environment',
    'operation_log_module': 'Operation Log',
    'operation_log_desc': 'View system operation logs, support audit trail',
    'finance_management': 'Finance Management',
    'finance_management_desc': 'Payment settings, withdrawal settings, transaction records, etc.',
    'security_settings_module': 'Security Settings',
    'security_settings_desc': 'Federated login, password strength, SMS verification, cache management, third-party login, etc.',
    'ai_settings_module': 'AI Settings',
    'ai_settings_desc': 'API Key, billing, token settings, default model',
    'dict_management': 'Data Dictionary',
    'dict_management_desc': 'Manage various data dictionary items',
    'menu_membership_module': 'Membership Management',
    'menu_membership_module_desc': 'Configure which menus require membership permissions, set trial counts',
    
    // AI Settings Page
    'ai_settings_title': 'AI Settings',
    'configured_models': 'Configured Models',
    'add_model': 'Add Model',
    'provider': 'Provider',
    'model_name': 'Model Name',
    'api_endpoint': 'API Endpoint',
    'api_key': 'API Key',
    'test_connection': 'Test Connection',
    'save_as_default': 'Save and Set as Default',
    'save_config': 'Save Configuration',
    'test_success': 'Test Successful',
    'test_failed': 'Test Failed',
    'connection_testing': 'Testing connection...',
    'please_select_provider': 'Please select a provider first',
    'please_enter_api_key': 'Please enter API Key first',
    'please_enter_model_name': 'Please enter model name',
    'please_enter_api_endpoint': 'Please enter API endpoint',
    'config_saved': 'Configuration saved',
    'config_saved_as_default': 'Configuration saved and set as default',
    'save_failed': 'Save failed',
    'ai_model_config': 'AI Model Configuration',
    'ai_prompt_config': 'AI Prompt Configuration',
    
    // AI Model Configuration Page
    'ai_model_config_title': 'AI Model Configuration',
    'ai_model_config_subtitle': 'Configure AI model parameters and providers',
    'default_model': 'Default Model',
    'model_provider': 'Model Provider',
    'model_endpoint': 'Model Endpoint',
    'model_key': 'Model Key',
    'model_parameters': 'Model Parameters',
    'max_tokens': 'Max Tokens',
    'temperature': 'Temperature',
    'top_p': 'Top P',
    
    // AI Prompt Configuration Page
    'ai_prompt_config_title': 'AI Prompt Configuration',
    'ai_prompt_config_subtitle': 'Configure AI system prompts and preset templates',
    'system_prompt': 'System Prompt',
    'user_prompt': 'User Prompt',
    'prompt_template': 'Prompt Template',
    'prompt_variables': 'Prompt Variables',
    
    // User Management Page
    'user_management_title': 'User Management',
    'user_list': 'User List',
    'add_user': 'Add User',
    'edit_user': 'Edit User',
    'delete_user': 'Delete User',
    'username': 'Username',
    'real_name': 'Real Name',
    'phone': 'Phone',
    'email': 'Email',
    'user_status': 'User Status',
    'primary_department': 'Primary Department',
    'user_roles': 'User Roles',
    'search_user': 'Search username/name/phone/email',
    'select_tenant': 'Select Tenant',
    'all_tenants': 'All Tenants',
    'cross_tenant_search': 'Cross-tenant Search',
    'batch_operations': 'Batch Operations',
    'batch_enable': 'Batch Enable',
    'batch_disable': 'Batch Disable',
    'batch_delete': 'Batch Delete',
    'user_enabled': 'Enabled',
    'user_disabled': 'Disabled',
    'password': 'Password',
    'confirm_password': 'Confirm Password',
    'department_settings': 'Department Settings',
    'secondary_departments': 'Secondary Departments (Multiple)',
    'role_settings': 'Role Settings',
    'remark': 'Remark',
    'permission_management_btn': 'Permission Management',
    'edit_user_info': 'Edit User Information',
    'delete_confirm': 'Are you sure you want to delete this user? This operation cannot be undone!',
    'batch_delete_confirm': 'Are you sure you want to batch delete {count} selected users? This operation cannot be undone!',
    'user_created': 'User created successfully',
    'user_updated': 'User updated successfully',
    'user_deleted': 'User deleted successfully',
    'user_enabled_success': 'User enabled successfully',
    'user_disabled_success': 'User disabled successfully',
    'password_leave_empty': 'Leave empty to keep unchanged',
    'import_users': 'Import Users',
    'export_users': 'Export Users',
    'user_statistics': 'User Statistics',
    'print_users': 'Print Users',
    
    // Role Management Page
    'role_management_title': 'Role Management',
    'role_list': 'Role List',
    'add_role': 'Add Role',
    'edit_role': 'Edit Role',
    'delete_role': 'Delete Role',
    'role_name': 'Role Name',
    'role_code': 'Role Code',
    'role_description': 'Role Description',
    'role_permissions': 'Role Permissions',
    'assign_permissions': 'Assign Permissions',
    'permission_list': 'Permission List',
    'select_permissions': 'Select Permissions',
    'permission_module': 'Permission Module',
    'permission_action': 'Permission Action',
    'expand_all': 'Expand All',
    'collapse_all': 'Collapse All',
    'select_all_in_module': 'Select All in Module',
    'deselect_all_in_module': 'Deselect All in Module',
    'role_created': 'Role created successfully',
    'role_updated': 'Role updated successfully',
    'role_deleted': 'Role deleted successfully',
    'permissions_assigned': 'Permissions assigned successfully',
    
    // Permission Management Page
    'permission_management_title': 'Permission Management',
    'page_permission_management_title': 'Page Permissions',
    'page_permission_management_desc': 'Manage system page access permissions',
    'page_permission_platform_desc': 'Select pages a tenant may access; changes sync to that tenant admin role',
    'page_permission_tenant_desc': 'View pages enabled for your tenant, then assign them to staff via role permissions',
    'page_permission_platform_subtitle': 'Selected pages become available to the tenant admin for downstream assignment',
    'page_permission_tenant_subtitle': 'These pages are enabled by the platform — assign them to roles in Role Permissions',
    'page_permission_tenant_hint': 'Pages below are enabled for your tenant. Use Role Permissions or User Roles to grant them to colleagues.',
    'page_permission_assign_flow_hint': 'Flow: platform enables pages → tenant admin assigns role permissions → assign roles to users.',
    'select_tenant_for_page_permission': 'Select tenant',
    'tenant_page_permission_pool': 'Tenant page permission pool',
    'tenant_opened_page_permissions': 'Enabled pages for this tenant',
    'save_tenant_page_permissions': 'Save tenant page permissions',
    'go_role_permission_assign': 'Assign role permissions',
    'no_page_permissions_catalog': 'No page permissions in catalog',
    'no_tenant_page_permissions': 'No pages enabled for this tenant yet',
    'role_permission_tenant_pool_hint': 'Permissions are filtered to your tenant pool; you can only assign within this scope.',
    'page_permission_search_placeholder': 'Search page permission name or code...',
    'permission_search_placeholder': 'Search permission name or code...',
    'permission_name': 'Permission Name',
    'permission_code': 'Permission Code',
    'permission_type': 'Permission Type',
    'permission_resource': 'Permission Resource',
    'permission_description': 'Permission Description',
    'add_permission': 'Add Permission',
    'edit_permission': 'Edit Permission',
    'add_page_permission': 'Add Page Permission',
    'edit_page_permission': 'Edit Page Permission',
    'delete_permission': 'Delete Permission',
    // Tenant Management Page
    'tenant_management_title': 'Tenant Management',
    'tenant_list': 'Tenant List',
    'add_tenant': 'Add Tenant',
    'edit_tenant': 'Edit Tenant',
    'delete_tenant': 'Delete Tenant',
    'tenant_name': 'Tenant Name',
    'tenant_code': 'Tenant Code',
    'tenant_type': 'Tenant Type',
    'tenant_status': 'Tenant Status',
    'tenant_admin': 'Tenant Administrator',
    'tenant_created': 'Tenant created successfully',
    'tenant_updated': 'Tenant updated successfully',
    'tenant_deleted': 'Tenant deleted successfully',
    'province_level': 'Province Level',
    'city_level': 'City Level',
    'county_level': 'County Level',
    'township_level': 'Township Level',
    // Organization Management Page
    'organization_management_title': 'Organization Management',
    'organization_list': 'Organization List',
    'add_organization': 'Add Organization',
    'edit_organization': 'Edit Organization',
    'delete_organization': 'Delete Organization',
    'organization_name': 'Organization Name',
    'organization_code': 'Organization Code',
    'parent_organization': 'Parent Organization',
    'organization_manager': 'Organization Manager',
    'organization_type': 'Organization Type',
    'organization_created': 'Organization created successfully',
    'organization_updated': 'Organization updated successfully',
    'organization_deleted': 'Organization deleted successfully',
    
    // Department Management Page
    'department_management_title': 'Department Management',
    'department_list': 'Department List',
    'add_department': 'Add Department',
    'edit_department': 'Edit Department',
    'delete_department': 'Delete Department',
    'department_name': 'Department Name',
    'department_code': 'Department Code',
    'parent_department': 'Parent Department',
    'department_manager': 'Department Manager',
    'employee_count': 'Employee Count',
    'department_created': 'Department created successfully',
    'department_updated': 'Department updated successfully',
    'department_deleted': 'Department deleted successfully',
    'sort_order': 'Sort Order',
    
    // Employee Management Page
    'employee_management_title': 'Employee Management',
    'employee_list': 'Employee List',
    'add_employee': 'Add Employee',
    'edit_employee': 'Edit Employee',
    'delete_employee': 'Delete Employee',
    'employee_no': 'Employee No.',
    'employee_name': 'Employee Name',
    'employee_department': 'Department',
    'employee_position': 'Position',
    'employee_status': 'Employee Status',
    'employee_created': 'Employee created successfully',
    'employee_updated': 'Employee updated successfully',
    'employee_deleted': 'Employee deleted successfully',
    
    // Operation Log Page
    'operation_log_title': 'Operation Log',
    'operation_user': 'Operation User',
    'operation_type': 'Operation Type',
    'operation_time': 'Operation Time',
    'operation_content': 'Operation Content',
    'operation_ip': 'Operation IP',
    'operation_result': 'Operation Result',
    'operation_success': 'Success',
    'operation_failed': 'Failed',
    'log_search': 'Log Search',
    'export_logs': 'Export Logs',
    // Data Dictionary Management Page
    'dict_management_title': 'Data Dictionary Management',
    'dict_list': 'Dictionary List',
    'add_dict': 'Add Dictionary',
    'edit_dict': 'Edit Dictionary',
    'delete_dict': 'Delete Dictionary',
    'dict_code': 'Dictionary Code',
    'dict_name': 'Dictionary Name',
    'dict_type': 'Dictionary Type',
    'dict_items': 'Dictionary Items',
    'add_dict_item': 'Add Dictionary Item',
    'edit_dict_item': 'Edit Dictionary Item',
    'delete_dict_item': 'Delete Dictionary Item',
    'item_value': 'Item Value',
    'item_label': 'Item Label',
    'dict_created': 'Dictionary created successfully',
    'dict_updated': 'Dictionary updated successfully',
    'dict_deleted': 'Dictionary deleted successfully',
    'enum_management': 'Enum Management',
    'config_management': 'Configuration Management',
    // Finance Management Page
    'finance_management_title': 'Finance Management',
    'payment_settings': 'Payment Settings',
    'withdrawal_settings': 'Withdrawal Settings',
    'transaction_records': 'Transaction Records',
    'payment_method': 'Payment Method',
    'payment_account': 'Payment Account',
    'transaction_amount': 'Transaction Amount',
    'transaction_status': 'Transaction Status',
    'transaction_time': 'Transaction Time',
    // Security Settings Page
    'security_settings_title': 'Security Settings',
    'oauth_login': 'OAuth Login',
    'password_strength': 'Password Strength',
    'sms_verification': 'SMS Verification',
    'cache_management': 'Cache Management',
    'cache_monitoring': 'Cache Monitoring',
    'data_cache': 'Data Cache',
    'alipay_settings': 'Alipay Settings',
    'wechat_settings': 'WeChat Settings',
    'third_party_login': 'Third-party Login',
    'min_password_length': 'Min Password Length',
    'require_uppercase': 'Require Uppercase',
    'require_lowercase': 'Require Lowercase',
    'require_numbers': 'Require Numbers',
    'require_special_chars': 'Require Special Characters',
    'password_expiry': 'Password Expiry',
    'prevent_reuse': 'Prevent Reuse',
    'lockout_threshold': 'Lockout Threshold',
    'lockout_duration': 'Lockout Duration',
    
    // Membership Management Page
    'membership_management_title': 'Membership Management',
    'membership_center': 'Membership Center',
    'membership_types': 'Membership Plans',
    'current_membership': 'Current Membership',
    'membership_status': 'Membership Status',
    'expiry_date': 'Expiry Date',
    'days_remaining': 'Days Remaining',
    'upgrade_membership': 'Upgrade Membership',
    'purchase_membership': 'Purchase Membership',
    'membership_price': 'Membership Price',
    'membership_duration': 'Membership Duration',
    'membership_features': 'Membership Features',
    'membership_expired': 'Expired',
    'membership_active': 'Active',
    'renew_membership': 'Renew Membership',
    'payment_method_label': 'Payment Method',
    'contact_phone': 'Contact Phone',
    'purchase_confirm': 'Confirm Purchase',
    'membership_purchased': 'Purchase successful!',
    'membership_page_subtitle': 'Choose a membership plan that suits you and enjoy more exclusive services',
    'welcome_to_membership': 'Welcome to Membership Center',
    'not_member_yet': 'You are not a member yet, upgrade to enjoy more exclusive services',
    'upgrade_now': 'Upgrade Now',
    'admin_dashboard': 'Admin Dashboard',
    'select_payment_method': 'Please select payment method',
    'enter_phone': 'Please enter contact phone',
    'valid_phone': 'Please enter a valid phone number',
    // Membership Type Management Page
    'membership_type_management': 'Membership Type Management',
    'add_membership_type': 'Add Membership Type',
    'edit_membership_type': 'Edit Membership Type',
    'delete_membership_type': 'Delete Membership Type',
    'membership_type_name': 'Membership Type Name',
    'membership_type_price': 'Membership Price',
    'membership_type_duration': 'Membership Duration',
    'membership_type_features': 'Membership Features',
    
    // Membership Privilege Management Page
    'membership_privilege_management': 'Membership Privilege Management',
    'privilege_name': 'Privilege Name',
    'privilege_description': 'Privilege Description',
    'privilege_type': 'Privilege Type',
    
    // Payment Method Management Page
    'payment_method_management': 'Payment Method Management',
    'add_payment_method': 'Add Payment Method',
    'edit_payment_method': 'Edit Payment Method',
    'delete_payment_method': 'Delete Payment Method',
    'payment_method_name': 'Payment Method Name',
    'payment_method_code': 'Payment Method Code',
    // Membership Statistics Page
    'membership_statistics_title': 'Membership Statistics',
    'total_members': 'Total Members',
    'active_members': 'Active Members',
    'expired_members': 'Expired Members',
    'membership_revenue': 'Membership Revenue',
    
    // VIP Management Page
    'vip_management_title': 'VIP Management',
    'vip_level': 'VIP Level',
    'vip_benefits': 'VIP Benefits',
    'vip_settings': 'VIP Settings',
    
    // Database Health Check Page
    'database_health_check_title': 'Database Health Check',
    'database_status': 'Database Status',
    'connection_status': 'Connection Status',
    'query_performance': 'Query Performance',
    'table_analysis': 'Table Analysis',
    'index_analysis': 'Index Analysis',
    
    // Database Error Management Page
    'database_error_management_title': 'Database Error Management',
    'error_list': 'Error List',
    'error_type': 'Error Type',
    'error_message': 'Error Message',
    'error_time': 'Error Time',
    // Organization Tree Management Page
    'organization_tree_management_title': 'Organization Tree Management',
    'organization_tree': 'Organization Tree',
    'expand_tree': 'Expand Tree',
    'collapse_tree': 'Collapse Tree',
    
    // Organization User Management Page
    'organization_user_management_title': 'Organization User Management',
    'organization_users': 'Organization Users',
    'assign_users': 'Assign Users',
    
    // User Role Management Page
    'user_role_management_title': 'User Role Management',
    'user_role_assign': 'User Role Assignment',
    'assign_roles': 'Assign Roles',
    
    // Role Permission Management Page
    'role_permission_management_title': 'Role Permission Management',
    'role_permission_assign': 'Role Permission Assignment',
    
    // Menu Membership Management Page
    'menu_membership_management_title': 'Menu Membership Management',
    'menu_list': 'Menu List',
    'membership_required': 'Membership Required',
    'trial_count': 'Trial Count',
    
    // Membership Redirect Page
    'membership_redirect_title': 'Membership Notice',
    'membership_redirect_message': 'This feature requires membership',
    
    // Admin Membership Dashboard
    'admin_membership_dashboard_title': 'Admin Membership Dashboard',
    'membership_overview': 'Membership Overview',
    'membership_trends': 'Membership Trends',
    
    // ========== System Management Module Internationalization End ==========

    // Weather Data
    'weather_data': 'Weather Data',
    'weather_data_collection': 'Weather Data Collection',
    'temperature': 'Temperature',
    'humidity': 'Humidity',
    'rainfall': 'Rainfall',
    'wind_speed': 'Wind Speed',
    'wind_direction': 'Wind Direction',
    'air_pressure': 'Air Pressure',
    'sunshine_hours': 'Sunshine Hours',
    'export_data': 'Export Data',
    'show_map': 'Show Map',
    'hide_map': 'Hide Map',
    'monitoring_stations': 'Monitoring Stations',
    'map_area': 'Map Area - Monitoring Stations',
    'click_station_switch': 'Click station to switch data',
    'data_filter': 'Data Filter',
    'monitoring_area': 'Monitoring Area',
    'date': 'Date',
    'time_range': 'Time Range',
    'query_data': 'Query Data',
    'extreme_weather_stats': 'Extreme Weather Statistics',
    'high_temperature_weather': 'High Temperature',
    'heavy_rain_weather': 'Heavy Rain',
    'strong_wind_weather': 'Strong Wind',
    'low_visibility': 'Low Visibility',
    'days': 'Days',
    'real_time_data': 'Real-time Data',
    'weather_condition': 'Weather Condition',
    'view_details': 'View Details',
    'trend_chart_24h': '24-Hour Trend',
    'uv_index': 'UV Index',
    'visibility': 'Visibility',
    'record_time': 'Record Time',
    'data_source': 'Data Source',
    'weather_station': 'Weather Station',
    'today': 'Today',
    'this_week': 'This Week',
    'this_month': 'This Month',
    'this_quarter': 'This Quarter',
    'fetch_weather_data_failed': 'Failed to fetch weather data, please check network connection',
    'export_success': 'Data exported successfully',
    'export_failed': 'Export failed',
    'time': 'Time',
    'wind_direction': 'Wind Direction',
    'precipitation': 'Precipitation',
    'sunny': 'Sunny',
    'rainy': 'Rainy',
    'cloudy': 'Cloudy',
    'normal': 'Normal',
    'close': 'Close',
    'basic_info': 'Basic Information',
    'monitoring_location': 'Monitoring Location',
    'record_time': 'Record Time',
    'weather_indicators': 'Weather Indicators',
    'detailed_indicators': 'Detailed Indicators',
    'coordinate_info': 'Coordinate Information',
    'latitude': 'Latitude',
    'longitude': 'Longitude',
    'uv_low': 'Low',
    'uv_medium': 'Medium',
    'uv_high': 'High',
    'uv_very_high': 'Very High',
    'uv_extreme': 'Extreme',

    // Water Resources
    'water_resources': 'Water Resources',
    'water_usage': 'Water Usage',
    'water_quality': 'Water Quality',
    'irrigation_area': 'Irrigation Area',

    // Soil Analysis
    'soil_analysis': 'Soil Analysis',
    'soil_type': 'Soil Type',
    'soil_ph': 'Soil pH',
    'soil_moisture': 'Soil Moisture',
    'soil_fertility': 'Soil Fertility',

    // Planting Advice
    'planting_advice': 'Planting Advice',
    'crop_type': 'Crop Type',
    'planting_time': 'Planting Time',
    'harvest_time': 'Harvest Time',

    // Historical Data
    'historical_data': 'Historical Data',
    'historical_data_analysis': 'Historical Data Analysis',
    'historical_data_description': 'Analyze historical weather data to discover patterns and anomalies',
    'data_type': 'Data Type',
    'data_date': 'Data Date',
    'year_range': 'Year Range',
    'time_range': 'Time Range',
    'filter': 'Filter',
    'refresh_data': 'Refresh Data',
    'export_data': 'Export Data',
    'average_value': 'Average Value',
    'maximum_value': 'Maximum Value',
    'minimum_value': 'Minimum Value',
    'yearly_trend': 'Yearly Trend',
    'temperature': 'Temperature',
    'humidity': 'Humidity',
    'rainfall': 'Rainfall',
    'yearly_comparison': 'Yearly Comparison',
    'data_table': 'Data Table',
    'anomaly_events': 'Anomaly Events',
    'statistical_analysis': 'Statistical Analysis',
    'yearly_data_comparison': 'Yearly Data Comparison',
    'monthly_trend_comparison': 'Monthly Trend Comparison',
    'historical_data_table': 'Historical Data Table',
    'anomaly_event_records': 'Anomaly Event Records',
    'anomaly_event_statistics': 'Anomaly Event Statistics',
    'anomaly_event_count': 'Found {count} anomaly events, including {severe} severe events',
    'data_distribution': 'Data Distribution',
    'change_trend': 'Change Trend',
    'historical_data_details': 'Historical Data Details',
    'january': 'Jan',
    'february': 'Feb',
    'march': 'Mar',
    'april': 'Apr',
    'may': 'May',
    'june': 'Jun',
    'july': 'Jul',
    'august': 'Aug',
    'september': 'Sep',
    'october': 'Oct',
    'november': 'Nov',
    'december': 'Dec',
    'year': 'Year',
    'operation': 'Operation',
    'details': 'Details',
    'date': 'Date',
    'event_type': 'Event Type',
    'value': 'Value',
    'impact_level': 'Impact Level',
    'description': 'Description',
    'high_temperature': 'High Temperature',
    'low_temperature': 'Low Temperature',
    'heavy_rain': 'Heavy Rain',
    'drought': 'Drought',
    'severe': 'Severe',
    'moderate': 'Moderate',
    'mild': 'Mild',
    'export_success': 'Data exported successfully',
    'export_failed': 'Export failed',
    'refresh_success': 'Data refreshed successfully',
    'yearly_average': 'Yearly Average',
    'highest_value': 'Highest Value',
    'lowest_value': 'Lowest Value',
    'data_analysis': 'Data Analysis',
    'data_analysis_point1': 'Data changes follow seasonal patterns',
    'data_analysis_point2': 'Compared to historical periods, changes are within normal range',
    'data_analysis_point3': 'No significant abnormal fluctuations, data quality is good',
    'tip': 'Tip',
    'please_enter': 'Please enter',
    'select_ai_model_to_configure': 'Please select an AI model from the left to configure',
    'custom_endpoint_and_model': 'Custom endpoint and model',
    'preset_endpoint': 'Preset endpoint',
    'configuration': 'Configuration',
    'success': 'Success',
    'error': 'Error',
    'please_wait': 'Please wait',
    'api': 'API',
    'response_time': 'Response time',
    'custom': 'Custom',
    'default': 'Default',
    'data': 'Data',
    'month': 'Month',
    'tenant': 'Tenant',
    'account': 'Account',
    'name': 'Name',
    'roles': 'Roles',
    'operation': 'Operation',
    'rows_per_page': 'Rows per page',
    'items': 'items',
    'page_info': 'Page {current} of {total}, Total {items} records',
    'statistics': 'Statistics',
    'print': 'Print',
    'unknown_tenant': 'Unknown Tenant',
    'basic_info': 'Basic Information',
    'update': 'Update',
    'enter_username': 'Please enter username',
    'enter_real_name': 'Please enter real name',
    'enter_email': 'Please enter email',
    'tenant_management_subtitle': 'Manage multi-level tenant architecture, supports Province→City→County→Township',
    'enter_tenant_name': 'Please enter tenant name',
    'data_dictionary': 'Data Dictionary',
    'privilege_config': 'Privilege Configuration',
    'upgrade_rules': 'Upgrade Rules',
    'organization_user_management_subtitle': 'Unified management of organizations, users, roles and permissions, switch between different functional modules via top navigation',
    'back_to_system_management': 'Back to System Management',
    'click_to_enter': 'Click to Enter',
    'feature_description': 'Feature Description',
    'organization_management_desc': 'Manage organizational structure and department settings',
    'user_management_desc': 'Manage system user information',
    'role_management_desc': 'Manage system role definitions',
    'permission_management_desc': 'Manage system permission configuration',
    'user_role_management_desc': 'Assign user role relationships',
    'role_permission_management_desc': 'Configure role permission relationships',
    'organization_management_feature_desc': 'Manage organizational structure, department settings, organization tree structure, etc., supports multi-level organization management.',
    'user_management_feature_desc': 'Manage system user information, including user creation, editing, deletion, status management, etc.',
    'role_management_feature_desc': 'Define system roles, set basic information and descriptions for roles.',
    'permission_management_feature_desc': 'Manage system permission configuration, define various operation permissions.',
    'user_role_management_feature_desc': 'Assign user role relationships, manage associations between users and roles.',
    'role_permission_management_feature_desc': 'Configure role permission relationships, assign appropriate permissions to roles.',
    'please_select_tab_to_continue': 'Please select a tab above to enter the corresponding module',

    // Trend Analysis
    'trend_analysis': 'Trend Analysis',
    'trend_chart': 'Trend Chart',
    'trend_prediction': 'Trend Prediction',

    // Disaster Warning
    'disaster_warning': 'Disaster Warning',
    'warning_level': 'Warning Level',
    'warning_type': 'Warning Type',
    'warning_area': 'Warning Area',

    // Local Climate
    'local_climate': 'Local Climate',
    'climate_type': 'Climate Type',
    'suitable_crops': 'Suitable Crops',

    // Field Management
    'field_management': 'Field Management',
    'field_name': 'Field Name',
    'field_area': 'Field Area',
    'field_location': 'Field Location',
    'field_status': 'Field Status',

    // Field Operation
    'field_operation': 'Field Operation',
    'operation_name': 'Operation Name',
    'field_operation_type': 'Operation Type',
    'operation_date': 'Operation Date',
    'operation_status': 'Operation Status',

    // Disease Warning
    'disease_warning': 'Disease Warning',
    'disease_type': 'Disease Type',
    'disease_level': 'Disease Level',
    'prevention_method': 'Prevention Method',

    // Planting Asset
    'planting_asset': 'Planting Asset',
    'planting_asset_name': 'Asset Name',
    'planting_asset_type': 'Asset Type',
    'planting_asset_value': 'Asset Value',

    // Planting Plan
    'planting_plan': 'Planting Plan',
    'plan_name': 'Plan Name',
    'plan_type': 'Plan Type',
    'plan_status': 'Plan Status',

    // Asset Statistics
    'asset_statistics': 'Asset Statistics',
    'total_assets': 'Total Assets',
    'asset_growth': 'Asset Growth',

    // Economic Analysis
    'economic_analysis': 'Economic Analysis',
    'cost_analysis': 'Cost Analysis',
    'profit_analysis': 'Profit Analysis',
    'investment_return': 'Investment Return',

    // Economic Statistics
    'economic_statistics': 'Economic Statistics',
    'income_statistics': 'Income Statistics',
    'expense_statistics': 'Expense Statistics',

    // Output Statistics
    'output_statistics': 'Output Statistics',
    'yield_statistics': 'Yield Statistics',
    'quality_statistics': 'Quality Statistics',

    // Performance Tracking
    'performance_tracking': 'Performance Tracking',
    'performance_indicator': 'Performance Indicator',
    'performance_score': 'Performance Score',

    // Data Dashboard
    'planting_data_dashboard': 'Data Dashboard',
    'planting_dashboard_overview': 'Dashboard Overview',
    'planting_key_indicators': 'Key Indicators',

    // Seeding Management
    'seeding_management': 'Seeding Management',
    'seeding_date': 'Seeding Date',
    'seeding_method': 'Seeding Method',
    'seeding_density': 'Seeding Density',
    'crop': 'Crop',
    'area': 'Area',
    'area_unit': 'Mu',
    'operator': 'Operator',

    // Fertilization Management
    'fertilization_management': 'Fertilization Management',
    'fertilization_date': 'Fertilization Date',
    'fertilizer_type': 'Fertilizer Type',
    'fertilization_amount': 'Fertilization Amount',
    'fertilizer': 'Fertilizer',
    'amount': 'Amount',
    'amount_unit': 'kg',

    // Irrigation Management
    'irrigation_management': 'Irrigation Management',
    'irrigation_date': 'Irrigation Date',
    'irrigation_method': 'Irrigation Method',
    'irrigation_amount': 'Irrigation Amount',
    'irrigation_water': 'Irrigation Water',
    'water_amount': 'Water Amount',
    'water_amount_unit': 'm³',

    // Weeding Management
    'weeding_management': 'Weeding Management',
    'weeding_date': 'Weeding Date',
    'weeding_method': 'Weeding Method',
    'herbicide_type': 'Herbicide Type',
    'herbicide': 'Herbicide',
    'herbicide_amount': 'Herbicide Amount',
    'herbicide_amount_unit': 'ml',

    // Planting Production Planning
    'planting_production_planning': 'Planting Production Planning',
    'planning_name': 'Planning Name',

    // Network Data Module
    'network_data': 'Network Data',
    'data_crawling': 'Data Crawling',
    'data_analytics': 'Data Analytics',
    'global_monitoring': 'Global Monitoring',
    'local_prevention': 'Local Prevention',
    'pest_disease': 'Pest & Disease',
    'public_opinion': 'Public Opinion',
    'weather_disaster': 'Weather Disaster',

    // Common Pages
    'not_found': 'Page Not Found',
    'back_home': 'Back to Home',

    // Payment Management
    'payment_management': 'Payment Management',
    'payment_methods': 'Payment Methods',
    'refund_processing': 'Refund Processing',
    'reconciliation_management': 'Reconciliation Management',
    'financial_statistics': 'Financial Statistics',
    'payment_method': 'Payment Method',
    'payment_type': 'Payment Type',
    'online_payment': 'Online Payment',
    'offline_payment': 'Offline Payment',
    'service_fee': 'Service Fee',
    'payment_status': 'Payment Status',
    'refund_amount': 'Refund Amount',
    'refund_reason': 'Refund Reason',
    'refund_status': 'Refund Status',
    'reconciliation_date': 'Reconciliation Date',
    'total_amount': 'Total Amount',
    'success_amount': 'Success Amount',
    'failed_amount': 'Failed Amount',
    'reconciliation_operator': 'Operator',
    'financial_revenue': 'Financial Revenue',
    'order_count': 'Order Count',
    'success_rate': 'Success Rate',
    'average_order': 'Average Order',
    'planning_type': 'Planning Type',
    'planning_status': 'Planning Status',
    'planning_start_date': 'Planning Start Date',
    'planning_end_date': 'Planning End Date',
    'planning_area': 'Planning Area',
    'planning_crop': 'Planning Crop',
    'planning_yield': 'Planning Yield',
    'planning_cost': 'Planning Cost',

    // Planting Asset Management
    'planting_asset_management': 'Planting Asset Management',
    'comprehensive_asset_management': 'Plant Protection Asset Management',
    'asset_id': 'Asset ID',
    'asset_name': 'Asset Name',
    'asset_type': 'Asset Type',
    'asset_value': 'Asset Value',
    'asset_purchase_date': 'Purchase Date',
    'asset_status': 'Asset Status',
    'asset_location': 'Asset Location',
    'asset_owner': 'Asset Owner',
    'asset_maintenance': 'Maintenance Record',
    'asset_code': 'Asset Code',
    'asset_specification': 'Specification',
    'asset_purchase_price': 'Purchase Price',
    'asset_current_value': 'Current Value',
    'asset_responsible_person': 'Responsible Person',
    'asset_category': 'Category',
    'asset_remark': 'Remark',
    'asset_usage_record': 'Usage Record',
    'asset_maintenance_record': 'Maintenance Record',
    'asset_statistics': 'Asset Statistics',

    // Data Dashboard
    'data_dashboard': 'Data Dashboard',
    'dashboard_overview': 'Dashboard Overview',
    'key_indicators': 'Key Indicators',
    'dashboard_charts': 'Chart Display',
    'dashboard_statistics': 'Statistics',
    'dashboard_alerts': 'Alert Information',
    'dashboard_tasks': 'To-Do Tasks',
    'dashboard_weather': 'Weather Information',
    'dashboard_market': 'Market Information',

    // ====== Navigation i18n ======
    'nav_welcome': 'Welcome',
    'nav_disease_diagnosis': 'Plant Protection Inquiry',
    'nav_plant_protection_inquiry': 'AI Smart Service',
    'nav_inquiry_history': 'Inquiry History',
    'nav_diagnosis_image': 'Image Diagnosis',
    'nav_diagnosis_text': 'Text Diagnosis',
    'nav_expert_diagnosis': 'Expert Diagnosis',
    'nav_weather_agronomy': 'Weather & Agronomy',
    'nav_smart_farm_cockpit': 'Smart Farm Cockpit',
    'nav_plant_protection_news': 'Agri News',
    'nav_news_center': 'News Center',
    'nav_pest_warning': 'Pest Warning',
    'nav_technical_guidance': 'Technical Guidance',
    'nav_policy_interpretation': 'Policy Interpretation',
    'nav_market_analysis': 'Market Analysis',
    'nav_expert_advice': 'Expert Advice',
    'nav_seasonal_guidance': 'Seasonal Guidance',
    'nav_regional_news': 'Regional News',
    'nav_research_progress': 'Research Progress',
    'nav_international_news': 'International News',
    'nav_data_statistics': 'Data Statistics',
    'nav_weather_data': 'Weather Data',
    'nav_local_climate': 'Local Climate',
    'nav_intervention_plans': 'Intervention suggestions',
    'nav_planting_advice': 'Planting Advice',
    'nav_soil_analysis': 'Soil Analysis',
    'nav_water_resources': 'Water Resources',
    'nav_historical_data': 'Historical Data',
    'nav_trend_analysis': 'Trend Analysis',
    'nav_disaster_warning': 'Disaster Warning',
    'nav_my_plant_protection': 'Production Management',
    // My Plant Protection Home
    'mpp_page_subtitle': 'Land, crop, and field work production control',
    'mpp_data_overview': 'Data Overview',
    'mpp_recent_activity': 'Recent Activity',
    'mpp_recent_execution': 'Recent Executions',
    'mpp_recent_plans': 'Scheduled Plans (Future)',
    'mpp_view_all': 'View all',
    'mpp_no_recent': 'No recent activities',
    'mpp_no_recent_execution': 'No in-progress or completed field work',
    'mpp_no_recent_plans': 'No future scheduled plans',
    'mpp_stat_planted_crops': 'Planted crops',
    'mpp_stat_tasks': 'Tasks',
    'mpp_completion_rate': 'Completion rate',
    'mpp_stat_warnings': 'Warnings',
    'mpp_stat_completed': 'Completed',
    'mpp_count_items': '{count} items',
    'mpp_dim_all': 'All',
    'mpp_dim_land': 'Land',
    'mpp_dim_crop': 'Crops',
    'mpp_dim_field_work': 'Field Work',
    'mpp_dim_support': 'Support',
    'mpp_dim_land_hint': 'Farms, parcels, assets, and irrigation infrastructure',
    'mpp_dim_crop_hint': 'Planting plans, growth models, and crop lifecycle',
    'mpp_dim_field_work_hint': 'Execution ledger, planning, and pest early-warning shown separately',
    'mpp_dim_support_hint': 'Materials, procurement, storage, and business analytics',
    'mpp_section_execution': 'Execution Ledger',
    'mpp_section_planning': 'Planning',
    'mpp_section_pest_warning': 'Alerts & Pest Control',
    // My Plant Protection Home - Land Management Card
    'page_desc_land_management_hub': 'View and maintain land information, including boundaries and map maintenance',
    'detail_land_asset_tab': 'Land Information',
    'detail_land_boundary': 'Land Boundary',
    'detail_land_map_maintenance': 'Land Map Maintenance',
    'nav_plant_growth_model': 'Plant Growth Model',
    // Plant Protection News Module
    'ppn_category_news': 'News',
    'ppn_category_news_desc': 'Industry news and research updates',
    'ppn_category_warning': 'Warning & Analysis',
    'ppn_category_warning_desc': 'Pest warning and market analysis',
    'ppn_category_environment': 'Environmental Analysis',
    'ppn_category_environment_desc': 'Soil and water resources analysis',
    'ppn_category_guidance': 'Guidance & Advice',
    'ppn_category_guidance_desc': 'Planting guidance and recommendations',
    'ppn_category_safety': 'Safety & Environment',
    'ppn_category_safety_desc': 'Safe pesticide use and environmental requirements',
    // Plant Protection News Modules
    'ppn_news_center_title': 'News Center',
    'ppn_news_center_desc': 'Latest plant protection news, policy interpretation, and technology updates',
    'ppn_research_progress_title': 'Research Progress',
    'ppn_research_progress_desc': 'Latest achievements, technological breakthroughs, and development trends',
    'ppn_pest_warning_title': 'Pest Warning',
    'ppn_pest_warning_desc': 'Real-time pest monitoring and prevention recommendations',
    'ppn_market_analysis_title': 'Market Analysis',
    'ppn_market_analysis_desc': 'Market trends, price analysis, and supply-demand information',
    'ppn_data_statistics_title': 'Data Statistics',
    'ppn_data_statistics_desc': 'Industry data statistics, trend analysis, and report downloads',
    'ppn_network_trend_analysis_title': 'Network Trend Analysis',
    'ppn_network_trend_analysis_desc': 'Analyze pest development trends based on historical data',
    'ppn_soil_analysis_title': 'Soil Analysis',
    'ppn_soil_analysis_desc': 'Analyze soil properties and provide improvement recommendations',
    'ppn_water_resources_title': 'Water Resources Analysis',
    'ppn_water_resources_desc': 'Analyze hydrological data and assess water resources status',
    'ppn_seasonal_guidance_title': 'Seasonal Guidance',
    'ppn_seasonal_guidance_desc': 'Seasonal plant protection recommendations and precautions',
    'ppn_expert_advice_title': 'Expert Opinions',
    'ppn_expert_advice_desc': 'Expert views, case analysis, experience sharing and consultation',
    'ppn_planting_advice_title': 'Planting Advice',
    'ppn_planting_advice_desc': 'Recommendations based on climate, soil, and hydrological data',
    'ppn_safe_pesticide_use_title': 'Safe Pesticide Use',
    'ppn_safe_pesticide_use_desc': 'Pesticide safety guidelines, emergency treatment, and protective measures',
    'ppn_environmental_protection_title': 'Environmental Protection',
    'ppn_environmental_protection_desc': 'Eco-friendly control methods and pesticide environmental impact assessment',
    // News Center Page
    'ppn_news_center_page_title': 'News Center',
    'ppn_news_center_page_subtitle': 'Get the latest plant protection news, policy interpretation, technical updates, and market analysis',
    'ppn_admin_mode': 'Admin Mode: You have access to all features',
    'ppn_search_placeholder': 'Search news...',
    'ppn_category_all': 'All',
    'ppn_category_policy': 'Policy & Regulation',
    'ppn_category_technology': 'Technology',
    'ppn_category_market': 'Market News',
    'ppn_category_research': 'Research Progress',
    'ppn_category_industry': 'Industry News',
    'ppn_views': 'views',
    'ppn_author': 'Author',
    'ppn_bookmark': 'Bookmark',
    'ppn_share': 'Share',
    'ppn_read_full': 'Read Full Article',
    'ppn_no_news': 'No news available',
    'ppn_no_image': 'No image',
    // Pest Warning Page - Common
    'ppn_region_all': 'All Regions',
    'ppn_region_north': 'North China',
    'ppn_region_northeast': 'Northeast China',
    'ppn_region_east': 'East China',
    'ppn_region_central': 'Central China',
    'ppn_region_south': 'South China',
    'ppn_region_west': 'West China',
    'ppn_region_southwest': 'Southwest China',
    'ppn_region_northwest': 'Northwest China',
    'ppn_crop_all': 'All Crops',
    'ppn_crop_rice': 'Rice',
    'ppn_crop_wheat': 'Wheat',
    'ppn_crop_corn': 'Corn',
    'ppn_crop_soybean': 'Soybean',
    'ppn_crop_cotton': 'Cotton',
    'ppn_crop_vegetable': 'Vegetable',
    'ppn_crop_fruit': 'Fruit Tree',
    'ppn_level_all': 'All Levels',
    'ppn_level_low': 'Low Risk',
    'ppn_level_medium': 'Medium Risk',
    'ppn_level_high': 'High Risk',
    'ppn_level_critical': 'Critical Risk',
    // Pest Warning Page
    'ppn_pest_warning_page_title': 'Pest Warning',
    'ppn_pest_warning_page_subtitle': 'Real-time pest monitoring and prevention recommendations',
    'ppn_filter_by_region': 'Filter by Region',
    'ppn_filter_by_crop': 'Filter by Crop',
    'ppn_filter_by_level': 'Filter by Risk Level',
    'ppn_affected_area': 'Affected Area',
    'ppn_start_date': 'Start Date',
    'ppn_end_date': 'End Date',
    'ppn_prevention_measures': 'Prevention Measures',
    'ppn_risk_factors': 'Risk Factors',
    'ppn_status_active': 'Active',
    'ppn_status_resolved': 'Resolved',
    'ppn_view_details': 'View Details',
    'ppn_no_warnings': 'No warnings available',
    // Market Analysis Page
    'ppn_market_analysis_page_title': 'Market Analysis',
    'ppn_market_analysis_page_subtitle': 'Market trends, price analysis, and supply-demand information',
    'ppn_market_category_all': 'All Markets',
    'ppn_market_category_pesticide': 'Pesticide Market',
    'ppn_market_category_fertilizer': 'Fertilizer Market',
    'ppn_market_category_seed': 'Seed Market',
    'ppn_market_category_equipment': 'Equipment Market',
    'ppn_market_category_biotech': 'Biotechnology',
    'ppn_market_category_organic': 'Organic Market',
    'ppn_market_search_placeholder': 'Search market analysis...',
    'ppn_market_size': 'Market Size',
    'ppn_market_growth_rate': 'Growth Rate',
    'ppn_market_forecast_period': 'Forecast Period',
    'ppn_market_views_label': 'Views',
    'ppn_market_bookmark': 'Bookmark',
    'ppn_market_share': 'Share',
    'ppn_market_download': 'Download Report',
    'ppn_market_view_details': 'View Details',
    'ppn_market_no_results': 'No market analysis available',
    'ppn_market_analysis_1_title': '2024 Biological Pesticide Market Trends',
    'ppn_market_analysis_1_summary': 'Demand for biological pesticides continues to grow; market size expected to exceed 50 billion CNY',
    'ppn_market_analysis_1_content': 'Driven by stricter environmental requirements and wider adoption of green control, the biological pesticide market keeps expanding. Market size is expected to reach 52 billion CNY in 2024 with annual growth above 15%. Companies should increase R&D investment and develop efficient, low-residue products.',
    'ppn_market_analysis_1_market_size': 'CN¥52B',
    'ppn_market_analysis_1_growth_rate': '15.2%',
    'ppn_market_analysis_1_forecast': '2024-2026',
    'ppn_market_analysis_2_title': 'Intelligent Plant Protection Equipment Outlook',
    'ppn_market_analysis_2_summary': 'UAV plant protection equipment is booming, with intelligence becoming the core trend',
    'ppn_market_analysis_2_content': 'The intelligent plant protection equipment market is growing rapidly, especially for UAVs. Market size is expected to reach 18 billion CNY in 2024, with intelligence and precision agriculture as key directions. Enterprises should invest in automation and data capabilities.',
    'ppn_market_analysis_2_market_size': 'CN¥18B',
    'ppn_market_analysis_2_growth_rate': '25.8%',
    'ppn_market_analysis_2_forecast': '2024-2026',

    'ppn_market_analysis_3_title': 'Organic Fertilizer Supply-Demand Analysis',
    'ppn_market_analysis_3_summary': 'Organic fertilizer demand remains strong while supply gaps widen',
    'ppn_market_analysis_3_content': 'With the rapid development of organic agriculture, demand for organic fertilizer is surging. Current supply gaps are around 30%, and imbalances may intensify over the next three years. Producers should expand capacity and enhance quality control.',
    'ppn_market_analysis_3_market_size': 'CN¥32B',
    'ppn_market_analysis_3_growth_rate': '18.5%',
    'ppn_market_analysis_3_forecast': '2024-2026',

    'ppn_market_analysis_4_title': 'Policy Impact on GM Seed Market',
    'ppn_market_analysis_4_summary': 'Policy changes significantly affect the GM seed market',
    'ppn_market_analysis_4_content': 'Recent policy adjustments are reshaping the GM seed market. Enterprises must respond proactively, refine market strategies, and reinforce compliance management.',
    'ppn_market_analysis_4_market_size': 'CN¥45B',
    'ppn_market_analysis_4_growth_rate': '8.3%',
    'ppn_market_analysis_4_forecast': '2024-2026',
    'ppn_market_analysis_5_title': 'Biotechnology Products Market Outlook',
    'ppn_market_analysis_5_summary': 'Biotech products have bright prospects with rising investment enthusiasm',
    'ppn_market_analysis_5_content': 'Biotechnology products show strong prospects, especially in gene editing and bio-breeding. Investment heat continues to grow, and explosive expansion is expected over the next five years. Focus on core technology R&D and industrialization strategies.',
    'ppn_market_analysis_5_market_size': 'CN¥28B',
    'ppn_market_analysis_5_growth_rate': '22.1%',
    'ppn_market_analysis_5_forecast': '2024-2026',

    'ppn_market_author_research': 'Market Research Dept.',
    'ppn_market_author_equipment': 'Equipment Insights Center',
    'ppn_market_author_fertilizer': 'Fertilizer Institute',
    'ppn_market_author_policy': 'Policy Research Center',
    'ppn_market_author_biotech': 'Biotech Research Institute',

    'ppn_market_tag_bio_pesticide': 'Biological Pesticide',
    'ppn_market_tag_market_trend': 'Market Trend',
    'ppn_market_tag_green_control': 'Green Control',
    'ppn_market_tag_smart_equipment': 'Smart Equipment',
    'ppn_market_tag_uav': 'UAV',
    'ppn_market_tag_precision_agriculture': 'Precision Agriculture',
    'ppn_market_tag_organic_fertilizer': 'Organic Fertilizer',
    'ppn_market_tag_supply_demand': 'Supply & Demand',
    'ppn_market_tag_organic_farming': 'Organic Farming',
    'ppn_market_tag_gm': 'GM',
    'ppn_market_tag_policy': 'Policy Impact',
    'ppn_market_tag_market_adjustment': 'Market Adjustment',
    'ppn_market_tag_biotech': 'Biotechnology',
    'ppn_market_tag_gene_editing': 'Gene Editing',
    'ppn_market_tag_investment_outlook': 'Investment Outlook',

    'ppn_market_download_header': 'Market Analysis Report',
    'ppn_market_download_title_label': 'Title: ',
    'ppn_market_download_summary_label': 'Summary: ',
    'ppn_market_download_category_label': 'Category: ',
    'ppn_market_download_publish_label': 'Published: ',
    'ppn_market_download_author_label': 'Author: ',
    'ppn_market_download_market_size_label': 'Market Size: ',
    'ppn_market_download_growth_label': 'Growth Rate: ',
    'ppn_market_download_forecast_label': 'Forecast Period: ',
    'ppn_market_download_detail_label': 'Details: ',
    'ppn_market_download_detail_placeholder': 'See full report for more details.',
    'ppn_market_download_tags_label': 'Tags: ',
    'ppn_market_download_generated_label': 'Generated at: ',
    'ppn_market_download_success': 'Report "{title}" downloaded successfully!',

    // Data Statistics Page
    'ppn_data_statistics_page_title': 'Data Statistics',
    'ppn_data_statistics_page_subtitle': 'Industry data statistics, trend analysis, and report downloads',
    'ppn_data_statistics_search_placeholder': 'Search data statistics...',
    'ppn_data_statistics_category_all': 'All',
    'ppn_data_statistics_category_production': 'Production Statistics',
    'ppn_data_statistics_category_market': 'Market Statistics',
    'ppn_data_statistics_category_trade': 'Trade Statistics',
    'ppn_data_statistics_category_consumption': 'Consumption Statistics',
    'ppn_data_statistics_category_policy': 'Policy Statistics',
    'ppn_data_statistics_category_research': 'Research Statistics',
    'ppn_data_statistics_data_period': 'Data Period',
    'ppn_data_statistics_data_source': 'Data Source',
    'ppn_data_statistics_file_size': 'File Size',
    'ppn_data_statistics_views_label': 'Views',
    'ppn_data_statistics_downloads_label': 'Downloads',
    'ppn_data_statistics_author_label': 'Compiled By',
    'ppn_data_statistics_download': 'Download Report',
    'ppn_data_statistics_view_details': 'View Details',
    'ppn_data_statistics_bookmark': 'Bookmark',
    'ppn_data_statistics_share': 'Share',
    'ppn_data_statistics_no_results': 'No data statistics available',
    'ppn_data_statistics_period_label': 'Statistics Period',
    'ppn_data_statistics_period_day': 'Day',
    'ppn_data_statistics_period_week': 'Week',
    'ppn_data_statistics_period_month': 'Month',
    'ppn_data_statistics_period_year': 'Year',
    'ppn_data_statistics_trend_analysis': 'Trend Analysis Chart',
    'ppn_data_statistics_category_distribution': 'Data Category Distribution',
    'ppn_data_statistics_key_metric_total': 'Total Data',
    'ppn_data_statistics_key_metric_production': 'Production Data',
    'ppn_data_statistics_key_metric_market': 'Market Data',
    'ppn_data_statistics_key_metric_trade': 'Trade Data',
    'ppn_data_statistics_key_metric_consumption': 'Consumption Data',
    'ppn_data_statistics_key_metric_avg_growth': 'Average Growth Rate',
    'ppn_data_statistics_change_from_previous': 'vs Previous Period',
    'ppn_statistics_type_production': 'Production Statistics',
    'ppn_statistics_type_sales': 'Sales Statistics',
    'ppn_statistics_type_pest': 'Pest Statistics',
    'ppn_statistics_type_prevention': 'Prevention Statistics',
    'ppn_data_source': 'Data Source',
    'ppn_update_time': 'Update Time',
    'ppn_total_records': 'Total Records',

    'ppn_data_statistics_1_title': '2024 Plant Protection Production Statistics',
    'ppn_data_statistics_1_summary': 'Comprehensive analysis of 2024 plant protection production, including output, value, and regional distribution',
    'ppn_data_statistics_1_content': 'In 2024, total plant protection production reached 2.8 million tons, up 8.5% year-on-year. Biological pesticides grew fastest at 450,000 tons with 25% growth.',
    'ppn_data_statistics_1_period': 'Full Year 2024',
    'ppn_data_statistics_1_source': 'National Bureau of Statistics',
    'ppn_data_statistics_1_file_size': '2.5MB',
    'ppn_data_statistics_1_author': 'Statistics Information Center',
    'ppn_data_statistics_1_tags': 'Production,Output Analysis,Regional Distribution',

    'ppn_data_statistics_2_title': 'Plant Protection Trade Data Analysis',
    'ppn_data_statistics_2_summary': 'Detailed study of import/export trade volume, key partners, and trends',
    'ppn_data_statistics_2_content': 'Total trade in 2024 reached USD 18 billion, with USD 12 billion exports and USD 6 billion imports. Major export markets include Southeast Asia, South America, and Africa.',
    'ppn_data_statistics_2_period': 'Full Year 2024',
    'ppn_data_statistics_2_source': 'General Administration of Customs',
    'ppn_data_statistics_2_file_size': '1.8MB',
    'ppn_data_statistics_2_author': 'Trade Analysis Dept.',
    'ppn_data_statistics_2_tags': 'Trade,Import & Export,Market Analysis',

    'ppn_data_statistics_3_title': 'Plant Protection Consumption Survey',
    'ppn_data_statistics_3_summary': 'Big-data-driven analysis of consumption behavior and market trends',
    'ppn_data_statistics_3_content': 'Survey results show increasing adoption of biological pesticides, stronger awareness of precise application, and rising demand for green control solutions.',
    'ppn_data_statistics_3_period': 'Q4 2024',
    'ppn_data_statistics_3_source': 'Market Research',
    'ppn_data_statistics_3_file_size': '3.2MB',
    'ppn_data_statistics_3_author': 'Market Research Center',
    'ppn_data_statistics_3_tags': 'Consumption,Market Survey,Behavior Analysis',

    'ppn_data_statistics_4_title': 'Plant Protection Policy Impact Assessment',
    'ppn_data_statistics_4_summary': 'Evaluates policy implementation results to support future adjustments',
    'ppn_data_statistics_4_content': 'Policies on green control, pesticide reduction, and coordinated prevention achieved significant effects, though further coordination and promotion are needed.',
    'ppn_data_statistics_4_period': '2023-2024',
    'ppn_data_statistics_4_source': 'Policy Assessment',
    'ppn_data_statistics_4_file_size': '2.1MB',
    'ppn_data_statistics_4_author': 'Policy Evaluation Center',
    'ppn_data_statistics_4_tags': 'Policy Assessment,Implementation,Data Support',

    'ppn_data_statistics_5_title': 'Plant Protection R&D Investment Statistics',
    'ppn_data_statistics_5_summary': 'Tracks R&D investment and analyzes achievement commercialization',
    'ppn_data_statistics_5_content': 'Plant protection R&D investment reached 8.5 billion CNY in 2024, up 12%, with markedly improved commercialization of new technologies.',
    'ppn_data_statistics_5_period': 'Full Year 2024',
    'ppn_data_statistics_5_source': 'Ministry of Science and Technology',
    'ppn_data_statistics_5_file_size': '1.5MB',
    'ppn_data_statistics_5_author': 'Research Statistics Center',
    'ppn_data_statistics_5_tags': 'R&D,Investment,Technology Transfer',

    'ppn_data_statistics_download_header': 'Data Statistics Report',
    'ppn_data_statistics_download_title_label': 'Title: ',
    'ppn_data_statistics_download_summary_label': 'Summary: ',
    'ppn_data_statistics_download_category_label': 'Category: ',
    'ppn_data_statistics_download_publish_label': 'Published: ',
    'ppn_data_statistics_download_author_label': 'Compiled By: ',
    'ppn_data_statistics_download_period_label': 'Data Period: ',
    'ppn_data_statistics_download_source_label': 'Data Source: ',
    'ppn_data_statistics_download_size_label': 'File Size: ',
    'ppn_data_statistics_download_detail_label': 'Details: ',
    'ppn_data_statistics_download_detail_placeholder': 'See full report for complete details.',
    'ppn_data_statistics_download_tags_label': 'Tags: ',
    'ppn_data_statistics_download_generated_label': 'Generated at: ',
    'ppn_data_statistics_download_success': 'Report "{title}" downloaded successfully!',

    // Soil Analysis Page
    'ppn_soil_analysis_page_title': 'Soil Analysis',
    'ppn_soil_analysis_page_subtitle': 'Analyze soil properties and provide improvement recommendations',
    'ppn_soil_type': 'Soil Type',
    'ppn_soil_ph_value': 'pH Value',
    'ppn_soil_organic_matter': 'Organic Matter',
    'ppn_soil_nutrient_content': 'Nutrient Content',
    'ppn_soil_improvement_suggestions': 'Improvement Suggestions',
    'ppn_soil_region_north_plain': 'North China Plain',
    'ppn_soil_region_northeast_black': 'Northeast Black Soil Region',
    'ppn_soil_region_yangtze': 'Middle-Lower Yangtze',
    'ppn_soil_region_south': 'South China Region',
    'ppn_soil_type_all': 'All Soil Types',
    'ppn_soil_type_brown': 'Brown Soil',
    'ppn_soil_type_black': 'Black Soil',
    'ppn_soil_type_paddy': 'Paddy Soil',
    'ppn_soil_type_red': 'Red Soil',
    'ppn_soil_clear_filters': 'Clear filters',
    'ppn_soil_current_filters': 'Current filters:',
    'ppn_soil_records_found': '{count} records found',
    'ppn_soil_toggle_light': 'Switch to light mode',
    'ppn_soil_toggle_dark': 'Switch to dark mode',
    'ppn_soil_card_avg_ph_title': 'Average pH',
    'ppn_soil_card_ph_range': 'Recommended range: 6.0-7.5',
    'ppn_soil_card_organic_title': 'Organic matter',
    'ppn_soil_card_organic_target': 'Target: >2.5%',
    'ppn_soil_card_nitrogen_title': 'Nitrogen content',
    'ppn_soil_card_nitrogen_range': 'Recommended range: 80-150',
    'ppn_soil_card_phosphorus_title': 'Phosphorus content',
    'ppn_soil_card_phosphorus_range': 'Recommended range: 30-80',
    'ppn_soil_unit_mgkg': 'mg/kg',
    'ppn_soil_table_title': 'Soil analysis details',
    'ppn_soil_table_region': 'Region',
    'ppn_soil_table_type': 'Soil type',
    'ppn_soil_table_ph': 'pH',
    'ppn_soil_table_organic': 'Organic (%)',
    'ppn_soil_table_nitrogen': 'Nitrogen (mg/kg)',
    'ppn_soil_table_phosphorus': 'Phosphorus (mg/kg)',
    'ppn_soil_table_potassium': 'Potassium (mg/kg)',
    'ppn_soil_table_status': 'Status',
    'ppn_soil_status_excellent': 'Excellent',
    'ppn_soil_status_good': 'Good',
    'ppn_soil_status_warning': 'Needs improvement',
    'ppn_soil_status_poor': 'Poor',
    'ppn_soil_status_unknown': 'Unknown',
    'ppn_soil_loading': 'Loading...',
    'ppn_soil_recommendations_title': 'Soil improvement recommendations',
    'ppn_soil_rec_add_organic': 'Increase organic fertilizer',
    'ppn_soil_rec_rotation': 'Adopt crop rotation',
    'ppn_soil_rec_deep_tillage': 'Deep tillage',
    'ppn_soil_rec_conservation_tillage': 'Conservation tillage',
    'ppn_soil_rec_straw_return': 'Return straw to field',
    'ppn_soil_rec_scientific_fertilization': 'Apply fertilizer scientifically',
    'ppn_soil_rec_add_phosphate': 'Increase phosphate fertilizer',
    'ppn_soil_rec_improve_drainage': 'Improve drainage',
    'ppn_soil_rec_adjust_ph': 'Adjust soil pH',
    'ppn_soil_rec_add_lime': 'Apply lime',
    'ppn_soil_rec_improve_organic': 'Improve organic matter',
    'ppn_soil_rec_balance_fertilization': 'Balance fertilization',
    // Water Resources Page
    'ppn_water_resources_page_title': 'Water Resources Analysis',
    'ppn_water_resources_page_subtitle': 'Analyze hydrological data and assess water resources',
    'ppn_water_quality': 'Water Quality',
    'ppn_water_level': 'Water Level',
    'ppn_irrigation_status': 'Irrigation Status',
    'wr_filter_region_all': 'All regions',
    'wr_region_north': 'North China Plain',
    'wr_region_central': 'Middle and Lower Yangtze',
    'wr_region_northwest': 'Northwest Region',
    'wr_region_south': 'South China Region',
    'wr_filter_water_type_all': 'All water sources',
    'wr_water_type_groundwater': 'Groundwater',
    'wr_water_type_surface': 'Surface water',
    'wr_water_type_rainwater': 'Rainwater',
    'wr_clear_filters': 'Clear filters',
    'wr_current_filters': 'Current filters:',
    'wr_records_found': '{count} records found',
    'switch_to_en': 'Switch to English',
    'switch_to_zh': 'Switch to Chinese',
    'wr_status_excellent': 'Excellent',
    'wr_status_good': 'Good',
    'wr_status_warning': 'Needs improvement',
    'wr_status_poor': 'Poor',
    'wr_status_unknown': 'Unknown',
    'wr_metric_ph_title': 'Average pH',
    'wr_metric_ph_range': 'Optimal range: {range}',
    'wr_metric_conductivity_title': 'Conductivity',
    'wr_metric_conductivity_target': 'Target: {target}',
    'wr_metric_hardness_title': 'Hardness',
    'wr_metric_hardness_range': 'Optimal range: {range}',
    'wr_metric_nitrate_title': 'Nitrate',
    'wr_metric_nitrate_standard': 'Standard: {standard}',
    'wr_analysis_detail_title': 'Water resource analysis details',
    'wr_column_region': 'Region',
    'wr_column_water_type': 'Water type',
    'wr_column_ph': 'pH',
    'wr_column_conductivity': 'Conductivity (μS/cm)',
    'wr_column_hardness': 'Hardness (mg/L)',
    'wr_column_nitrate': 'Nitrate (mg/L)',
    'wr_column_status': 'Water quality status',
    'wr_management_suggestions_title': 'Water resource management suggestions',
    'wr_recommendation_north_1': 'Regular monitoring',
    'wr_recommendation_north_2': 'Sustainable extraction',
    'wr_recommendation_north_3': 'Protect water sources',
    'wr_recommendation_central_1': 'Maintain water quality',
    'wr_recommendation_central_2': 'Ecological restoration',
    'wr_recommendation_central_3': 'Pollution prevention',
    'wr_recommendation_northwest_1': 'Reduce hardness',
    'wr_recommendation_northwest_2': 'Reduce salinity',
    'wr_recommendation_northwest_3': 'Improve water quality',
    'wr_recommendation_south_1': 'Collect and utilize',
    'wr_recommendation_south_2': 'Purify and treat',
    'wr_recommendation_south_3': 'Ecological protection',
    'recommendations': 'Recommendations',
    'recommendations_placeholder': 'Please enter recommendations, one per line',
    'remarks': 'Remarks',
    'remarks_placeholder': 'Please enter remarks',
    // Seasonal Guidance Page
    'ppn_seasonal_guidance_page_title': 'Seasonal Guidance',
    'ppn_seasonal_guidance_page_subtitle': 'Seasonal plant protection recommendations and precautions',
    'ppn_season_spring': 'Spring',
    'ppn_season_summer': 'Summer',
    'ppn_season_autumn': 'Autumn',
    'ppn_season_winter': 'Winter',
    'ppn_current_season': 'Current Season',
    'seasonal_guidance_title': 'Seasonal Guidance',
    'seasonal_guidance_subtitle': 'Seasonal recommendations and precautions to plan farm activities scientifically',
    'seasonal_guidance_add_button': 'New Guidance',
    'seasonal_guidance_select_season': 'Select Season',
    'seasonal_guidance_current_season_badge': 'Current Season',
    'seasonal_guidance_crop_label': 'Crop Type',
    'seasonal_guidance_region_label': 'Region',
    'seasonal_guidance_search_label': 'Search',
    'seasonal_guidance_search_placeholder': 'Search title, content, or author...',
    'seasonal_guidance_current_filters': 'Current filters:',
    'seasonal_guidance_search_tag': 'Search: {keyword}',
    'seasonal_guidance_clear_filters': 'Clear filters',
    'seasonal_guidance_records_found': '{count} records found',
    'seasonal_guidance_list_title': 'Guidance List',
    'seasonal_guidance_loading': 'Loading...',
    'seasonal_guidance_empty': 'No guidance data yet',
    'seasonal_guidance_author_label': 'Author: {author}',
    'seasonal_guidance_created_at_label': 'Created: {date}',
    'seasonal_guidance_updated_at_label': 'Updated: {date}',
    'seasonal_guidance_view': 'View details',
    'seasonal_guidance_edit': 'Edit',
    'seasonal_guidance_delete': 'Delete',
    'seasonal_guidance_delete_confirm': 'Are you sure you want to delete this guidance?',
    'seasonal_guidance_delete_success': 'Guidance deleted successfully!',
    'seasonal_guidance_delete_failed': 'Failed to delete guidance. Please try again.',
    'seasonal_guidance_add_success': 'Guidance added successfully!',
    'seasonal_guidance_add_failed': 'Failed to add guidance. Please try again.',
    'seasonal_guidance_update_success': 'Guidance updated successfully!',
    'seasonal_guidance_update_failed': 'Failed to update guidance. Please try again.',
    'seasonal_guidance_form_incomplete': 'Please complete all required guidance information!',
    'seasonal_guidance_form_heading_edit': 'Edit Guidance',
    'seasonal_guidance_form_heading_create': 'Create Guidance',
    'seasonal_guidance_form_title_label': 'Title *',
    'seasonal_guidance_form_title_placeholder': 'Enter guidance title',
    'seasonal_guidance_form_season_label': 'Season *',
    'seasonal_guidance_form_crop_label': 'Crop type *',
    'seasonal_guidance_form_region_label': 'Region *',
    'seasonal_guidance_form_author_label': 'Author *',
    'seasonal_guidance_form_author_placeholder': 'Enter author name',
    'seasonal_guidance_form_content_label': 'Guidance content *',
    'seasonal_guidance_form_content_placeholder': 'Enter detailed guidance content...',
    'seasonal_guidance_form_cancel': 'Cancel',
    'seasonal_guidance_form_submit_update': 'Update',
    'seasonal_guidance_form_submit_create': 'Create',
    'seasonal_guidance_validation_title': 'Please enter the guidance title!',
    'seasonal_guidance_validation_content': 'Please enter the guidance content!',
    'seasonal_guidance_validation_author': 'Please enter the author name!',
    'seasonal_guidance_submit_failed': 'Submission failed. Please try again.',
    'seasonal_guidance_init_failed': 'Failed to load the page. Please refresh and try again.',
    'seasonal_crop_all': 'All crops',
    'seasonal_crop_grain': 'Grain crops',
    'seasonal_crop_economic': 'Economic crops',
    'seasonal_crop_vegetable': 'Vegetable crops',
    'seasonal_crop_fruit': 'Fruit crops',
    'seasonal_region_all': 'Nationwide',
    'seasonal_region_north': 'North China',
    'seasonal_region_northeast': 'Northeast China',
    'seasonal_region_east': 'East China',
    'seasonal_region_central': 'Central China',
    'seasonal_region_south': 'South China',
    'seasonal_region_southwest': 'Southwest China',
    'seasonal_region_northwest': 'Northwest China',
    'seasonal_guidance_item_spring_wheat_title': 'Spring Wheat Planting Guidance',
    'seasonal_guidance_item_spring_wheat_content': 'Spring is critical for wheat growth. Focus on: 1) irrigate in time to keep soil moist; 2) apply fertilizer properly to promote tillering; 3) control pests, especially aphids and rust.',
    'seasonal_guidance_item_summer_rice_title': 'Summer Rice Management Essentials',
    'seasonal_guidance_item_summer_rice_content': 'With high temperatures and rainfall in summer, rice management must: 1) control water level to prevent lodging; 2) weed promptly to reduce competition; 3) manage rice planthoppers and sheath blight.',
    'seasonal_guidance_item_autumn_fruit_title': 'Autumn Orchard Pruning Techniques',
    'seasonal_guidance_item_autumn_fruit_content': 'Key autumn pruning steps: 1) thin dense branches to improve ventilation and light; 2) shorten fruiting shoots to encourage bud differentiation; 3) prevent pests and diseases to keep trees healthy.',
    'seasonal_guidance_item_winter_vegetable_title': 'Winter Greenhouse Vegetable Management',
    'seasonal_guidance_item_winter_vegetable_content': 'Winter greenhouse management tips: 1) regulate temperature to avoid frost damage; 2) ventilate reasonably to reduce diseases; 3) supplement light to support growth.',
    // Weather
    'weather_temperature': 'Temperature',
    'weather_humidity': 'Humidity',
    'weather_wind': 'Wind',
    'weather_sunrise': 'Sunrise',
    'weather_wind_force_unit': ' level',
    'weather_sunset': 'Sunset',
    'weather_unknown': 'Unknown',
    'weather_current': 'Current Weather',
    'weather_sunny': 'Sunny',
    'weather_cloudy': 'Cloudy',
    'weather_rainy': 'Rainy',
    'weather_snowy': 'Snowy',
    'weather_thunderstorm': 'Thunderstorm',
    'weather_trend_15days': 'Weather Trend',
    'weather_temp_high': 'High Temperature',
    'weather_temp_low': 'Low Temperature',
    'weather_wind_force': 'Wind Force',
    
    // Plant Protection
    'plant_protection_advice': 'Plant Protection Advice',
    'plant_protection_warning': 'Pest & Disease Warning',
    'plant_protection_inquiry': 'AI Smart Service',
    'plant_protection_no_data': 'No data',
    'plant_protection_upload': 'Upload',
    'plant_protection_inquire': 'Inquire',
    'plant_protection_placeholder': 'Paste image or ask any plant protection question',

    // Equipment Management
    'equipment_mgmt_title': 'Equipment Management',
    'equipment_name': 'Equipment Name',
    'equipment_type': 'Equipment Type',
    'equipment_status': 'Equipment Status',
    'equipment_location': 'Location',
    'equipment_operator': 'Operator',
    'equipment_fuel_level': 'Fuel Level',
    'equipment_working_hours': 'Working Hours',
    'last_maintenance': 'Last Maintenance',
    'next_maintenance': 'Next Maintenance',
    'equipment_tractor': 'Tractor',
    'equipment_seeder': 'Seeder',
    'equipment_harvester': 'Harvester',
    'equipment_irrigation': 'Irrigation Equipment',
    'equipment_other': 'Other',
    'status_operational': 'Operational',
    'status_maintenance': 'Under Maintenance',
    'status_idle': 'Idle',
    'status_broken': 'Broken',
    'add_equipment': 'Add Equipment',
    'maintenance_record': 'Maintenance Record',

    // Knowledge Base
    'knowledge_base_title': 'Knowledge Base',
    'knowledge_search': 'Search knowledge...',
    'knowledge_category': 'Category',
    'knowledge_all': 'All',
    'knowledge_pest_disease': 'Pest & Disease',
    'knowledge_fertilizer': 'Fertilization',
    'knowledge_irrigation': 'Irrigation',
    'knowledge_crop_protection': 'Crop Protection',
    'knowledge_soil': 'Soil Management',
    'knowledge_detail': 'Knowledge Details',
    'related_knowledge': 'Related Knowledge',
    'knowledge_added': 'Added',
    // Mall
    'mall_title': 'Agricultural Mall',
    'mall_product': 'Product',
    'mall_category': 'Category',
    'mall_price': 'Price',
    'mall_stock': 'Stock',
    'mall_sales': 'Sales',
    'mall_add_to_cart': 'Add to Cart',
    'mall_buy_now': 'Buy Now',
    'mall_cart': 'Shopping Cart',
    'mall_order': 'Order',
    'mall_my_orders': 'My Orders',
    'mall_product_detail': 'Product Details',
    'mall_search_placeholder': 'Search products, brands or keywords...',
    'mall_all_categories': 'All Categories',
    'mall_pesticide': 'Pesticide',
    'mall_fertilizer': 'Fertilizer',
    'mall_seed': 'Seed',
    'mall_equipment': 'Equipment',
    'mall_tools': 'Tools',
    'mall_my_favorites': 'My Favorites',
    'mall_my_mall': 'My Mall',
    'mall_management_title': 'Mall Management',
    'mall_min_price': 'Min Price',
    'mall_max_price': 'Max Price',
    'mall_all_time': 'All Time',
    'mall_last_7_days': 'Last 7 Days',
    'mall_last_30_days': 'Last 30 Days',
    'mall_last_90_days': 'Last 90 Days',
    'mall_sort_comprehensive': 'Comprehensive',
    'mall_sort_sales': 'Best Selling',
    'mall_sort_price_asc': 'Price: Low to High',
    'mall_sort_price_desc': 'Price: High to Low',
    'mall_sort_latest': 'Latest',
    'mall_in_stock_only': 'In Stock Only',
    'mall_found': 'Found',
    'mall_items': 'items',
    'mall_keyword': 'Keyword: ',
    'mall_filter_category': 'Category: ',
    'mall_filter_search': 'Search: ',
    'mall_filter_price': 'Price: ',
    'mall_filter_listing': 'Listed: ',
    'mall_filter_days': 'Last {days} days',
    'mall_filter_in_stock': 'In Stock',
    'mall_temp_cart': 'Temporary Cart',
    'mall_temp_cart_desc': 'Login to sync to your account',
    'mall_view_cart': 'View',
    'mall_price_update': 'Price Updated',
    'mall_price_changed_msg': 'Product prices have changed, please confirm before submitting order.',
    'mall_refresh_price': 'Refresh Price',
    'mall_favorites_page': 'Favorites',
    'mall_back_to_all': 'Back to All Products',
    'mall_badge_new': 'New',
    'mall_badge_hot': 'Hot',
    'mall_badge_low_stock': 'Low Stock',
    'mall_badge_out_of_stock': 'Out of Stock',
    'mall_no_favorites': 'No Favorites',
    'mall_no_products': 'No Products',
    'mall_no_favorites_desc': 'You haven\'t favorited any products yet',
    'mall_no_products_desc': 'No products found matching the criteria',
    'mall_clear_filters': 'Clear Filters',
    'mall_stock_count': 'Stock {count}',
    'mall_sales_count': 'Sales {count}',
    'mall_member_price': 'Member Price {price}',
    'mall_prev_page': 'Previous',
    'mall_next_page': 'Next',
    'mall_page_num': 'Page {num}',
    'mall_search_history': 'Search History',
    'mall_search_suggestions': 'Suggestions',
    'mall_clear_search': 'Clear Search',
    'mall_remove_filter': 'Remove Filter',
    'mall_add_to_favorites': 'Add to Favorites',
    'mall_remove_from_favorites': 'Remove from Favorites',
    'mall_skip_to_content': 'Skip to Main Content',
    'mall_favorites_count': '{count} items',
    'mall_uncategorized': 'Uncategorized',
    'mall_cart_merged': 'Temporary cart has been merged into your account',
    'mall_added_to_temp_cart': 'Added to temporary cart, login to sync to your account',
    'mall_load_failed': 'Failed to load product data',
    'mall_invalid_user_id': 'Invalid user ID: {id}, please login again',

    // System Management
    'system_management': 'System Management',
    'user_management': 'User Management',
    'role_management': 'Role Management',
    'permission_management': 'Permission Management',
    'menu_management': 'Menu Management',
    'tenant_management': 'Tenant Management',
    'organization_management': 'Organization Management',
    'operation_log': 'Operation Log',
    'system_settings': 'System Settings',
    'ai_settings': 'AI Settings',
    'security_settings': 'Security Settings',

    // My Plant Protection Module
    'my_plant_protection_title': 'Production Management',
    'planting_planning': 'Planting Plan (Future)',
    'field_management': 'Field Management',
    'sowing_management': 'Sowing Management',
    'fertilization_management': 'Fertilization Management',
    'irrigation_management': 'Irrigation Management',
    'weeding_management': 'Weeding Management',
    'harvest_management': 'Harvest Management',
    'disease_warning': 'Disease Warning',
    'land_plot': 'Land Plot',
    'crop_variety': 'Crop Variety',
    'planting_area': 'Planting Area',
    'planting_date': 'Planting Date',
    'expected_harvest': 'Expected Harvest',
    'growth_stage': 'Growth Stage',
    'task_list': 'Task List',
    'add_task': 'Add Task',
    'task_name': 'Task Name',
    'task_type': 'Task Type',
    'task_status': 'Task Status',
    'task_priority': 'Priority',
    'task_assignee': 'Assignee',
    'task_deadline': 'Deadline',
    'task_completed': 'Completed',
    'task_pending': 'Pending',
    'task_in_progress': 'In Progress',

    'nav_knowledge': 'Knowledge Base',
    'nav_plant_protection_mall': 'Agri Supplies Mall',
    'nav_profile': 'Profile',
    'nav_account_settings': 'Account Settings',
    'nav_my_comments': 'My Comments',
    'nav_my_favorites': 'My Favorites',
    'nav_my_likes': 'My Likes',
    'nav_my_orders': 'My Orders',
    'nav_my_shares': 'My Shares',
    'nav_membership': 'Membership',
    'membership_history': 'Membership History',

    'nav_data_crawling': 'Data Crawling',
    'nav_data_analytics': 'Data Analytics',
    'nav_global_monitoring': 'Global Monitoring',
    'nav_local_prevention': 'Local Prevention',
    'nav_pest_disease': 'Pest & Disease',
    'nav_public_opinion': 'Public Opinion',
    'nav_weather_disaster': 'Weather Disaster',
    'nav_network_trend_analysis': 'Network Trend Analysis',
    'nav_system_management': 'System Management',
    'nav_user_management': 'User Management',
    'nav_role_management': 'Role Management',
    'nav_permission_management': 'Permission Management',
    'nav_user_role': 'User Role',
    'nav_role_permission': 'Role Permission',
    'nav_page_permission': 'Page Permissions',
    'nav_organization': 'Organization',
    'nav_tenant_management': 'Tenant Management',
    'nav_operation_log': 'Operation Log',
    'nav_resource_monitoring': 'Resource Monitoring',
    'nav_agricultural_material': 'Agricultural Material',
    'nav_machine_management': 'Machine Management',
    'nav_machine_rental': 'Machine Rental',
    'nav_planting_resource': 'Planting Resource',
    'nav_planting_plan': 'Planting Plan',
    'nav_field_operation': 'Field Operation',
    'nav_field_work_overview': 'Field Work Overview',
    'nav_field_operations': 'Field Operations Ledger',
    'nav_planting_planning': 'Planting Plan (Future)',
    'nav_field_task': 'Field Task',
    'nav_environment_monitoring': 'Soil Moisture',
    'nav_smart_irrigation_hub': 'Smart Irrigation & Monitoring',
    'nav_warning_management': 'Warning Management',
    'nav_disease_diagnosis_system': 'Plant Protection Inquiry',
    'nav_knowledge_system': 'Knowledge System',
    'nav_notification': 'Notification',
    'nav_statistics': 'Statistics',
    'nav_asset_statistics': 'Asset Statistics',
    'nav_output_statistics': 'Output Statistics',
    'nav_performance_tracking': 'Performance Tracking',
    'nav_economic_analysis': 'Economic Analysis',
    'nav_resource_monitoring_system': 'Resource Monitoring',
    'nav_planning_statistics': 'Planning Statistics',
    'nav_land_management': 'Land Management',
    'nav_system_settings': 'System Settings',
    'nav_cache_management': 'Cache Management',
    'nav_ai_settings': 'AI Settings',
    'nav_database_health_check': 'Database Health Check',
    'nav_dict_management': 'Dictionary Management',
    'nav_finance_management': 'Finance Management',
    'nav_security_settings': 'Security Settings',
    'nav_mall_management': 'Mall Management',
    'nav_vip_management': 'VIP Management',
    'nav_membership_management': 'Membership Management',
    'nav_asset_management': 'Asset Management',
    'nav_economic_statistics': 'Economic Statistics',
    'nav_data_visualization': 'Data Visualization',

    // Land management page i18n (page specific)
    'land_page_title': 'Land Management',
    'land_page_subtitle': 'Manage and view land plots',

    'land_stat_total_count': 'Total Plots',
    'land_stat_total_area': 'Total Area',
    'land_stat_in_progress': 'In Planting',
    'land_stat_idle': 'Idle',
    'land_unit_block': 'plots',
    'land_unit_area': ' mu',

    'land_data_source_tip': 'Data source: Started planting plans',

    'land_search_code': 'Land Code',
    'land_search_name': 'Land Name',
    'land_search_crop': 'Crop Type',
    'land_search_status': 'Status',
    'land_placeholder_code': 'Enter land code',
    'land_placeholder_name': 'Enter land name',
    'land_placeholder_select_crop': 'Select crop type',
    'land_placeholder_select_status': 'Select status',

    'land_button_refresh': 'Refresh List',
    'land_button_add': 'Add Land',

    'land_column_code': 'Land Code',
    'land_column_name': 'Land Name',
    'land_column_crop': 'Crop',
    'land_column_area': 'Area',
    'land_column_location': 'Location',
    'land_column_soil': 'Soil',
    'land_column_irrigation': 'Irrigation',
    'land_column_status': 'Status',
    'land_column_planting_date': 'Start Date',
    'land_column_operator': 'Operator',
    'land_column_notes': 'Notes',
    'land_column_actions': 'Actions',
    'land_action_view': 'View',

    'land_status_planting': 'Planting',
    'land_status_idle': 'Idle',
    'land_status_fallow': 'Fallow',
    'land_status_constructing': 'Constructing',

    'land_soil_loam': 'Loam',
    'land_soil_sandy': 'Sandy',
    'land_soil_clay': 'Clay',
    'land_soil_silt': 'Silt',
    'land_soil_black': 'Black soil',

    'land_irrigation_spray': 'Spray',
    'land_irrigation_drip': 'Drip',
    'land_irrigation_furrow': 'Furrow',
    'land_irrigation_flood': 'Flood',
    'land_irrigation_none': 'None',

    'land_unknown_name': 'Unknown land',
    'land_unknown_crop': 'Unknown crop',
    'land_unknown_location': 'Unknown location',
    'land_unknown_operator': 'Unknown operator',
    'land_generated_notes': 'System generated notes',

    'land_load_failed': 'Failed to load land data',
    'land_delete_success': 'Deleted successfully',
    'land_delete_failed': 'Delete failed',
    'land_confirm_delete_message': 'Are you sure you want to delete this land plot? This action cannot be undone.',
    'land_batch_delete_empty': 'Please select plots to delete',
    'land_batch_delete_success': 'Batch deleted successfully',
    'land_edit_success': 'Updated successfully',
    'land_add_success': 'Added successfully',
    'land_default_operator': 'System',

    'land_modal_view_title': 'Land Details',
    'land_modal_edit_title': 'Edit Land',
    'land_modal_add_title': 'Add Land',

    'land_field_code': 'Land Code',
    'land_field_name': 'Land Name',
    'land_field_crop': 'Crop Type',
    'land_field_area': 'Area',
    'land_field_location': 'Location',
    'land_field_soil': 'Soil Type',
    'land_field_irrigation': 'Irrigation',
    'land_field_operator': 'Operator',
    'land_field_notes': 'Notes',
    'land_field_status': 'Status',
    'land_field_planting_date': 'Planting Date',

    'land_rule_code': 'Please enter land code',
    'land_rule_name': 'Please enter land name',
    'land_rule_crop': 'Please select crop type',
    'land_rule_area': 'Please enter area',
    'land_rule_location': 'Please enter location',
    'land_rule_soil': 'Please select soil type',
    'land_rule_irrigation': 'Please select irrigation',
    'land_rule_operator': 'Please enter operator',

    'land_placeholder_area': 'Enter area',
    'land_placeholder_location': 'Enter location',
    'land_placeholder_operator': 'Enter operator',
    'land_placeholder_notes': 'Enter notes',
    'land_placeholder_select_soil': 'Select soil type',
    'land_placeholder_select_irrigation': 'Select irrigation',

    'land_crop_wheat': 'Wheat',
    'land_crop_corn': 'Corn',
    'land_crop_rice': 'Rice',
    'land_crop_vegetable': 'Vegetable',
    'land_crop_fruit': 'Fruit',

    'land_pagination_total': 'Showing {start}-{end} of {total} items',

    // Growth Budget page i18n
    'gb_page_title': 'Growth Budget Management',
    'gb_page_subtitle': 'Growth estimation, yield prediction and cost-profit analysis for planting plans',
    'gb_stat_total_crops': 'Total Crops',
    'gb_stat_total_area': 'Total Area',
    'gb_stat_avg_profit': 'Average Profit',
    'gb_stat_total_profit': 'Total Profit',
    'gb_unit_crop_kind': ' kinds',
    'gb_unit_mu': ' mu',
    'gb_unit_yuan_per_mu': ' CNY/mu',
    'gb_unit_yuan': ' CNY',
    'gb_filter_crop_label': 'Crop:',
    'gb_filter_all_crops': 'All Crops',
    'gb_action_add_budget': 'Add Budget',
    'gb_chart_growth_cycle': 'Growth Cycle Forecast',
    'gb_series_days_grown': 'Days Grown',
    'gb_series_days_remaining': 'Days Remaining',
    'gb_chart_yield_profit': 'Yield & Profit Forecast',
    'gb_series_expected_yield_kg': 'Expected Yield (kg)',
    'gb_series_profit_yuan': 'Profit (CNY)',
    'gb_chart_time_analysis': 'Time Analysis',
    'gb_series_days': 'Days',
    'gb_key_time_nodes': 'Key Time Nodes',
    'gb_stage_sowing_short': 'Sowing',
    'gb_stage_heading_short': 'Heading',
    'gb_stage_harvest_short': 'Harvest',
    'gb_stage_next_batch_short': 'Next Batch',
    'gb_table_title': 'Growth Budget List',
    'gb_pagination_total': 'Showing {start}-{end} of {total} items',
    'gb_modal_edit_title': 'Edit Growth Budget',
    'gb_modal_add_title': 'Add Growth Budget',
    'gb_field_crop_name': 'Crop Name',
    'gb_field_land_name': 'Land Name',
    'gb_field_planting_date': 'Planting Date',
    'gb_field_current_stage': 'Current Stage',
    'gb_field_expected_heading': 'Expected Heading Date',
    'gb_field_expected_harvest': 'Expected Harvest Date',
    'gb_field_next_planting': 'Next Planting Date',
    'gb_field_growth_cycle_days': 'Growth Cycle (days)',
    'gb_field_expected_yield': 'Expected Yield (kg/mu)',
    'gb_field_cost_per_mu': 'Cost (CNY/mu)',
    'gb_field_expected_revenue': 'Expected Revenue (CNY/mu)',
    'gb_field_profit_per_mu': 'Profit (CNY/mu)',
    'gb_field_notes': 'Notes',
    'gb_rule_crop_name': 'Please select crop name',
    'gb_rule_land_name': 'Please enter land name',
    'gb_rule_planting_date': 'Please select planting date',
    'gb_rule_current_stage': 'Please select current stage',
    'gb_rule_expected_heading': 'Please select expected heading date',
    'gb_rule_expected_harvest': 'Please select expected harvest date',
    'gb_rule_next_planting': 'Please select next planting date',
    'gb_rule_growth_cycle': 'Please enter growth cycle',
    'gb_rule_expected_yield': 'Please enter expected yield',
    'gb_rule_cost_per_mu': 'Please enter cost',
    'gb_rule_expected_revenue': 'Please enter expected revenue',
    'gb_rule_profit_per_mu': 'Please enter profit',
    'gb_placeholder_crop_name': 'Select crop name',
    'gb_placeholder_land_name': 'Enter land name',
    'gb_placeholder_current_stage': 'Select current stage',
    'gb_placeholder_days': 'Days',
    'gb_placeholder_yield': 'Yield',
    'gb_placeholder_cost': 'Cost',
    'gb_placeholder_revenue': 'Revenue',
    'gb_placeholder_profit': 'Profit',
    'gb_placeholder_notes': 'Enter notes',
    'gb_crop_wheat': 'Wheat',
    'gb_crop_corn': 'Corn',
    'gb_crop_rice': 'Rice',
    'gb_crop_vegetable': 'Vegetable',
    'gb_stage_sowing': 'Sowing',
    'gb_stage_seedling': 'Seedling',
    'gb_stage_tillering': 'Tillering',
    'gb_stage_jointing': 'Jointing',
    'gb_stage_heading': 'Heading',
    'gb_stage_flowering': 'Flowering',
    'gb_stage_filling': 'Filling',
    'gb_stage_maturity': 'Maturity',

    // Growth Budget - table columns
    'gb_column_crop_name': 'Crop',
    'gb_column_land_name': 'Land',
    'gb_column_planting_date': 'Planting Date',
    'gb_column_current_stage': 'Current Stage',
    'gb_column_expected_heading': 'Expected Heading',
    'gb_column_expected_harvest': 'Expected Harvest',
    'gb_column_next_planting': 'Next Planting',
    'gb_column_growth_cycle_days': 'Growth Cycle (days)',
    'gb_column_expected_yield_kg_per_mu': 'Expected Yield (kg/mu)',
    'gb_column_cost_yuan_per_mu': 'Cost (CNY/mu)',
    'gb_column_expected_revenue': 'Expected Revenue (CNY/mu)',
    'gb_column_profit_per_mu': 'Profit (CNY/mu)',
    'gb_column_actions': 'Actions',

    // Warning Analysis page i18n (en-US)
    'wa_page_title': 'Warning Analysis',
    'wa_page_subtitle': 'Analyze pest, weather and other warnings for planted fields and take actions promptly',
    'wa_stat_total': 'Total Warnings',
    'wa_stat_pending': 'Pending Warnings',
    'wa_stat_high_level': 'High-level Warnings',
    'wa_stat_total_loss': 'Estimated Total Loss',
    'wa_unit_item': ' items',
    'wa_unit_mu': ' mu',
    'wa_filter_type_label': 'Warning Type:',
    'wa_filter_all_types': 'All Types',
    'wa_type_pest': 'Pest Warning',
    'wa_type_weather': 'Weather Warning',
    'wa_type_soil': 'Soil Warning',
    'wa_type_water_fertilizer': 'Water & Fertilizer Warning',
    'wa_filter_status_label': 'Status:',
    'wa_filter_all_status': 'All Statuses',
    'wa_status_pending': 'Pending',
    'wa_status_processing': 'Processing',
    'wa_status_resolved': 'Resolved',
    'wa_status_ignored': 'Ignored',
    'wa_level_high': 'High',
    'wa_level_medium': 'Medium',
    'wa_level_low': 'Low',
    'wa_crop_wheat': 'Wheat',
    'wa_crop_corn': 'Corn',
    'wa_crop_rice': 'Rice',
    'wa_crop_vegetable': 'Vegetable',
    'wa_action_add_warning': 'Add Warning',
    'wa_table_title': 'Warning List',
    'wa_pagination_total': 'Showing {start}-{end} of {total} items',
    'wa_column_warning_code': 'Code',
    'wa_column_warning_type': 'Type',
    'wa_column_warning_level': 'Level',
    'wa_column_land_name': 'Land',
    'wa_column_crop_name': 'Crop',
    'wa_column_warning_content': 'Content',
    'wa_column_detected_date': 'Detected Date',
    'wa_column_status': 'Status',
    'wa_column_actions': 'Actions',
    'wa_modal_view_title': 'Warning Details',
    'wa_modal_edit_title': 'Edit Warning',
    'wa_modal_add_title': 'Add Warning',
    'wa_field_warning_code': 'Warning Code',
    'wa_field_warning_type': 'Warning Type',
    'wa_field_warning_level': 'Warning Level',
    'wa_field_land_name': 'Land Name',
    'wa_field_crop_name': 'Crop Name',
    'wa_field_detected_date': 'Detected Date',
    'wa_field_status': 'Status',
    'wa_field_priority': 'Priority',
    'wa_field_warning_content': 'Warning Content',
    'wa_field_affected_area': 'Affected Area',
    'wa_field_estimated_loss': 'Estimated Loss',
    'wa_field_suggested_action': 'Suggested Action',
    'wa_field_operator': 'Operator',
    'wa_field_notes': 'Notes',
    'wa_rule_warning_type': 'Please select warning type',
    'wa_rule_warning_level': 'Please select warning level',
    'wa_rule_land_name': 'Please enter land name',
    'wa_rule_crop_name': 'Please enter crop name',
    'wa_rule_priority': 'Please select priority',
    'wa_rule_affected_area': 'Please enter affected area',
    'wa_rule_estimated_loss': 'Please enter estimated loss',
    'wa_rule_status': 'Please select status',
    'wa_rule_warning_content': 'Please enter warning content',
    'wa_rule_suggested_action': 'Please enter suggested action',
    'wa_placeholder_warning_type': 'Select warning type',
    'wa_placeholder_warning_level': 'Select warning level',
    'wa_placeholder_land_name': 'Enter land name',
    'wa_placeholder_crop_name': 'Enter crop name',
    'wa_placeholder_priority': 'Select priority',
    'wa_placeholder_area': 'Area',
    'wa_placeholder_loss': 'Loss amount',
    'wa_placeholder_status': 'Select status',
    'wa_placeholder_warning_content': 'Enter warning content',
    'wa_placeholder_suggested_action': 'Enter suggested action',
    'wa_placeholder_notes': 'Enter notes',

    // Expert Advice page i18n (en-US)
    'ea_page_title': 'Expert Advice Management',
    'ea_page_subtitle': 'Expert advice based on field and crop status, including pest control, water-fertilizer management, and planting techniques',
    'ea_stat_total': 'Total Advice',
    'ea_stat_active': 'Active Advice',
    'ea_stat_avg_effectiveness': 'Average Effectiveness',
    'ea_stat_total_benefit': 'Estimated Total Benefit',
    'ea_unit_item': ' items',
    'ea_unit_score': ' score',
    'ea_filter_type_label': 'Advice Type:',
    'ea_filter_all_types': 'All Types',
    'ea_type_pest_control': 'Pest Control',
    'ea_type_water_fertilizer': 'Water & Fertilizer',
    'ea_type_planting_tech': 'Planting Technique',
    'ea_type_environment': 'Environment Management',
    'ea_filter_crop_label': 'Crop:',
    'ea_filter_all_crops': 'All Crops',
    'ea_action_add_advice': 'Add Advice',
    'ea_table_title': 'Expert Advice List',
    'ea_pagination_total': 'Showing {start}-{end} of {total} items',
    'ea_column_advice_code': 'Advice Code',
    'ea_column_advice_type': 'Advice Type',
    'ea_column_crop_name': 'Crop',
    'ea_column_land_name': 'Land',
    'ea_column_expert_name': 'Expert',
    'ea_column_advice_title': 'Title',
    'ea_column_advice_date': 'Date',
    'ea_column_priority': 'Priority',
    'ea_column_adoption_rate': 'Adoption Rate',
    'ea_column_effectiveness': 'Effectiveness',
    'ea_column_estimated_cost': 'Estimated Cost',
    'ea_column_estimated_benefit': 'Estimated Benefit',
    'ea_column_actions': 'Actions',
    'ea_modal_edit_title': 'Edit Expert Advice',
    'ea_modal_add_title': 'Add Expert Advice',
    'ea_modal_view_title': 'Expert Advice Details',
    'ea_field_advice_code': 'Advice Code',
    'ea_field_advice_type': 'Advice Type',
    'ea_field_crop_name': 'Crop Name',
    'ea_field_land_name': 'Land Name',
    'ea_field_expert_name': 'Expert Name',
    'ea_field_expert_title': 'Expert Title',
    'ea_field_advice_date': 'Advice Date',
    'ea_field_priority': 'Priority',
    'ea_field_estimated_cost': 'Estimated Cost (CNY)',
    'ea_field_estimated_benefit': 'Estimated Benefit (CNY)',
    'ea_field_advice_title': 'Advice Title',
    'ea_field_advice_content': 'Advice Content',
    'ea_field_implementation_steps': 'Implementation Steps',
    'ea_field_precautions': 'Precautions',
    'ea_field_follow_up': 'Follow-up',
    'ea_rule_advice_type': 'Please select advice type',
    'ea_rule_crop_name': 'Please select crop name',
    'ea_rule_land_name': 'Please enter land name',
    'ea_rule_priority': 'Please select priority',
    'ea_rule_expert_name': 'Please enter expert name',
    'ea_rule_expert_title': 'Please enter expert title',
    'ea_rule_estimated_cost': 'Please enter estimated cost',
    'ea_rule_estimated_benefit': 'Please enter estimated benefit',
    'ea_rule_advice_title': 'Please enter advice title',
    'ea_rule_advice_content': 'Please enter advice content',
    'ea_rule_implementation_steps': 'Please enter implementation steps',
    'ea_placeholder_advice_type': 'Select advice type',
    'ea_placeholder_crop_name': 'Select crop',
    'ea_placeholder_land_name': 'Enter land name',
    'ea_placeholder_priority': 'Select priority',
    'ea_placeholder_expert_name': 'Enter expert name',
    'ea_placeholder_expert_title': 'Enter expert title',
    'ea_placeholder_cost': 'Cost',
    'ea_placeholder_benefit': 'Benefit',
    'ea_placeholder_advice_title': 'Enter advice title',
    'ea_placeholder_advice_content': 'Enter advice content',
    'ea_placeholder_implementation_steps': 'Enter steps, one per line',
    'ea_placeholder_precautions': 'Enter precautions',
    'ea_placeholder_follow_up': 'Enter follow-up actions',
    'ea_tip_viewing_for_crop': 'Viewing advice for {crop}',
    'ea_field_crop_id': 'Crop ID',
    'ea_not_specified': 'Not specified',
    'ea_action_clear_filter': 'Clear filter',
    'ea_section_basic_info': 'Basic Information',
    'ea_section_content': 'Advice Content',
    'ea_section_notes': 'Precautions',
    'ea_section_follow_up': 'Follow-up Actions',
    'ea_section_evaluation': 'Effectiveness Evaluation',
    'ea_section_feedback': 'User Feedback',

    // Seasonal Guidance page (en-US)
    'sg_page_title': 'Seasonal Guidance Management',
    'sg_page_subtitle': 'Provide seasonal planting guidance, calendar reminders, pest prevention and weather response advice',
    'sg_current_season': 'Current Season',
    'sg_now_is_season': 'It is {season} now. Please focus on seasonal management points for related crops',
    'sg_stat_total': 'Total Guidance',
    'sg_stat_active': 'Active Guidance',
    'sg_stat_high_priority': 'High Priority',
    'sg_stat_total_yield': 'Estimated Total Yield',
    'sg_unit_item': ' items',
    'sg_unit_kg_per_mu': ' kg/mu',
    'sg_filter_season_label': 'Season:',
    'sg_filter_all_seasons': 'All Seasons',
    'sg_season_spring': 'Spring',
    'sg_season_summer': 'Summer',
    'sg_season_autumn': 'Autumn',
    'sg_season_winter': 'Winter',
    'sg_filter_crop_label': 'Crop:',
    'sg_action_add_guidance': 'Add Guidance',
    'sg_table_title': 'Seasonal Guidance List',
    'sg_pagination_total': 'Showing {start}-{end} of {total} items',
    'sg_column_guidance_code': 'Code',
    'sg_column_season': 'Season',
    'sg_column_crop_name': 'Crop',
    'sg_column_guidance_title': 'Title',
    'sg_column_date_range': 'Date Range',
    'sg_column_priority': 'Priority',
    'sg_column_estimated_yield': 'Estimated Yield',
    'sg_column_risk_factors': 'Risk Factors',
    'sg_column_actions': 'Actions',
    'sg_modal_edit_title': 'Edit Guidance',
    'sg_modal_add_title': 'Add Guidance',
    'sg_modal_view_title': 'Guidance Details',
    'sg_field_guidance_code': 'Guidance Code',
    'sg_field_season': 'Season',
    'sg_field_crop_name': 'Crop Name',
    'sg_field_guidance_title': 'Guidance Title',
    'sg_field_guidance_content': 'Guidance Content',
    'sg_field_start_date': 'Start Date',
    'sg_field_end_date': 'End Date',
    'sg_field_priority': 'Priority',
    'sg_field_estimated_yield': 'Estimated Yield',
    'sg_field_weather_notes': 'Weather Notes',
    'sg_field_pest_prevention': 'Pest Prevention',
    'sg_field_farming_tasks': 'Farming Tasks',
    'sg_field_risk_factors': 'Risk Factors',
    'sg_field_status': 'Status',
    'sg_section_basic_info': 'Basic Information',
    'sg_section_content': 'Guidance Content',
    'sg_section_history_compare': 'Historical Comparison',
    'sg_field_year': 'Year',
    'sg_field_yield': 'Yield (kg/mu)',
    'sg_field_main_issues': 'Main Issues',
    'sg_column_actions_tip': 'Actions',
    'sg_rule_season': 'Please select season',
    'sg_rule_crop_name': 'Please select crop',
    'sg_rule_start_date': 'Please select start date',
    'sg_rule_end_date': 'Please select end date',
    'sg_rule_priority': 'Please select priority',
    'sg_rule_estimated_yield': 'Please enter estimated yield',
    'sg_rule_guidance_title': 'Please enter guidance title',
    'sg_rule_guidance_content': 'Please enter guidance content',
    'sg_placeholder_season': 'Select season',
    'sg_placeholder_crop_name': 'Select crop',
    'sg_placeholder_yield': 'Yield',
    'sg_placeholder_guidance_title': 'Enter guidance title',
    'sg_placeholder_guidance_content': 'Enter guidance content',
    'sg_placeholder_weather_notes': 'Enter weather notes',
    'sg_placeholder_pest_prevention': 'Enter pest prevention points',
    'sg_placeholder_farming_tasks': 'Enter tasks, one per line',
    'sg_placeholder_risk_factors': 'Enter risk factors, separated by commas',
    'sg_crop_all': 'All Crops',
    'sg_crop_wheat': 'Wheat',
    'sg_crop_corn': 'Corn',
    'sg_crop_rice': 'Rice',
    'sg_crop_vegetable': 'Vegetable',
    'sg_priority_high': 'High',
    'sg_priority_medium': 'Medium',
    'sg_priority_low': 'Low',
    'sg_action_view': 'View',
    'sg_action_edit': 'Edit',
    'sg_action_delete': 'Delete',
    'sg_action_confirm': 'Confirm',
    'sg_action_cancel': 'Cancel',
    'sg_date_start': 'Start',
    'sg_date_end': 'End',
    'sg_msg_delete_success': 'Deleted successfully',
    'sg_msg_edit_success': 'Updated successfully',
    'sg_msg_add_success': 'Added successfully',
    'sg_msg_form_validation_failed': 'Form validation failed',
    'sg_tab_seasonal_advice': 'Seasonal Planting Advice',
    'sg_tab_solar_term': 'Solar Term Farming Guide',
    'sg_tab_pest_control': 'Seasonal Pest Control',
    'sg_tab_management': 'Seasonal Management Points',

  // Agricultural Materials (en-US)
  'am_page_title': 'Agricultural Material Management',
  'am_page_subtitle': 'Manage information of pesticides, fertilizers, seeds, etc., including categories, usage, safety notes, supplier info',
  'am_stat_total': 'Total Materials',
  'am_stat_active': 'Active Materials',
  'am_stat_avg_quality': 'Average Quality Rating',
  'am_stat_total_value': 'Total Value',
  'am_unit_kind': ' kinds',
  'am_unit_score': ' score',
  'am_filter_category_label': 'Category:',
  'am_filter_all_categories': 'All Categories',
  'am_category_pesticide': 'Pesticide',
  'am_category_fertilizer': 'Fertilizer',
  'am_category_seed': 'Seed',
  'am_category_tool': 'Tool',
  'am_filter_supplier_label': 'Supplier:',
  'am_filter_all_suppliers': 'All Suppliers',
  'am_action_add_material': 'Add Material',
  'am_table_title': 'Material List',
  'am_pagination_total': 'Showing {start}-{end} of {total} items',
  'am_column_code': 'Code',
  'am_column_name': 'Name',
  'am_column_category': 'Category',
  'am_column_brand': 'Brand',
  'am_column_supplier': 'Supplier',
  'am_column_spec': 'Specification',
  'am_column_package': 'Package',
  'am_column_price': 'Price',
  'am_column_quality': 'Quality',
  'am_column_safety': 'Safety Level',
  'am_column_actions': 'Actions',
  'am_modal_edit_title': 'Edit Material',
  'am_modal_add_title': 'Add Material',
  'am_modal_view_title': 'Material Details',
  'am_section_basic_info': 'Basic Info',
  'am_section_inventory': 'Inventory',
  'am_load_failed': 'Failed to load materials',
  'am_field_name': 'Name',
  'am_rule_name': 'Please enter material name',
  'am_placeholder_name': 'Enter name',
  'am_field_code': 'Code',
  'am_rule_code': 'Please enter material code',
  'am_placeholder_code': 'Enter code',
  'am_field_category': 'Category',
  'am_rule_category': 'Please select category',
  'am_placeholder_category': 'Select category',
  'am_field_subcategory': 'Subcategory',
  'am_placeholder_subcategory': 'Enter subcategory',
  'am_field_brand': 'Brand',
  'am_rule_brand': 'Please enter brand',
  'am_placeholder_brand': 'Enter brand',
  'am_field_spec': 'Specification',
  'am_rule_spec': 'Please enter specification',
  'am_placeholder_spec': 'Enter specification',
  'am_field_package': 'Package',
  'am_placeholder_package': 'Enter package',
  'am_field_unit': 'Unit',
  'am_rule_unit': 'Please enter unit',
  'am_placeholder_unit': 'Enter unit',
  'am_field_price': 'Price (CNY)',
  'am_rule_price': 'Please enter price',
  'am_placeholder_price': 'Enter price',
  'am_field_safety': 'Safety Level',
  'am_placeholder_safety': 'Select safety level',
  'am_safety_high': 'Highly toxic',
  'am_safety_medium': 'Moderately toxic',
  'am_safety_low': 'Low toxic',
  'am_safety_very_low': 'Slightly toxic',
  'am_not_set': 'Not set',
  'am_field_quantity': 'Quantity',
  'am_placeholder_quantity': 'Enter quantity',
  'am_field_min_stock': 'Min Stock',
  'am_placeholder_min_stock': 'Enter min stock',
  'am_field_max_stock': 'Max Stock',
  'am_placeholder_max_stock': 'Enter max stock',
  'am_field_storage_location': 'Storage Location',
  'am_placeholder_storage_location': 'Enter storage location',
  'am_field_supplier': 'Supplier',
  'am_placeholder_supplier': 'Enter supplier',
  'am_field_quality': 'Quality',
  'am_field_expiry_date': 'Expiry Date',
  'am_placeholder_expiry_date': 'Pick expiry date',
  'am_field_usage_instructions': 'Usage Instructions',
  'am_placeholder_usage_instructions': 'Enter usage instructions',
  'am_field_safety_notes': 'Safety Notes',
  'am_placeholder_safety_notes': 'Enter safety notes',
  'am_none': 'None',
  'am_search_placeholder': 'Search material name, brand or supplier...',
  'am_filter_all_categories': 'All Categories',
  'am_filter_all_status': 'All Status',
  'am_status_active': 'Normal',
  'am_status_low_stock': 'Low Stock',
  'am_status_out_of_stock': 'Out of Stock',
  'am_status_expiring_soon': 'Expiring Soon',
  'am_status_expired': 'Expired',
  'am_action_add': 'Add Material',
  'am_action_batch_delete': 'Batch Delete',
  'am_action_import': 'Import',
  'am_action_export': 'Export',
  'am_action_edit': 'Edit',
  'am_action_delete': 'Delete',
  'am_action_view': 'View',
  'am_action_purchase': 'Purchase',
  'am_stat_total_materials': 'Total Materials',
  'am_stat_normal_stock': 'Normal Stock',
  'am_stat_low_stock_count': 'Low Stock',
  'am_stat_out_of_stock_count': 'Out of Stock',
  'am_column_material_info': 'Material Info',
  'am_column_price_stock': 'Price/Stock',
  'am_column_status': 'Status',
  'am_table_stock': 'Stock',
  'am_table_min_stock': 'Min Stock',
  'am_pagination_showing': 'Showing {start} to {end} of {total} records',
  'am_pagination_prev': 'Previous',
  'am_pagination_next': 'Next',
  'am_confirm_delete': 'Are you sure to delete this material?',
  'am_confirm_batch_delete': 'Are you sure to delete {count} selected materials?',
  'am_msg_select_items': 'Please select materials to delete',
  'am_msg_import_success': 'Successfully imported {count} materials',
  'am_msg_import_failed': 'Import failed, please check file format',
  'am_msg_delete_success': 'Deleted successfully',
  'am_msg_update_success': 'Updated successfully',
  'am_msg_create_success': 'Created successfully',
  'am_tab_inventory': 'Inventory',
  'am_tab_purchase': 'Purchase',
  'am_tab_usage': 'Usage Records',

    // Growth cycle page i18n (page specific)
    'growth_page_title': 'Growth Cycle',
    'growth_page_subtitle': 'Growth records, health score and stage distribution',

    'growth_stat_total_records': 'Total Records',
    'growth_stat_avg_health': 'Average Health Score',
    'growth_stat_active_crops': 'Active Crops',
    'growth_stat_today_records': "Today's Records",
    'growth_unit_record': ' record',
    'growth_unit_score': ' score',
    'growth_unit_crop': ' crops',
    'growth_unit_cm': 'cm',

    'growth_filter_crop_label': 'Crop',
    'growth_filter_crop_all': 'All Crops',
    'growth_filter_date_range': 'Date Range',

    'growth_action_add_record': 'Add Record',
    'growth_action_view': 'View',
    'growth_action_edit': 'Edit',
    'growth_action_delete': 'Delete',

    'growth_chart_title': 'Growth Trend',
    'growth_chart_height': 'Height',
    'growth_chart_leaf_age': 'Leaf Age',

    'growth_health_distribution_title': 'Health Distribution',
    'growth_health_excellent': 'Excellent',
    'growth_health_good': 'Good',
    'growth_health_normal': 'Average',
    'growth_health_poor': 'Poor',

    'growth_timeline_title': 'Growth Timeline',
    'growth_stage_description': '{stage} description',
    'growth_stage_duration': 'Duration: {days} days',

    'growth_table_title': 'Growth Records',
    'growth_pagination_total': 'Showing {start}-{end} of {total} items',

    'growth_modal_view_title': 'Growth Record Details',
    'growth_modal_edit_title': 'Edit Growth Record',
    'growth_modal_add_title': 'Add Growth Record',

    'growth_column_crop': 'Crop',
    'growth_column_land': 'Land',
    'growth_column_stage': 'Stage',
    'growth_column_leaf_age': 'Leaf Age',
    'growth_column_height': 'Height',
    'growth_column_stem_diameter': 'Stem Diameter',
    'growth_column_leaf_count': 'Leaf Count',
    'growth_column_health_score': 'Health Score',
    'growth_column_record_date': 'Record Date',
    'growth_column_operator': 'Operator',
    'growth_column_notes': 'Notes',
    'growth_column_actions': 'Actions',

    'growth_field_crop': 'Crop',
    'growth_field_land': 'Land',
    'growth_field_stage': 'Stage',
    'growth_field_record_date': 'Record Date',
    'growth_field_leaf_age': 'Leaf Age',
    'growth_field_height': 'Height',
    'growth_field_stem_diameter': 'Stem Diameter',
    'growth_field_leaf_count': 'Leaf Count',
    'growth_field_health_score': 'Health Score',
    'growth_field_operator': 'Operator',
    'growth_field_notes': 'Notes',

    'growth_rule_crop': 'Please select crop',
    'growth_rule_land': 'Please enter land',
    'growth_rule_stage': 'Please select stage',
    'growth_rule_record_date': 'Please select record date',
    'growth_rule_leaf_age': 'Please enter leaf age',
    'growth_rule_height': 'Please enter height',
    'growth_rule_stem_diameter': 'Please enter stem diameter',
    'growth_rule_leaf_count': 'Please enter leaf count',
    'growth_rule_health_score': 'Please enter health score',
    'growth_rule_operator': 'Please enter operator',

    'growth_placeholder_select_crop': 'Select crop',
    'growth_placeholder_land': 'Enter land',
    'growth_placeholder_select_stage': 'Select stage',
    'growth_placeholder_leaf_age': 'Enter leaf age',
    'growth_placeholder_height': 'Enter height',
    'growth_placeholder_stem_diameter': 'Enter stem diameter',
    'growth_placeholder_leaf_count': 'Enter leaf count',
    'growth_placeholder_health_score': 'Enter health score',
    'growth_placeholder_operator': 'Enter operator',
    'growth_placeholder_notes': 'Enter notes',

    'growth_crop_wheat': 'Wheat',
    'growth_crop_corn': 'Corn',
    'growth_crop_rice': 'Rice',
    'growth_crop_vegetable': 'Vegetable',

    'growth_land_north_wheat': 'North wheat field',
    'growth_land_south_corn': 'South corn field',
    'growth_land_east_vegetable': 'East vegetable field',

    'growth_operator_zhangsan': 'Zhang San',
    'growth_operator_lisi': 'Li Si',
    'growth_operator_wangwu': 'Wang Wu',

    'growth_notes_normal': 'Normal growth',
    'growth_notes_good_tillering': 'Good tillering',
    'growth_notes_strong_stem': 'Strong stem',
    'growth_notes_need_management': 'Needs better management',

    'growth_stage_sowing': 'Sowing',
    'growth_stage_seedling': 'Seedling',
    'growth_stage_tillering': 'Tillering',
    'growth_stage_jointing': 'Jointing',
    'growth_stage_booting': 'Booting',
    'growth_stage_heading': 'Heading',
    'growth_stage_filling': 'Filling',
    'growth_stage_maturity': 'Maturity',
    'growth_stage_tasseling': 'Tasseling',
    'growth_stage_flowering': 'Flowering',
    'growth_stage_growth': 'Growth',
    'growth_stage_fruiting': 'Fruiting',

    'growth_delete_success': 'Deleted successfully',
    'growth_edit_success': 'Updated successfully',
    'growth_add_success': 'Added successfully',
    'growth_default_operator': 'System',

    // 页面详情国际化
    'page_detail_land_management': 'Land Management',
    'page_detail_growth_cycle': 'Growth Cycle',
    'page_detail_growth_budget': 'Growth Budget',
    'page_detail_warning_analysis': 'Warning Analysis',
    'page_detail_expert_advice': 'Expert Advice',
    'page_detail_seasonal_guidance': 'Seasonal Guidance',
    'page_detail_materials_info': 'Materials Info',
    'page_detail_materials_management': 'Materials Management',
    'page_detail_field_operations': 'Field Work Overview',
    'page_detail_operation_tasks': 'Operation Tasks',
    'page_detail_planting_planning': 'Planting Plan (Future)',
    'page_detail_sales_statistics': 'Sales Statistics',
    'page_detail_data_analysis': 'Data Analysis',
    'page_detail_environment_monitoring': 'Soil Moisture',
    'page_detail_network_trends': 'Network Trends',
    'page_detail_asset_info': 'Asset Info',
    'page_detail_asset_management': 'Asset Management',
    
    // 页面标题和描述国际化
    'page_title_planted_crops': 'Planting Plan',
    'page_desc_planted_crops': 'Planting plan display, growth dynamics, prediction, seasonal guidance',
    'btn_add_planting_plan': 'Add Planting Plan',
    'modal_edit_planting_plan': 'Edit Planting Plan',
    'pp_select_crop': 'Select Crop',
    'pp_select_crop_placeholder': 'Please select a crop',
    'pp_select_land': 'Select Land',
    'pp_select_land_placeholder': 'Please select a land plot',
    'pp_plan_area': 'Planned Area (mu)',
    'pp_plan_name': 'Plan Name',
    'pp_plan_name_placeholder': 'Auto-generated, editable',
    'pp_start_date': 'Plan Start Date',
    'pp_leader': 'Leader',
    'pp_leader_placeholder': 'Enter leader name',
    'pp_priority': 'Priority',
    'pp_priority_high': 'High',
    'pp_priority_medium': 'Medium',
    'pp_priority_low': 'Low',
    'pp_stage_plan': 'Stage Plan',
    'pp_stage_order': 'Order',
    'pp_stage_name': 'Stage Name',
    'pp_stage_days': 'Est. Days',
    'pp_stage_date_range': 'Date Range',
    'pp_stage_measures': 'Suggested Measures',
    'pp_stage_notes': 'Notes',
    'pp_total_cycle': 'Total Cycle',
    'pp_expected_harvest': 'Expected Harvest',
    'pp_land_info': 'Land Info',
    'pp_soil_type': 'Soil Type',
    'pp_irrigation': 'Irrigation',
    'pp_estimated_yield': 'Est. Yield (kg)',
    'pp_estimated_cost': 'Est. Cost (CNY)',
    'pp_remark': 'Remark',
    'pp_remark_placeholder': 'Enter remark',
    'pp_no_stage_hint': 'Please select a crop to load growth stage model',
    'pp_empty_hint': 'No planting plan data',
    'pp_empty_add_hint': 'Click "Add Planting Plan" to create a crop lifecycle plan',
    'pp_day_unit': 'days',
    'pp_plan_detail': 'Planting Plan Detail',
    'pp_crop_info': 'Crop Information',
    'pp_crop_category': 'Crop Category',
    'pp_cat_grain': 'Grain Crop',
    'pp_cat_economic': 'Cash Crop',
    'pp_cat_vegetable': 'Vegetable Crop',
    'pp_temp_range': 'Suitable Accumulated Temperature',
    'pp_precip_range': 'Suitable Precipitation',
    'pp_stage_overview': 'Growth Stage Overview',
    'pp_stage_description': 'Stage Description',
    'pp_no_stage_desc': 'No detailed stage information available',
    'pp_stage_notes_placeholder': 'Optional notes',
    'pp_suitable_temp': 'Suitable Temperature',
    'pp_suitable_humidity': 'Suitable Humidity',
    'pp_stage_duration': 'Stage Duration',
    'pp_land_area': 'Land Area',
    'pp_land_location': 'Location',
    'pp_land_type': 'Land Type',
    'pp_land_manager': 'Land Manager',
    'pp_soil_ph': 'Soil pH',
    'pp_ph_normal': 'Normal',
    'pp_ph_acidic': 'Acidic',
    'pp_ph_alkaline': 'Alkaline',
    'pp_drainage': 'Drainage Condition',
    'pp_area_unit': 'mu',
    'pp_current_crop': 'Current Crop',
    'pp_in_use': 'In Use',
    'pp_land_planting_date': 'Current Planting Date',
    'pp_land_harvest_date': 'Expected Harvest Date',
    'page_title_agricultural_materials': 'Agricultural Materials',
    'page_desc_agricultural_materials': 'Pesticides, fertilizers, seeds and other agricultural materials management, alarm when shortage',
    'page_title_field_management': 'Field Work Management',
    'page_desc_field_management': 'Field work plans, task execution, environment monitoring and warnings',
    'page_title_warning_management': 'Warning Management',
    'page_desc_warning_management': 'Warning rules, manual trigger and record handling',
    'page_title_data_statistics': 'Data Statistics',
    'page_desc_data_statistics': 'Sales statistics, data analysis statistics',
    'page_title_asset_management': 'Asset Management',
    'page_desc_asset_management': 'Asset information management',
    'page_title_my_farm': 'My Farm',
    'page_desc_my_farm': 'A farm consists of multiple plots; manage farm info and plot assignment',
    'my_farm_feature_hub_title': 'Farm features',
    'my_farm_feature_hub_subtitle': 'Open farm-related sub-features from here (same level as the farm list, one extra step).',
    'my_farm_nav_manage_desc': 'Manage farm-land relations, assignments and base information.',
    'my_farm_page_subtitle': 'Carrier layer: farms, plots, devices, irrigation and environment monitoring. Use shortcuts above for crop processes and business analytics.',
    'my_farm_group_carrier': 'Carrier core',
    'my_farm_group_land_archives': 'Plot archives & monitoring',
    'my_farm_group_shortcuts': 'Go to production management',
    'my_farm_shortcut_production_hub': 'Production Hub',
    'my_farm_shortcut_planting': 'Planting plans',
    'my_farm_shortcut_field_work_hub': 'Field work & tasks',
    'my_farm_shortcut_pest': 'Pest control',
    'my_farm_shortcut_scheme': 'AI scheme center',
    'my_farm_shortcut_business': 'Business analytics',
    'my_farm_data_section_title': 'Farm data',
    'my_farm_feature_enter': 'Open',
    'page_title_smart_irrigation_hub': 'Smart Irrigation & Monitoring',
    'page_desc_smart_irrigation_hub': 'Gateway status, emergency stop/resume, irrigation stats and land list (sensor-first; closed-loop execution by on-site gateway).',
    'sih_detail_gateway': 'Device gateway status',
    'sih_detail_emergency': 'Emergency stop / resume automation',
    'sih_detail_logs': 'Audit trail',
    'sih_gateway_card_title': 'Irrigation gateway (middleware)',
    'sih_adapter_type': 'Adapter type',
    'sih_device_connected': 'Device link',
    'sih_emergency_stop': 'Emergency stop',
    'sih_emergency_on': 'ON — no auto irrigation commands',
    'sih_emergency_off': 'OFF — automation allowed',
    'sih_btn_emergency_abort': 'Emergency stop',
    'sih_btn_resume': 'Resume',
    'sih_yes': 'Connected',
    'sih_no': 'Not connected',
    'sih_irrigation_overview': 'Irrigation overview',
    'sih_stat_total_plans': 'Total plans',
    'sih_stat_farms': 'Farms',
    'sih_stat_planned': 'Planned',
    'sih_stat_in_progress': 'In progress',
    'sih_stat_completed': 'Completed',
    'sih_quick_links': 'Quick links',
    'sih_land_list_title': 'Lands (environment monitoring)',
    'sih_land_empty': 'No land data yet',
    'sih_col_land_name': 'Land name',
    'sih_col_land_id': 'Land ID',
    'sih_event_log_title': 'Gateway event log',
    'sih_event_empty': 'No events',
    'sih_col_time': 'Time',
    'sih_col_type': 'Type',
    'sih_col_operator': 'Operator',
    'sih_col_note': 'Note',
    'sih_event_abort': 'Emergency stop',
    'sih_event_resume': 'Resume automation',
    'sih_confirm_emergency_abort_title': 'Confirm emergency stop?',
    'sih_confirm_emergency_abort_content': 'This records the event and sets emergency stop; the field gateway must halt auto irrigation.',
    'sih_confirm_abort_ok': 'Stop',
    'sih_confirm_resume_title': 'Clear emergency stop?',
    'sih_confirm_resume_content': 'Automation will be allowed again. Ensure the field is safe.',
    'sih_msg_load_failed': 'Failed to load smart irrigation data',
    'sih_msg_abort_ok': 'Emergency stop applied',
    'sih_msg_resume_ok': 'Emergency stop cleared',
    'sih_msg_operation_failed': 'Operation failed',
    'sih_back_to_my_farm': 'Back to My Farm',
    'sih_under_my_farm_hint': 'Opened from My Farm → Farm features.',
    'detail_farm_list': 'Farm list',
    'detail_farm_plots': 'Multiple plots',
    'detail_farm_assign': 'Plot assignment',
    'detail_farm_management': 'Plot management',
    'my_farm_msg_fetch_farms_failed': 'Failed to fetch farms',
    'my_farm_msg_fetch_plots_failed': 'Failed to fetch plots',
    'my_farm_msg_enter_name': 'Please enter farm name',
    'my_farm_msg_enter_person': 'Please enter person in charge',
    'my_farm_msg_update_success': 'Updated successfully',
    'my_farm_msg_create_success': 'Created successfully',
    'my_farm_msg_operation_failed': 'Operation failed',
    'my_farm_msg_invalid_item': 'Cannot delete this item',
    'my_farm_msg_delete_failed': 'Delete failed',
    'my_farm_msg_delete_success': 'Deleted successfully',
    'my_farm_msg_assign_success': 'Assignment updated successfully',
    'my_farm_msg_update_failed': 'Update failed',
    'my_farm_plot_count': '{count} plots',
    'my_farm_area_mu': '{area} mu',
    'my_farm_plot_list': 'Plot List ({count})',
    'my_farm_no_plots': 'No plots',
    'my_farm_change_assignment': 'Change Assignment',
    'my_farm_manage_plots': 'Farm management',
    'my_farm_btn_parcel_management': 'Parcel management',
    'my_farm_land_resources': 'Land resources',
    'my_farm_land_resources_tooltip': 'Land resources and crop binding (may differ from parcel archive via Farm management; open detail for stage sample images)',
    'my_farm_land_hub_tooltip': 'Open parcel management: parcel list and survey',
    'land_hub_back_parent': 'Back',
    'land_hub_title': 'Land management',
    'land_hub_center_title': 'Land management',
    'land_hub_subtitle': 'Plot survey & archive; planting plans and stage images are on parcel detail → Planting plan tab',
    'land_hub_entry_resources': 'Land resources',
    'land_hub_entry_survey': 'Parcel management center',
    'land_hub_desc_resources': 'Crop binding, planting status, stage sample images (land resources data)',
    'land_hub_desc_survey': 'Plot archive, boundary survey, and map maintenance',
    'land_hub_enter': 'Open',
    'land_hub_back': 'Back to land management',
    'land_hub_current_resources': 'Current: land resources',
    'land_hub_current_survey': 'Current: parcel management center',
    'land_hub_go_survey': 'Go to parcel management center',
    'land_hub_go_resources': 'Go to land resources',
    'land_hub_features_title': 'Features',
    'land_hub_highlights_title': 'Highlights',
    'land_hub_btn_resources': 'Open land resources',
    'land_hub_btn_survey': 'Open parcel management center',
    'land_hub_redirecting_tip': 'Opening parcel management center…',
    'land_hub_res_feat_1': 'Maintain land resource and planting fields; list and detail views',
    'land_hub_res_feat_2': 'Detail shows crop stage sample images when available; otherwise bionic SVG',
    'land_hub_res_feat_3': 'Merged into plot survey; legacy entry redirects to parcel list',
    'land_hub_survey_feat_1': 'Plot ledger: name, code, farm, status, etc.',
    'land_hub_survey_feat_2': 'Survey & geometry: boundary, area, draw status',
    'land_hub_survey_feat_3': 'Open map pages to view or edit boundaries',
    'land_hub_res_tag1': 'Crop binding',
    'land_hub_res_tag1_d': 'Planting & status',
    'land_hub_res_tag2': 'Stage images',
    'land_hub_res_tag2_d': 'In detail',
    'land_hub_res_tag3': 'Resource list',
    'land_hub_res_tag3_d': 'Search & edit',
    'land_hub_survey_tag1': 'Plot archive',
    'land_hub_survey_tag1_d': 'Asset ledger',
    'land_hub_survey_tag2': 'Survey',
    'land_hub_survey_tag2_d': 'Boundary & area',
    'land_hub_survey_tag3': 'Map',
    'land_hub_survey_tag3_d': 'View & edit',
    'my_farm_create': 'Create Farm',
    'my_farm_empty': 'No farms yet, click "Create Farm" to add one',
    'my_farm_edit': 'Edit Farm',
    'my_farm_name': 'Farm Name',
    'my_farm_name_placeholder': 'e.g. East Farm',
    'my_farm_person_in_charge': 'Person in charge',
    'my_farm_person_in_charge_placeholder': 'Enter name of person in charge',
    'my_farm_description': 'Description',
    'my_farm_description_placeholder': 'Brief description of the farm',
    'my_farm_location': 'Location (Province / City / District)',
    'my_farm_location_placeholder': 'Please select province, city and district',
    'my_farm_selected_location': 'Selected: ',
    'my_farm_legacy_location_hint': 'This is a legacy location. Please reselect from cascader to update: ',
    'my_farm_delete_confirm_title': 'Confirm Delete',
    'my_farm_delete_confirm_content': 'Delete farm "{name}"? Its plots will become unassigned.',
    'my_farm_assign_modal_title': 'Change Plot Assignment',
    'my_farm_plot_label': 'Plot: ',
    'my_farm_assign_farm': 'Assigned Farm',
    'my_farm_unassigned': 'Unassigned',
    'my_farm_search_placeholder': 'Enter farm name, description, location, or person in charge',
    'my_farm_empty_search': 'No matching farms found',
    'my_farm_stat_count_label': 'Count',
    'my_farm_create_plot': 'New plot',
    'my_farm_plot_name': 'Plot name',
    'my_farm_plot_area_mu': 'Area (mu)',
    'my_farm_plot_name_ph': 'Enter plot name',
    'my_farm_plot_notes': 'Notes',
    'my_farm_msg_plot_name_required': 'Please enter plot name',
    'my_farm_msg_plot_area_required': 'Please enter area',
    'my_farm_msg_create_plot_success': 'Plot created',
    'my_farm_msg_create_plot_failed': 'Failed to create plot',
    'my_farm_plot_current_crop': 'Current crop',
    'my_farm_plot_no_crop': '—',
    // 页面详情标题国际化
    'page_details_title': 'Page Details',

    // My Plant Protection - Crop Cards
    'planting_area': 'Planting Area',
    'growth_days': 'Growth Days',
    'growth_stage': 'Growth Stage',
    'management_measures': 'Management Measures',
    'edit': 'Edit',
    'hub_edit_planting': 'Edit planting',
    'hub_edit_planting_title': 'Go to planted crops and planting plans',
    'hub_crop_warning_pest_title': 'View crop warning analysis',
    'hub_crop_warning_weather_title': 'View field work warning management',
    'edit_measures_title': 'Click to edit management measures',
    'pest_prevention_warning': 'Pest Prevention Warning',
    'weather_warning': 'Weather Warning',
    'growth_environment': 'Growth Environment',
    'healthy_degree': 'Health Degree',
    'environment_desc': 'Fertile soil, suitable climate, sufficient irrigation, adequate sunlight',
    'more_plots_hidden': '{count} more plots not displayed',
    'view_all_plots': 'View all plots',
    'unknown_crop': 'Unknown Crop',
    'unknown_plot': 'Unknown Plot',
    'in_progress': 'In Progress',
    'mu_unit': 'Mu',
    'days_unit': 'Days',
    
    // My Plant Protection - Growth Stages
    'stage_seeding': 'Seeding',
    'stage_emergence': 'Emergence',
    'stage_seedling': 'Seedling',
    'stage_tillering': 'Tillering',
    'stage_jointing': 'Jointing',
    'stage_heading': 'Heading',
    'stage_flowering': 'Flowering',
    'stage_filling': 'Filling',
    'stage_mature': 'Mature',
    // My Plant Protection - Detail Pages
    'detail_land_management': 'Land Management',
    'detail_growth_cycle': 'Growth Cycle',
    'detail_growth_budget': 'Growth Budget',
    'detail_warning_analysis': 'Warning Analysis',
    'detail_warning_management': 'Warning Management',
    'detail_expert_advice': 'Expert Advice',
    'detail_seasonal_guidance': 'Seasonal Guidance',
    'detail_materials_info': 'Materials Info',
    'detail_materials_management': 'Materials Management',
    'detail_field_operations': 'Field Work Overview',
    'detail_operation_tasks': 'Operation Tasks',
    'detail_planting_planning': 'Planting Plan (Future)',
    'detail_sales_statistics': 'Sales Statistics',
    'detail_data_analysis': 'Data Analysis',
    'detail_environment_monitoring': 'Soil Moisture',
    'detail_trend_analysis': 'Trend Analysis',
    'detail_network_trends': 'Network Trends',
    'detail_asset_info': 'Asset Info',
    'detail_asset_management': 'Asset Management',
    
    // Error Messages
    'fetch_data_failed': 'Failed to fetch planting data',
    'fetch_data_retry': 'Failed to fetch planting data, please try again',

    // Research Progress
    'research_progress': 'Research Progress',
    'research_progress_desc': 'Stay updated with the latest scientific achievements, technological breakthroughs, and development trends in plant protection',
    'search_research': 'Search research progress...',
    'research_institution': 'Research Institution',
    // Research Fields
    'all_fields': 'All Fields',
    'biocontrol': 'Biological Control',
    'pesticide_research': 'Pesticide R&D',
    'monitoring_tech': 'Monitoring Technology',
    'equipment_tech': 'Equipment Technology',
    'genetics_breeding': 'Genetics & Breeding',
    // Research Institutions
    'all_institutions': 'All Institutions',
    'caas': 'CAAS',
    'universities': 'Universities',
    'research_institutes': 'Research Institutes',
    'enterprise_rd': 'Enterprise R&D',
    // Research Status
    'completed': 'Completed',
    'ongoing': 'Ongoing',
    'planned': 'Planned',
    
    // Research Content
    'key_findings': 'Key Findings',
    'applications': 'Applications',
    'research_impact': 'Research Impact',
    'research_team': 'Research Team',
    'publish_date': 'Publish Date',
    'views': 'Views',
    'view_details': 'View Details',
    'bookmark': 'Bookmark',
    'share': 'Share',
    
    // Research Examples
    'biotech_breakthrough_title': 'Major Breakthrough in Biological Pesticide for Rice Blast Control',
    'biotech_breakthrough_summary': 'Research team developed new biological pesticide effectively controlling rice blast while reducing chemical pesticide use',
    'smart_monitoring_title': 'Smart Plant Protection Monitoring System Successfully Developed',
    'smart_monitoring_summary': 'AI-based intelligent monitoring system achieves automatic pest and disease identification and early warning',
    'slow_release_title': 'Breakthrough in Slow-Release Pesticide Formulation Technology',
    'slow_release_summary': 'Newly developed slow-release pesticide formulation extends efficacy and reduces application frequency',
    'uav_precision_title': 'Research on Precision Application Technology for Plant Protection UAVs',
    'uav_precision_summary': 'Enterprise R&D team makes important progress in precision application technology for plant protection drones',
    // Knowledge Base
    'knowledge_base': 'Knowledge Base',
    'all_categories': 'All Categories',
    'all_subcategories': 'All Subcategories',
    'pest_disease_knowledge': 'Pest & Disease Knowledge',
    'planting_skills': 'Planting Skills',
    'agricultural_technology': 'Agricultural Technology',
    'soil_management': 'Soil Management',
    'fertilizer_use': 'Fertilizer Use',
    'irrigation_technology': 'Irrigation Technology',
    'disease_identification': 'Disease Identification',
    'pest_control': 'Pest Control',
    'prevention_measures': 'Prevention Measures',
    'treatment_methods': 'Treatment Methods',
    'seeding_technology': 'Seeding Technology',
    'seedling_technology': 'Seedling Technology',
    'transplanting_technology': 'Transplanting Technology',
    'pruning_technology': 'Pruning Technology',
    'organic_agriculture': 'Organic Agriculture',
    'precision_agriculture': 'Precision Agriculture',
    'smart_agriculture': 'Smart Agriculture',
    'ecological_agriculture': 'Ecological Agriculture',
    'search_knowledge': 'Search knowledge...',
    'reset_filter': 'Reset Filter',
    'create_article': 'Create Article',
    'article_title': 'Article Title',
    'article_summary': 'Article Summary',
    'article_content': 'Article Content',
    'article_category': 'Article Category',
    'article_subcategory': 'Subcategory',
    'article_tags': 'Tags',
    'cover_image': 'Cover Image',
    'upload_cover': 'Upload Cover',
    'submitting': 'Submitting...',
    'article_created': 'Article created successfully!',
    'like': 'Like',
    'favorite': 'Favorite',
    'comment': 'Comment',
    'link_copied': 'Article link copied to clipboard',
    'featured_articles': 'Featured Articles',
    'category_statistics': 'Category Statistics',
    'related_articles': 'Related Articles',
    'search_articles': 'Search articles...',
    'clear_search': 'Clear search',
    'category_filter': 'Category Filter',
    'main_category': 'Main Category',
    'subcategory': 'Subcategory',
    'sort_by': 'Sort By',
    'sort_by_time': 'By Time',
    'sort_by_views': 'By Views',
    'sort_by_likes': 'By Likes',
    'publish_article': 'Publish Article',
    'enter_title': 'Please enter title',
    'enter_summary': 'Please enter summary',
    'enter_content': 'Please enter content',
    'enter_tags': 'Please enter tags, separated by commas',
    'select_category': 'Please select category',
    'publish': 'Publish',
    'no_articles': 'No articles',
    'showing_results': 'Showing {start} - {end} of {total}',
    'previous_page': 'Previous',
    'next_page': 'Next',
    'by_comments': 'By Comments',
    'title_preview': 'Title: {title}',
    'enter_article_title': 'Please enter article title',
    'select_main_category': 'Please select main category',
    'select_subcategory': 'Please select subcategory',
    'enter_article_content': 'Please enter article content, rich text supported...',

    // ====== Breadcrumb i18n ======
    'breadcrumb_planting_asset': 'Planting Asset Management',
    'breadcrumb_production_planning': 'Production Planning',
    'breadcrumb_field_management': 'Field Management',
    'breadcrumb_economic_statistics': 'Economic Statistics',
    'breadcrumb_disease_warning': 'Disease Warning',
    'breadcrumb_data_dashboard': 'Data Dashboard',
    'breadcrumb_planning_statistics': 'Planning Statistics',
    'breadcrumb_sowing_management': 'Sowing Management',
    'breadcrumb_fertilization_management': 'Fertilization Management',
    'breadcrumb_irrigation_management': 'Irrigation Management',
    'breadcrumb_weeding_management': 'Weeding Management',
    'breadcrumb_pest_control_management': 'Pest Control Management',
    'breadcrumb_inspection_management': 'Field Inspection',
    'breadcrumb_employee': 'Employee Management',
    'breadcrumb_data_crawling': 'Data Crawling Config',
    'breadcrumb_opinion': 'Public Opinion',
    'breadcrumb_pest_disease': 'Pest & Disease Data',
    'breadcrumb_weather': 'Weather Disaster Warning',
    'breadcrumb_trends': 'Trend Analysis',
    'breadcrumb_prevention': 'Local Prevention Advice',
    'breadcrumb_analytics': 'Data Analytics Report',
    'breadcrumb_global': 'Global Monitoring',
    'breadcrumb_weather_data': 'Weather Data Collection',
    'breadcrumb_warning': 'Disaster Warning',
    'breadcrumb_weather_trends': 'Trend Analysis',
    'breadcrumb_weather_history': 'Historical Data Analysis',
    'breadcrumb_climate': 'Local Climate Analysis',
    'breadcrumb_soil': 'Soil Analysis',
    'breadcrumb_water': 'Water Resources Analysis',
    'breadcrumb_advice': 'Planting Advice',
    'breadcrumb_planting_planning': 'Planting Plan (Future)',
    'breadcrumb_land': 'Land Management',
    'breadcrumb_output_statistics': 'Output Statistics',
    'breadcrumb_performance_tracking': 'Performance Tracking',
    'breadcrumb_planting_plan': 'Planting Plan',
    'breadcrumb_organization_management': 'Organization Management',
    'breadcrumb_department_management': 'Department Management',
    'breadcrumb_user_management': 'User Management',
    'breadcrumb_role_management': 'Role Management',
    'breadcrumb_permission_management': 'Permission Management',
    'breadcrumb_tenant_management': 'Tenant Management',
    'breadcrumb_operation_log': 'Operation Log',
    'breadcrumb_role_permission_management': 'Role Permission Management',
    'breadcrumb_page_permission_management': 'Page Permissions',
    'breadcrumb_user_role_management': 'User Role Management',
    'breadcrumb_account_settings': 'Account Settings',
    'breadcrumb_mall_management': 'Mall Management',

    // System Settings related translation keys
    'nav_login_security_settings': 'Login Security Settings',
    'nav_sms_settings': 'SMS Settings',
    'nav_alipay_login_settings': 'Alipay Login Settings',
    'nav_wechat_login_settings': 'WeChat Login Settings',

    // Mall Management related translation keys
    'nav_product_management': 'Product Management',
    'nav_order_management': 'Order Management',
    'nav_customer_management': 'Customer Management',
    'nav_inventory_management': 'Inventory Management',

    'nav_payment_management': 'Payment Management',
    'nav_logistics_management': 'Logistics Management',
    'nav_network_data': 'Network Data',
    'nav_employee': 'Employee Management',
  }
};

// 获取当前语言：固定中文
export const getCurrentLanguage = () => 'zh-CN';

// 设置当前语言（入口已隐藏，始终写入中文）
export const setCurrentLanguage = () => {
  localStorage.setItem('language', 'zh-CN');
};

// 获取翻译文本：固定使用中文
export const t = (key, params = {}) => {
  const lang = 'zh-CN';
  let text = (translations[lang] && translations[lang][key])
    || key;

  if (params && typeof params === 'object') {
    Object.keys(params).forEach(paramKey => {
      const regex = new RegExp(`\{${paramKey}\}`, 'g');
      text = text.replace(regex, params[paramKey]);
    });
  }

  return text;
};

// 切换语言
export const changeLanguage = (language) => {
  localStorage.setItem('language', language);
  window.location.reload();
};

// 翻译版本号 - 用于强制浏览器刷新缓存
export const I18N_VERSION = '2025-11-05-v2';

export default translations; 